import React from "react";

import * as SC from "./LondonMap.styles.jsx";

export default function LondonMap({ userLocation, setUserLocation }) {
  function locateUser(event) {
    let newLocation = event.target.getAttribute("borough");
    setUserLocation(newLocation);
    window.localStorage.setItem("location", newLocation);
  }

  return (
    <SC.SVG>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity="1"
        strokeWidth="3.5"
        className={"Havering" === userLocation ? "clicked" : null}
        onClick={locateUser}
        borough="Havering"
        alt="Havering"
        id="havering"
        title="Havering"
        d="M1431.097,379.954c-0.5-1.101-1-2.301-1.501-3.502c-1.901-4.503-3.802-9.206-7.204-11.607
            c-1.101-0.8-2.401-1.601-3.702-2.401c-4.203-2.602-8.905-5.604-11.708-10.006c-2.101-3.402-2.701-7.705-3.201-11.807
            c-0.301-2.702-0.701-5.303-1.401-7.505c-4.002-0.6-8.905,0.2-13.508,1c-2.302,0.4-4.403,0.801-6.404,1.001
            c-6.704,0.6-14.009,0.8-21.213,0.4h-0.601l-0.101-0.601c-1.101-6.404-2.602-15.109-5.403-20.813c-0.6-1.301-1.2-2.501-1.801-3.602
            c-1.501-3.002-2.902-5.804-4.503-9.106c-0.4-0.8-0.801-1.901-1.101-3.002c-0.9-2.602-2.001-5.803-3.803-6.604l-0.4-0.2v-0.4
            c-0.3-2.702-2.802-5.203-4.902-7.404c-0.701-0.701-1.301-1.301-1.901-2.001c-3.402-3.902-5.203-6.904-7.505-11.307
            c-2.302-4.502-3.803-7.504-4.103-13.208c-0.1-1.301,0.101-3.202,0.2-5.503c0.4-4.403,0.9-10.407-1.001-12.007l-0.2-0.2
            c-0.8-1.501-13.608-1.801-17.811-1.801c-1.802,0-3.303-0.1-4.103-0.1h-0.601v-0.6c-0.3-3.302,0.2-5.204,1.301-8.105
            s3.202-8.305,5.804-10.206c1.501-1.101,3.002-1.401,4.103-1.701c0.5-0.1,1.201-0.3,1.301-0.5c0.101-0.1,0.101-0.7-1.2-2.802
            c-2.302-3.902-6.904-8.405-11.007-12.308c-2.102-2.001-4.103-3.902-5.704-5.704c-4.002-4.402-8.905-7.805-13.608-11.107
            c-1.901-1.301-3.902-2.702-5.903-4.203c-2.201-1.601-4.303-3.302-6.504-5.003c-1.101-0.9-2.302-1.801-3.402-2.702
            c-1.501-1.201-3.902-2.301-6.304-3.602c-5.004-2.502-10.707-5.204-12.008-9.506c-0.301,0-0.601,0.1-0.9,0.1
            c-0.301,0.1-0.701,0.1-1.001,0.1c-0.4,0.2-1.001,0.4-2.001,0.801v0.1c-5.604,1.501-11.107,4.002-16.511,6.404
            c-3.002,1.301-6.104,2.702-9.105,3.902l-0.4,0.2c-3.802,1.501-6.204,2.401-10.606,2.602c-3.902,0.2-7.905,0.3-11.907,0.4
            c-5.504,0.2-11.107,0.3-16.61,0.601c-4.803,0.2-9.006,2.901-13.008,5.503c-4.804,3.002-9.707,6.204-15.71,5.404
            c-2.002-0.3-3.803-0.901-5.403-1.401c-1.901-0.701-3.803-1.301-6.004-1.401c-3.702-0.3-7.604-0.2-11.308-0.2
            c-1.601,0-3.202,0-4.702,0h-23.015c6.504,3.302,11.106,13.108,14.309,21.213c3.202,8.205,7.405,20.713,6.504,34.421
            c-0.3,4.803-1.501,7.104-3.702,9.206l0.101,0.2c0.2,0.601,0.4,1.301,0.9,1.701c0.5,0.5,1.2,0.9,1.901,1.301
            c0.801,0.5,1.601,0.9,2.201,1.601c2.802,2.902,2.802,5.403,2.701,8.905c0,0.601,0,1.201,0,1.901c0,3.202,0.2,6.304,0.301,9.406
            c0.2,4.503,0.4,9.105,0.2,13.809c-0.2,4.203-1.802,7.104-3.402,10.006c-1.701,3.202-3.302,6.104-3.002,10.606
            c0.2,3.202,1.501,6.204,2.802,9.306c1.602,3.703,3.202,7.505,3.002,11.808v0.5l-0.5,0.1c-0.9,0.2-1.101,0.5-1.101,0.5
            c-0.101,1,4.702,3.702,6.704,4.903c1.501,0.901,2.802,1.601,3.602,2.202c1.401,1.101,2.602,2.301,3.803,3.502
            c3.302,3.202,6.104,6.004,10.807,5.403c2.602-0.3,5.104-1.401,7.805-2.602c2.502-1.101,5.203-2.301,7.905-2.702
            c5.203-0.9,14.909-1.401,20.013,0.5l0.5,0.2v0.5c-0.3,4.002-0.2,9.406,0.601,12.408c0.601,2.001,1.901,3.502,3.202,5.104
            c1.2,1.401,2.501,2.902,3.302,4.803c1.401,3.202,3.002,7.305,2.702,11.007c-0.501,7.104-6.004,17.011-10.907,22.714
            c-5.604,6.404-11.007,13.808-15.609,20.113c-2.402,3.302-4.103,7.004-5.704,10.606c-1.801,3.902-3.602,7.905-6.304,11.407
            c-4.202,5.604-5.203,11.207-6.204,17.711c-0.3,1.801-0.6,3.603-1,5.604l-0.601,2.901c-1.301,6.404-2.602,12.408-2.302,18.912
            c2.001,0.601,3.902,1.001,5.804,1.4c4.003,0.801,7.805,1.602,11.607,4.003c6.504,4.103,13.208,9.006,17.812,17.11
            c2.901,5.004,4.302,10.207,5.903,15.61c0.801,2.701,1.601,5.403,2.501,8.205c3.103,8.705,7.104,17.811,15.91,15.71
            c1.301-0.301,2.602-0.701,3.902-1.102c2.902-0.9,5.904-1.9,10.007-1.9l0,0c1.301,0,2.701,0,4.002,0c3.202,0,6.504,0.1,9.706-0.101
            c1.301-4.402,3.803-12.708,8.105-17.211c2.802-2.901,7.204-3.702,11.407-4.603c4.902-1.001,9.605-1.901,11.507-5.703v-0.701
            c-0.1-1.4-1.201-3.702-2.302-6.203c-2.101-4.604-4.503-9.807-2.001-12.508c1.501-1.602,4.903-1.602,8.005-1.701
            c1.201,0,2.401,0,3.103-0.2c0.7-0.101,1.5-0.2,2.401-0.301c3.401-0.399,8.405-1.101,10.406-3.102c1.901-1.901,1.4-3.002,0.5-4.703
            c-0.3-0.7-0.7-1.501-0.9-2.401c-0.601-2.302-0.601-4.903-0.7-7.204c0-0.501,0-1.101-0.101-1.501c-0.1-3.103-0.5-5.304-2.101-8.105
            c-0.4-0.801-1.101-1.601-1.802-2.401c-1.4-1.601-2.901-3.302-2.701-5.403l0.1-0.7h0.7c1.602,0,3.002,0.9,4.303,1.801
            c1.701,1.101,3.303,2.102,5.304,1.601c1.201-0.3,2.201-1.2,2.602-2.301s0.101-2.401-0.9-3.603c-0.4-0.5-1.201-0.801-2.001-1.2
            c-1.301-0.601-2.702-1.201-2.902-2.402c-0.2-1.101,0.601-2.301,2.401-3.802c0.801-0.7,2.002-0.801,3.103-0.9
            c0.6-0.101,1.601-0.2,1.801-0.4c0.5-0.601,0.5-1.001,0.5-1.602c0-0.6-0.1-1.301,0.301-2.201c0.1-0.2,0.3-0.601,0.4-1.001
            c2.001-4.402,3.502-7.304,4.902-7.805c1.301-0.5,2.502-0.5,3.503,0.101c2.401,1.501,2.802,5.804,3.002,7.904
            c0.3,3.002,0.9,6.004,1.4,9.006c0.7,3.603,1.401,7.305,1.601,11.007c0.701,0,1.401,0.101,2.202,0.2
            c5.403,0.5,12.907,1.101,14.509-2.602c0.5-1.2,0.4-2.901,0.2-4.503c-0.2-1.801-0.4-3.802,0.4-5.303
            c0.1-0.301,0.5-0.601,1.301-1.301c2.101-1.901,3.202-3.002,3.002-3.402c0,0-0.301-0.4-2.102-0.301h-0.7l-0.101-0.7
            c-0.8-5.804-0.5-12.908-0.2-17.811c0.4-6.604,4.303-6.505,9.206-6.505c1.701,0,3.502,0,5.604-0.199l2.302-0.2
            c3.602-0.301,6.804-0.601,10.506-1.602c5.104-1.301,11.308-2.401,17.912-3.002c0.5,0,1.101-0.1,1.9-0.1
            c2.002,0,5.604-0.101,6.404-1.101c0.4-0.501,0.4-2.502,0.301-4.003c0-1.401-0.101-2.802,0.199-3.602l0.101-0.5l0.5-0.1
            c8.506-0.9,17.511-2.802,26.116-4.703c10.406-2.302,21.113-4.603,31.82-5.304c0.6-5.003-1.401-8.705-3.603-12.607
            C1432.498,382.655,1431.798,381.354,1431.097,379.954L1431.097,379.954z"
      ></path>
      <text
        onClick={locateUser}
        borough="Havering"
        transform="matrix(1 0 0 1 1204.0107 334.9995)"
        fontSize="27.7821"
      >
        Havering
      </text>
       
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Bexley"
        className={"Bexley" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Bexley"
        d="M1080.178,506.133c0,3.102,0.101,6.203,0.2,9.105c0.101,3.002,0.2,6.204,0.2,9.306c0,3.302,0,6.604,0,10.006
		c0,6.504-0.1,13.309,0,19.914c0.101,5.803,1.602,11.605,3.103,17.209c0.9,3.504,1.801,7.105,2.401,10.707l0.2,1.201l-1.201-0.4
		c-0.9-0.301-1.801-0.699-2.602-1.1c-3.102-1.402-5.203-2.402-7.905,1.301c-1.101,1.5-2.001,3.102-2.901,4.703
		c-1.201,2.201-2.502,4.402-4.303,6.402l-0.4,0.4l-0.5-0.299c-2.002-1.102-2.702-2.602-3.303-3.803
		c-0.7-1.502-1.2-2.502-3.802-2.803c-2.002-0.199-3.702,0.201-5.403,0.701c-1.102,0.301-2.302,0.6-3.503,0.801
		c-1,0.1-2.001,0.1-3.002,0c-2.101-0.1-4.103-0.201-5.203,1.1c-0.2,0.301-0.2,0.602-0.3,1.201c0,0.801-0.1,1.701-0.801,2.502
		c-0.5,0.6-1.501,0.801-2.502,1c-0.7,0.1-1.4,0.301-1.801,0.5c-3.602,2.203-10.206,6.705-14.209,11.709
		c-3.402,4.201-4.502,10.406-5.203,15.908c-0.1,0.602-0.1,1.301-0.1,2.002c0,1.102,0,2.301-0.301,3.303
		c-0.4,1.4-1,2.102-1.601,2.701c-0.4,0.4-0.7,0.801-1.101,1.4c-0.601,1.002-0.801,1.902-0.601,2.402
		c0.301,1,1.802,1.602,3.502,2.301c1.001,0.4,2.002,0.801,3.002,1.4c4.203,2.602,4.703,7.205,5.104,11.709
		c0.2,2.1,0.4,4.201,1.001,6.104l0.4-0.301l0.399,0.9c5.403,11.408-3.202,21.213-9.506,28.418l-0.7,0.801
		c-0.9,1-1.301,2.102-1.801,3.402c-0.501,1.301-1.001,2.602-1.901,3.701c-0.7,0.801-1.802,1.301-3.002,1.803
		c-1.401,0.6-2.901,1.199-3.302,2.301c-0.501,1.301,0,1.602,1,2.4c0.7,0.502,1.501,1.201,2.002,2.303
		c0.7,1.801,0.199,3.602-0.301,5.402c-0.1,0.5-0.3,1.102-0.4,1.602c8.906,1.301,13.809,8.205,18.611,14.91
		c2.702,3.801,5.404,7.703,8.906,10.605c9.806,8.205,24.615,20.613,38.523,20.713h0.301c5.303,0,10.307-1.4,15.109-2.902
		c4.703-1.4,9.605-2.801,14.709-2.801c1.601,0,3.102,0.1,4.703,0.4l0.3,0.1l29.719,19.111c1.801-0.799,2.602-3.002,2.701-4.902
		c0.101-2.701-0.7-3.102-2.401-3.803c-0.801-0.4-1.801-0.801-2.802-1.602c-2.901-2.4-2.201-4.201-1.501-6.104
		c0.301-0.801,0.601-1.6,0.801-2.602l0.2-1.301c0.4-2.801,0.601-3.902,3.402-6.303c0.6-0.5,1.101-0.701,1.4-0.9
		c0.601-0.301,0.801-0.4,0.9-1.803c0.101-1.301-0.2-1.6-0.9-2.201c-0.3-0.299-0.801-0.699-1.2-1.301
		c-1.802-2.5-1.602-3.402-0.801-4.803c0.3-0.6,0.7-1.301,1-2.502c0.4-1.6,0.301-3.801,0.101-5.902c-0.101-1.102-0.2-2.201-0.2-3.203
		c0-3.402,0.9-5.203,1.901-7.504l0.4-0.9c0.2-0.4,0.4-0.9,0.5-1.301c1.301-3.203,2.502-5.904,7.805-3.803
		c1.101,0.4,2.401,1.4,3.702,2.301c1.602,1.201,3.402,2.502,4.604,2.602c0.4-1.301,0.9-2.602,1.4-4.002
		c1.001-2.701,2.002-5.504,2.602-8.404c0.2-1.102,0.4-2.303,0.501-3.604c0.2-2.102,0.399-4.303,1.2-6.203
		c0.301-0.801,0.801-1.301,1.301-1.701c0.4-0.4,0.801-0.801,1.001-1.4c0.3-0.801,0.3-1.701,0.3-2.602c0-0.701,0-1.301,0.101-2.102
		c0.3-1.902,1.901-7.506,3.802-9.006c1.901-1.602,3.703-1.102,5.404-0.602c0.9,0.301,1.9,0.502,3.001,0.502
		c3.402-0.201,6.204-2.502,8.906-4.703l0.5-0.4c0.5-0.4,1.2-0.9,1.901-1.502c1.701-1.301,3.803-2.801,4.803-4.201
		c0.7-1.002,0.801-2.102,1.001-3.203c0.2-1.5,0.3-3.102,2.201-4.402c0.801-0.5,1.501-0.6,2.001-0.6s0.801,0,1.401-0.701
		c0.5-0.5,0.601-1.102,0.8-1.801c0.2-0.701,0.301-1.502,0.901-2.201c1.501-2.002,3.502-2.201,5.403-2.502
		c0.801-0.1,1.601-0.201,2.401-0.4c2.901-0.701,6.004-2.201,8.505-4.002c3.902-2.902,4.203-3.504,3.103-7.406
		c-1.602-6.002,1.4-9.404,4.503-12.906c1-1.201,2.101-2.402,3.102-3.803c1.701-2.402,2.901-4.703,3.102-7.805
		c0-0.602,0-1.201,0-1.803c-0.1-0.9-0.1-1.801,0-2.701c0.2-0.9,0.501-1.5,0.9-2c0.4-0.701,0.701-1.102,0.601-2.203
		c-0.1-1.5-1.2-2.4-2.401-3.4c-1.601-1.301-3.402-2.902-2.401-5.705c0.601-1.701,2.001-2.301,3.002-2.701
		c1.2-0.5,1.801-0.801,1.801-1.9c0-0.801-0.4-1.502-0.7-2.303c-0.5-1-1.001-2-0.601-3.102c0.301-0.9,1.101-1.5,2.401-2.201
		c1.001-0.4,1.901-0.6,2.702-0.801c1.701-0.301,2.802-0.5,3.603-2.801c0.199-0.602,0.1-1.402,0-2.201
		c-0.101-0.801-0.2-1.701,0-2.502c0.199-0.801,0.5-1.502,0.8-2.102c0.301-0.701,0.601-1.201,0.601-1.801
		c-0.1-2.002-3.002-3.902-5.003-4.504c-4.503-1.4-9.706,2.201-13.909,3.502c-5.303,1.602-10.807,2.703-16.31,3.703
		c-13.309,2.402-26.617-2.402-35.423-12.707c-2.201-2.602-4.102-5.705-5.303-8.907c-2.502-6.804-3.102-14.209-4.303-21.313
		c-1.001-5.503-2.702-11.006-5.904-15.709c-6.904-10.207-18.611-8.205-29.018-10.407c-9.605-2.101-17.711-7.604-26.116-12.407
		c-3.102-1.701-6.104-4.203-9.606-4.903c-3.102-0.7-5.703,0.601-8.505,1.602c-1.901,0.7-4.303,1.7-5.003,2.701
		c-1.501,2.001-0.9,8.105-0.5,12.508C1080.078,503.23,1080.178,504.932,1080.178,506.133L1080.178,506.133z"
      ></path>
      <text
        onClick={locateUser}
        borough="Bexley"
        transform="matrix(1 0 0 1 1061.5439 643.1958)"
        fontSize="27.7821"
      >
        Bexley
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Redbridge"
        className={"Redbridge" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Redbridge"
        d="M1003.931,400.566c3.502-0.9,5.903-1.801,9.406-3.602c1.101-0.6,2.501-1.801,3.902-3.002
            c1.901-1.701,3.702-3.202,5.203-3.602c3.902-0.801,5.903,0.4,7.505,1.501c1.7,1.101,3.001,1.901,6.604,0.3
            c4.003-1.801,8.405-5.304,12.908-10.006c0.9-0.901,1.401-1.701,1.901-2.501c0.7-1.101,1.501-2.202,3.102-3.502
            c1.001-0.8,2.102-1.301,3.303-1.801c1.4-0.6,2.802-1.201,3.702-2.201c1.101-1.201,1.501-2.201,1.901-3.302
            c0.4-1.201,0.9-2.401,2.301-3.702c2.201-2.001,3.502-3.002,4.303-3.502c0.301-0.2,0.601-0.4,0.601-0.5s0-0.3,0-0.601
            c0-0.6,0-1.501,0.101-3.001c0.9-9.906,1-10.207,9.005-16.311l0.601-0.5c6.404-4.803,7.104-6.304,7.404-14.209v-0.8
            c0.2-6.004,0.4-11.607,1.301-17.211c0.101-0.601,0.301-1.601,0.601-2.802c0.501-2.101,1.301-5.503,1.101-6.304
            c-0.5-1.901-1.101-2.202-2.001-2.602c-0.601-0.3-1.401-0.7-2.201-1.701c-0.4-0.601-0.801-1.101-1.301-1.601
            c-2.802-3.402-5.104-6.304-2.201-12.508c0.399-0.801,1.4-1.901,2.602-3.202c1-1.101,2.001-2.101,2.602-3.002
            c1.501-2.101,3.002-4.203,4.603-6.304c4.503-5.704,10.106-12.208,17.511-18.011c0.9-0.701,1.701-1.301,2.502-1.901
            c0.9-0.7,1.701-1.301,2.401-1.901l-0.2-0.2c0.101-0.1,0.5-0.601,1.001-0.5c2.001-1.801,2.901-3.802,3.201-8.105
            c0.901-13.508-3.201-25.716-6.403-33.821c-4.103-10.406-10.606-23.915-20.112-21.013c-2.502,0.7-6.004,4.502-9.807,8.605
            c-5.504,5.804-11.607,12.408-17.011,12.408h-0.1c-1.701,0-3.202-0.7-4.503-1.901l-0.801,0.6
            c-6.104,4.303-15.31,10.807-22.914,9.506c-2.702-0.5-5.003-1.901-6.704-4.302c-0.501,0.1-1.101,0.2-1.701,0.3
            c-1.701,0.2-4.103,0.5-4.803,1.301c-1.401,1.601-1.401,2.001-1.401,2.001c0,0.1,0.301,0.3,0.5,0.4
            c0.701,0.5,1.802,1.201,2.002,3.102l0.1,0.601c0.301,2.602,0.4,3.502,0.101,6.404l0,0l-0.601-0.1l0.5,0.3
            c-0.3,0.5-1.701,5.003-1.801,5.604l-0.601-0.1l0.601,0.4v0.1l-0.301,0.5c-3.302,5.203-6.004,6.904-13.308,4.603l-0.701-0.2
            c-6.003-1.901-7.805-2.501-14.709-0.3c-11.507,3.702-21.313,1.301-31.52-7.705c-1.101-1-3.002-2.201-5.003-3.602
            c-3.702-2.501-7.805-5.303-9.206-7.605c-3.302-5.303-0.2-7.305,2.302-8.905c1.701-1.101,3.202-2.001,3.302-3.803
            c-3.502,0-6.904,0.901-10.206,1.801c-7.404,1.901-14.309,3.702-21.813-3.702c-3.302-3.302-5.804-7.405-8.306-11.307
            c-3.201-5.203-6.604-10.606-11.707-14.209l-1.601-0.9c-0.9,1.401-1.802,2.802-2.302,4.403c-0.4,1.201-0.7,2.401-1.101,3.602
            c-2.602,8.605-5.104,16.811-14.209,19.913c7.604,3.202,12.107,7.004,14.109,11.807c2.001,4.603,1.501,10.207-1.302,17.011
            c-4.702,11.207-7.904,22.914-8.805,32.12c-1.501,14.709,2.301,27.917,5.903,40.725c2.502,8.706,5.003,17.811,5.903,27.217
            c0.301,3.302-0.1,7.304-0.5,11.207c-0.2,1.801-0.3,3.502-0.4,5.003v0.601l-0.5,0.1c-2.502,0.6-4.003,1.601-4.703,3.102
            c-1.601,3.603,1.901,9.706,4.703,14.709c0.9,1.601,1.801,3.202,2.401,4.503c7.905,0.1,11.207,1.4,14.309,9.506
            c5.204,0.1,10.607-1.001,16.411-2.202c4.502-0.9,9.205-1.901,13.809-2.201c-0.101-1.901-0.901-4.303-1.802-6.904
            c-1.601-4.703-3.202-9.606-1.301-13.108c0.9-1.701,2.602-3.002,5.104-3.702c5.403-1.501,9.906,4.002,13.208,8.005
            c0.601,0.8,1.2,1.501,1.801,2.102c0.601,0.6,1.101,1.301,1.701,2.001c2.102,2.501,4.103,4.903,7.505,5.804
            c0.9,0.2,2.201,0,3.502-0.1c2.001-0.3,4.003-0.5,5.403,0.4c5.304,3.402,4.203,10.606,3.103,17.511
            c-1.101,7.004-2.102,13.608,2.901,16.31C989.722,404.169,1000.429,401.467,1003.931,400.566L1003.931,400.566z"
      ></path>
      <text
        onClick={locateUser}
        borough="Redbridge"
        transform="matrix(1 0 0 1 916.9287 298.3921)"
        fontSize="27.7821"
      >
        Redbridge
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Enfield"
        className={"Enfield" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Enfield"
        d="M554.351,89.673c2.001,0.3,4.103,0.5,5.903,1.301c0.7,0.3,1.401,0.601,2.102,0.9c2.802,1.301,5.104,2.302,8.605,3.002
		c6.904,1.401,14.209,4.203,22.814,8.906l0.6,0.3c4.003,2.201,5.104,2.802,6.704,7.504c0.301,1,0.701,2.001,1.001,3.002
		c0.9,2.501,1.701,5.203,2.502,7.905c0.3,1.001,0.5,2.001,0.7,2.902c1.701,6.804,2.802,10.907,8.104,16.31
		c0.701,0.701,1.401,1.301,2.002,1.901c1.701,1.601,3.102,2.902,4.603,5.604c2.401,4.503,4.103,5.503,8.305,7.905l0.2,0.1
		c5.504,3.102,15.71,9.006,14.109,17.311c-0.9,4.703-2.302,8.905-3.603,13.008c-1,3.102-2.102,6.304-2.901,9.606
		c-1.101,4.803-4.403,8.605-7.505,12.408c-2.001,2.301-4.003,4.803-5.504,7.404c-2.201,3.902-1,5.403,0.801,7.505
		c0.801,1,1.701,2.001,2.201,3.302c0.9,0,1.901,0,2.902-0.1c3.602-0.1,7.404-0.2,10.606,0.601l0.9,0.2
		c4.203,1.101,8.506,2.301,13.008,2.501c2.502,0.1,5.004,0.3,7.505,0.5c7.604,0.5,15.41,1,23.314,1c4.703,0,9.506,0,14.209,0.1
		c12.107,0.1,24.615,0.2,36.723-0.5c3.303-0.2,6.805-0.5,10.106-0.8c5.403-0.5,10.907-1,16.311-1c7.705,0,15.209,1,22.214,4.603
		c0.9,0.4,1.801,1.001,2.701,1.601c1.901,1.201,3.902,2.501,5.904,2.702c2.802,0.2,5.604-2.101,7.904-4.002l0.801-0.601
		c2.802-2.301,4.403-4.203,3.803-7.304c-0.2-1.101-0.501-1.901-0.9-2.702c-0.601-1.601-1.301-3.002-0.4-5.704
		c1.101-3.502,3.602-6.704,6.004-9.806c1.4-1.801,2.701-3.502,3.702-5.203c1.601-2.702,3.202-5.604,4.702-8.405
		c1.701-3.102,3.503-6.404,5.304-9.306c5.804-9.306,9.506-17.311,11.808-25.315c0.7-2.402,1.501-4.803,2.301-7.004
		c1.602-4.503,3.103-8.706,3.503-13.508c0.4-4.103,0.6-8.405,0.8-12.608l-0.1-0.1h0.1c0.101-2.102,0.101-4.303,0.2-6.404
		c0.101-6.003,0.301-12.107,0.801-17.911c0.2-2.101,0.801-4.403,1.401-6.804c1.101-4.203,2.201-8.505,1.2-12.107
		c-0.3-1.101-0.9-2.102-1.601-3.202c-0.801-1.301-1.701-2.602-2.002-4.203c-0.399-1.801-0.199-3.802-0.1-5.804
		c0.1-1.301,0.2-2.501,0.1-3.602c-0.3-6.504-0.9-13.108-1.601-19.913c-0.1-1.401-0.4-2.802-0.601-4.203
		c-0.7-4.203-1.4-8.605,0.301-12.708c-1.401-0.4-3.503-0.4-5.203-0.5c-0.501,0-1.001,0-1.501,0c-2.302-0.1-4.703-0.1-7.104,0
		c-1.301,0-2.502,0-3.803,0c-5.104,0-8.505-1.201-12.808-2.802c-5.403-2.101-11.308-2.001-17.511-2.001
		c-6.004,0.1-12.309,0.1-18.412,0.2c-3.402,0.1-6.804,0.1-10.206,0.2c-2.001,0-4.103,0.2-6.104,0.3
		c-5.803,0.4-11.307,0.8-16.21-1.901c-2.301-1.301-4.603-2.702-6.904-4.103c-8.104-5.003-16.41-10.106-25.916-10.506
		c-1.301-0.1-2.602-0.1-3.902-0.2c-5.804-0.2-10.907-0.4-16.71-2.001c-2.702-0.7-5.204-1.301-8.506-1.201c-0.3,0-0.7,0-1.2,0
		c-1.101,0-2.902,0-3.503,0.3c-0.7,0.3-1.2,0.9-1.801,1.601c-0.5,0.601-1.001,1.201-1.601,1.601
		c-2.302,1.601-5.104,1.801-7.806,1.901c-1.801,0.1-3.702,0.2-5.303,0.801c-2.702,0.9-4.903,1.401-8.205,1.901l-4.003,0.5
		c-5.303,0.701-10.406,1.401-16.01,2.001c-3.902,0.4-6.204,1.201-9.206,3.001c-0.6,0.4-1.301,0.901-2.001,1.301
		c-2.001,1.401-4.303,3.002-6.504,3.402c-5.104,1-10.406-0.601-15.51-2.201c-4.603-1.401-9.406-2.802-13.809-2.302
		c-0.3,1.501-0.5,3.102-0.801,4.703c-0.6,4.002-1.301,8.205-2.602,11.807c-0.3,0.801-0.5,1.701-0.8,2.502
		c-0.601,2.101-1.201,4.103-2.602,6.204c-0.4,0.601-0.801,1.201-1.201,1.801c-1.101,1.701-2.201,3.302-3.002,5.203
		c-0.3,0.701-0.5,1.401-0.801,2.202c-0.6,2.001-1.301,4.302-3.002,5.403c-0.9,0.6-2.001,0.6-2.901,0.6c-0.601,0-1.201,0-1.601,0.2
		c-1.001,0.4-1.301,0.8-2.002,1.601c-0.2,0.2-0.4,0.5-0.6,0.8c-0.801,0.901-1.501,1.901-2.202,2.902
		c-2.501,3.302-5.103,6.704-8.605,8.605c0.901,2.101-0.1,5.503-1.101,8.706c-0.6,1.901-1.101,3.602-1.101,4.803
		C550.048,89.172,552.149,89.373,554.351,89.673L554.351,89.673z"
      ></path>
      <text
        onClick={locateUser}
        borough="Enfield"
        transform="matrix(1 0 0 1 672.8984 137.6685)"
        fontSize="27.7821"
      >
        Enfield
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Waltham Forest"
        className={"Waltham Forest" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Waltham Forest"
        d="M842.83,140.404c-0.5,5.003-2.102,9.506-3.603,13.909c-0.8,2.202-1.601,4.603-2.301,6.904
		c-2.302,8.105-6.104,16.21-11.907,25.616c-1.802,2.902-3.603,6.204-5.304,9.306c-1.501,2.802-3.102,5.704-4.703,8.405
		c-1.101,1.801-2.401,3.502-3.802,5.303c-2.402,3.002-4.804,6.104-5.804,9.306c-0.701,2.102-0.2,3.202,0.4,4.603
		c0.3,0.801,0.7,1.801,1,3.002c0.801,4.203-1.801,6.704-4.303,8.806l-0.8,0.6c-2.202,1.801-5.204,4.303-8.306,4.403
		c-0.801,7.505-5.104,12.808-9.306,17.911c-5.003,6.104-9.706,11.808-8.306,21.013c0.2,1.301,0.501,2.301,0.801,3.402
		c0.7,2.401,1.401,4.502-0.2,8.105c-1.601,3.502-3.902,6.504-6.004,8.905c-1.801,2.102-3.102,4.803-4.402,7.405
		c-1.401,3.002-2.901,6.104-5.203,8.305c1.301,2.201,2.501,4.603,3.603,6.904c1.601,3.202,3.201,6.504,5.103,9.406
		c2.302,3.402,5.203,5.503,8.306,7.705c1.4,1,2.802,2.001,4.202,3.202c1.201,1,5.304,4.603,6.805,7.605
		c0.6,1.101,0.7,2.401,0.9,3.602c0.2,1.501,0.3,2.902,1.2,3.902c2.902,3.402,10.707,3.002,15.31,2.702l1.001-0.1
		c1.001-0.1,1.801-0.1,2.602-0.2c1.401-0.1,2.702-0.2,3.902-0.2c3.202,0,5.804,0.6,9.807,3.202
		c5.703,3.803,9.506,9.306,12.607,14.109c3.202,5.104,4.003,5.203,7.604,5.804c1.101,0.2,2.502,0.4,4.303,0.8
		c2.602,0.601,4.103,1.501,5.403,2.302c2.201,1.301,3.502,2.101,8.405,0.1c0.7-0.3,1.501-0.701,2.401-1.101
		c3.503-1.701,7.905-3.802,11.107-2.301c1.4,0.701,2.301,2.001,2.802,3.902c5.403,0.701,6.304-1.101,7.604-3.702
		c0.801-1.601,1.701-3.302,3.603-4.903c3.603-2.901,8.405-0.7,10.106-2.401c0.6-0.6,0.9-1.801,0.9-3.602
		c0-0.601-0.301-1.401-0.601-2.202h-0.801v-1.501h0.101c-0.601-1.201-1.301-2.501-2.102-3.802
		c-3.102-5.503-6.704-11.707-4.803-16.01c0.801-1.801,2.501-3.102,5.203-3.802c0.1-1.401,0.2-3.002,0.4-4.503
		c0.4-3.802,0.8-7.805,0.5-10.907c-0.9-9.306-3.402-18.312-5.904-27.017c-3.701-12.908-7.504-26.316-6.003-41.226
		c0.9-9.306,4.202-21.213,8.905-32.521c2.701-6.404,3.102-11.607,1.301-15.81c-2.001-4.803-6.904-8.505-15.31-11.808l-2.201-0.9
		l2.302-0.5c10.006-2.301,12.508-10.606,15.209-19.512c0.4-1.201,0.7-2.401,1.101-3.602c0.801-2.602,2.401-4.703,4.003-6.804
		c1.901-2.501,3.702-4.903,3.902-8.005c0.2-2.401-0.301-3.603-1.101-5.203c-0.4-0.801-0.801-1.701-1.101-2.802
		c-0.2-0.701-0.501-1.101-0.9-1.601c-0.501-0.601-1.102-1.301-1.302-2.802c-0.2-1.201,0.4-2.602,0.901-3.902
		c0.4-0.901,0.9-2.102,0.7-2.502c-1.501-3.302-18.111-4.203-26.017-4.603c-2.201-0.1-4.002-0.2-5.203-0.3
		c-6.004-0.601-10.307-1.801-14.909-3.603c-1.101-0.4-2.001-0.5-2.901-0.7c-1.401-0.2-2.803-0.4-4.503-1.901
		c-1.401-1.101-1.401-2.401-1.501-3.302c-0.101-0.801-0.101-1.401-0.801-2.001c-0.601,1.201-1.4,1.401-2.401,1.501
		c-0.2,0-0.4,0-0.501,0.1C843.431,132.5,843.23,136.502,842.83,140.404L842.83,140.404z"
      ></path>
      <text
        onClick={locateUser}
        borough="Waltham Forest"
        transform="matrix(0.3419 -0.9397 0.9397 0.3419 809.9492 342.9468)"
        fontSize="27.7891"
      >
        Waltham Forest
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Sutton"
        className={"Sutton" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Sutton"
        d="M624.594,1018.252c0.501-0.201,1.102-0.301,1.701-0.502l1.001-0.299c3.502-0.9,8.405-2.201,10.206-5.305
		c0.801-1.301,0.901-2.801,0.4-4.602c-0.3-1.201-1.501-2.201-2.701-3.203c-1.201-1-2.401-2-2.802-3.301
		c-0.4-1.402-0.501-2.402,0-3.203c0.6-1.1,1.801-1.4,3.002-1.701c1.2-0.299,2.301-0.6,2.701-1.6c0.5-1.002-1-6.404-1.801-8.307
		c-0.4-0.799-1.001-1.701-1.801-2.701c-1.401-1.9-2.803-3.803-2.803-5.703c0-1.801,0.601-2.402,1.201-3.102
		c0.3-0.301,0.601-0.701,0.9-1.201c0.2-0.5,0.4-1.102,0.601-1.801c0.2-0.801,0.4-1.502,0.801-2.102c0.4-0.602,0.9-1.102,1.501-1.602
		c0.6-0.5,1.101-1,1.4-1.602c0.2-0.5,0.101-1.1,0.101-1.801c-0.101-0.9-0.2-1.9,0.3-2.801c2.102-3.604,9.006-5.203,14.108-6.404
		c1.301-0.301,2.502-0.6,3.402-0.9c1.101-0.301,2.201-0.9,3.302-1.602c1.802-1,3.603-2,5.704-2.201c1.501-0.1,3.002,0.201,4.503,0.6
		c1.601,0.4,3.202,0.801,5.003,0.602c2.602-0.301,6.304-1.102,7.805-2.402c2.001-1.801,1.501-2.701,0.501-4.602
		c-0.4-0.701-0.801-1.602-1.102-2.602c-0.8-2.602-1.2-5.205-1.601-7.705c-0.601-3.703-1.101-7.205-2.702-10.607
		c-0.5-1-1.4-2.102-2.401-3.102c-1.2-1.4-2.401-2.602-2.701-3.902c-0.501-1.801,0.601-3.102,1.701-4.303
		c0.8-0.9,1.601-1.801,1.801-3.002c1.001-4.402-0.7-8.506-2.302-12.508c-0.8-1.9-1.601-3.902-2.101-5.904
		c-0.4-1.701-0.701-3.301-1.001-4.902c-0.9-4.504-1.501-8.105-4.603-12.008c-1.901-2.402-2.102-5.004-2.302-7.904
		c-0.1-0.701-0.1-1.502-0.2-2.303c-0.2-2.1-0.7-3.602-1.2-5.303c-0.301-1.1-0.701-2.301-0.901-3.502c-0.3-1.5-0.4-3.002-0.4-4.502
		c-0.1-1.602-0.1-3.203-0.5-4.604c-0.801-2.602-2.401-5.604-4.103-8.605c-2.901-5.104-6.604-5.004-12.308-5.004
		c-0.601,0-1.301,0-2.001,0c-5.104,0-9.506,0.602-14.109,1.201c-1.801,0.201-3.602,0.5-5.403,0.701c-0.7,0.1-1.4,0.1-2.101,0.199
		c-2.702,0.201-5.504,0.4-7.605,1.602c-0.8,0.4-1.4,0.801-2.001,1.201c-1.901,1.201-3.402,2.102-6.804,2.201h-0.301
		c-4.303,0-6.504-2.602-8.705-5.203c-1.401-1.701-2.802-3.402-5.003-4.604c-0.601-0.301-1.201-0.801-1.901-1.201
		c-1.801-1.301-3.902-2.801-5.704-2.201c-1.301,0.4-3.902,3.902-5.503,6.004c-0.601,0.801-1.101,1.502-1.501,2.002
		c-0.7,0.801-1.401,1.801-2.102,2.701c-2.401,3.102-5.003,6.305-8.305,8.305c-2.202,1.301-4.604,2.402-7.805,1.701
		c-2.502-0.6-4.103-2-5.404-3.201c-1.801-1.701-3.001-2.701-5.703-0.9c-0.9,0.6-1.701,1.301-2.702,2.102
		c-2.701,2.301-5.703,4.803-9.306,3.102c-1-0.5-2.001-1.102-2.901-1.701c-1.001-0.602-1.901-1.201-2.902-1.701
		c-0.5-0.201-1.101-0.602-1.701-1c-1.2-0.701-2.501-1.502-3.702-1.502l0,0c-0.6,1.301-1.4,2.102-2.201,2.902
		c-1.001,1-1.801,1.801-1.801,3.502c0,1.1,0.1,1.9,0.2,2.502c0.3,2.301,0,2.9-3.303,5.104c-0.9,0.6-1.801,1.5-2.802,2.602
		c-1.601,1.701-3.302,3.502-5.303,3.801c-3.103,0.502-5.403-1.6-7.405-3.502c-0.5-0.4-0.9-0.801-1.4-1.201
		c-2.401-2-4.903-3.602-7.305-5.203c-2.201-1.4-4.503-2.9-6.704-4.703c-2.901-2.301-4.202-3.801-4.003-7.904
		c0-0.6,0.101-1.1,0.101-1.602c0.3-2.5,0.4-3.701-2.401-4.602c-1.101-0.301-2.502-0.301-4.003-0.201h-0.7
		c0.3,1.201,0.3,2.602,0,4.004c-0.5,2.301-2.001,4.201-3.502,6.004c-1.101,1.4-2.102,2.602-2.802,4.102
		c-0.601,1.301-0.9,2.602-1.301,3.803c-0.601,2.102-1.201,4.102-2.502,5.803h0.2c-0.4,10.908,0.3,22.314,1.001,33.32
		c0.2,3.203,0.4,6.305,0.5,9.508c1.401,0.1,2.702-0.301,4.103-0.701c1.201-0.4,2.502-0.701,4.003-0.801
		c4.002-0.1,6.003,1.102,8.805,2.902l0.2,0.1c5.104,3.201,8.605,7.504,12.308,12.008c0.801,1,1.602,2,2.402,2.902
		c0.6,0.699,1.101,1.301,1.601,1.801c1.601,1.801,3.002,3.402,4.402,5.703c1.901,3.102,2.002,4.502,2.302,7.904l0.1,0.801
		c0.4,3.602,1.302,6.805,2.302,10.207c0.7,2.4,1.501,4.902,2.001,7.504c0.301,1.301,0.701,2.701,1.101,4.104
		c1.201,4.002,2.402,8.205,0.101,12.207c-1.901,3.201-4.503,5.904-7.104,8.506s-5.003,5.104-6.704,8.004
		c-2.201,3.803,3.202,9.006,6.704,12.408l0.9,0.9c2.401,2.402,6.204,3.902,9.406,3.803c2.102-0.1,3.902-0.9,5.103-2.301
		c1.701-2.002,1.802-4.104,1.802-6.605c0-1.199,0.1-2.4,0.3-3.701c0.4-2.402,1.701-7.105,3.902-9.105
		c1.401-1.201,3.002-1.602,4.604-1.902c0.9-0.199,1.801-0.4,2.602-0.699c4.303-1.701,6.804-5.504,9.105-9.105
		c1.4-2.102,2.701-4.104,4.303-5.705l0.3-0.299l0.4,0.199c1.201,0.4,2.302,0.6,3.603,0.701c1.901,0.299,4.002,0.5,6.104,1.701
		c2.401,1.301,4.603,2.701,6.704,4.102c5.304,3.402,11.007,9.506,13.909,12.809c1.101,1.301,2.501,2.201,3.902,3.201
		c1.101,0.801,2.301,1.602,3.302,2.602c1.501,1.402,2.302,3.203,3.202,5.004c0.3,0.6,0.601,1.301,1,1.9
		c2.802,5.203,7.505,4.904,13.009,4.504c0.7,0,1.4-0.1,2.102-0.1c0.6,0,1.101-0.102,1.7-0.201c0.701-0.1,1.501-0.199,2.302-0.199
		c0.2,0,0.4,0,0.601,0h0.7v0.699c0.1,1.701-0.1,3.402-0.4,5.004c-0.5,3.701-1,6.904,3.103,10.006c0.7,0.5,1.501,0.9,2.301,1.301
		c0.4,0.199,0.9,0.5,1.301,0.701c0.7,0.4,1.501,0.9,2.201,1.5c0.501,0.4,1.001,0.701,1.501,1
		C621.492,1019.252,622.393,1018.952,624.594,1018.252L624.594,1018.252z"
      ></path>
      <text
        onClick={locateUser}
        borough="Sutton"
        transform="matrix(1 0 0 1 534.3428 914.4966)"
        fontSize="27.7821"
      >
        Sutton
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Kingston upon Thames"
        className={"Kingston upon Thames" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Kingston upon Thames"
        d="M466.396,847.344c0.7-1.6,1.901-3.002,3.002-4.402c1.4-1.801,2.802-3.402,3.202-5.402c1.2-5.604-3.502-9.307-7.905-13.008
		c-1.801-1.402-3.402-2.803-4.703-4.203c-5.203-5.904-3.002-9.207-0.8-12.709c1.601-2.4,3.202-4.902,2.701-8.605
		c-0.3-2.201-2.102-7.404-3.202-10.406l-0.4-1.1c-1.5-4.303-2.101-6.504-2.401-11.107c-0.2-2.701-0.9-4.104-1.901-6.104
		c-0.399-0.701-0.7-1.4-1.101-2.301c-1.2-2.602-1.2-4.805-1.301-7.105c0-1,0-2.002-0.1-3.201c-0.4-3.703-1.701-6.904-3.002-9.906
		s-2.602-6.104-2.901-9.807c-0.101-1.301-0.701-2.902-1.201-4.402c-0.601-1.701-1.201-3.402-1.301-5.004
		c-0.1-3.502,1.4-4.703,3.002-6.004c0.7-0.5,1.4-1.1,2.001-1.9c3.402-4.002,1.301-5.904-1.601-8.506
		c-1.301-1.201-2.802-2.502-3.702-4.102c-1.001,0.9-2.002,1.801-3.002,2.701c-4.303,3.902-8.706,7.805-13.309,11.107
		c-7.204,5.102-12.708,10.406-18.012,17.01c-0.9,1.201-2.201,3.303-3.502,5.504c-2.501,4.203-5.103,8.605-7.305,10.006
		c-1.801,1.201-3.602,1.5-5.003,1.102c-2.802-0.902-4.402-4.404-5.804-7.605c-0.7-1.502-1.301-2.902-2.001-3.902
		c-3.102-4.604-7.905-8.807-13.408-11.707c-3.002-1.602-9.706-4.004-14.309-3.303v0.201l-0.601-0.102
		c-0.801,0.201-1.602,0.5-2.202,1.002c-4.302,3.201-1.601,8.404,0.501,12.607l0.601,1.201c0.6,1.199,1.2,2.301,1.801,3.301
		c2.401,4.504,4.402,8.105,3.302,14.109c-0.5,2.801-1.4,5.504-2.201,8.205c-0.9,2.801-1.801,5.703-2.302,8.805
		c-0.3,1.602-0.5,3.303-0.7,4.805c-0.7,4.502-1.301,8.805-2.201,13.008c-0.601,2.602-0.601,5.902-0.601,9.305
		c0,3.902,0,7.906-0.9,11.307c-1.401,5.805-5.904,11.107-11.707,14.109c4.603,4.902,6.804,11.107,8.805,17.611
		c0.701,2.102,1.501,4.303,2.402,6.604c1.801,4.604,3.602,9.307,4.002,14.209c0.101,0.5,0.101,1.102,0.2,1.801
		c0.4,3.502,0.9,7.805-1.901,10.508c-1.4,1.4-3.802,1.801-6.004,2.201c-1.601,0.299-3.102,0.5-4.202,1.1
		c-6.304,3.502-6.004,9.506-5.604,15.91c0.1,1.502,0.2,3.102,0.2,4.703c0,1.902,0.1,3.703,0.1,5.504
		c0.2,7.104,0.501,13.809-3.702,20.111c-1.101,1.602-1.901,3.504-2.701,5.305c-0.801,1.701-1.501,3.402-2.502,4.902
		c-0.801,1.301-1.801,2.502-2.702,3.703c-1.4,1.801-2.801,3.602-3.702,5.604c-1.701,4.002-1.101,8.605-0.601,13.008
		c0.4,3.303,0.901,6.703,0.4,9.906c-0.7,4.902-0.5,10.406-0.2,15.709c0.101,2.803,0.301,5.703,0.301,8.406
		c0,1.5-0.2,3.301-0.4,5.002c-0.3,2.502-0.5,5.203-0.2,7.105c0.601,4.002,2.802,4.102,8.205,3.902
		c10.106-0.301,12.708-4.303,16.511-10.307c1.2-1.801,2.501-3.902,4.202-6.004c1.401-1.801,3.202-3.102,5.003-4.402
		c1.802-1.301,3.402-2.502,4.604-4.203c2.602-3.701,2.802-7.404,3.001-11.807c0.4-8.307,3.303-16.512,8.105-23.016l1.801-2.5
		c4.503-6.004,8.806-11.709,12.408-18.912c2.001-4.104,3.902-6.504,6.304-9.607c2.001-2.5,2.702-3.902,2.502-5.002
		c-0.2-1.102-1.101-2.201-3.402-3.803l-0.9-0.4l0.801-0.6c1.701-1.301,3.102-2.803,4.402-4.303c0.801-0.9,1.602-1.801,2.502-2.602
		c1.101-1.102,2.301-2.002,3.502-2.902c1.901-1.5,3.702-2.902,5.203-4.902c4.903-6.404,10.406-13.51,17.11-18.611
		c1.102-0.9,2.202-1.502,3.202-2.203c1.901-1.199,3.702-2.301,5.304-4.301c0.7-0.801,1.301-2.002,2.001-3.203
		c1.401-2.4,2.802-4.902,4.603-5.703c1.802-0.9,4.403-0.9,7.005-1c2.001,0,4.103-0.102,5.604-0.502
		c2.501-0.799,8.104-3.002,10.106-4.803c1.901-1.701,2.701-4.102,3.402-6.604C465.395,850.047,465.795,848.747,466.396,847.344
		L466.396,847.344z"
      ></path>
      <text
        onClick={locateUser}
        borough="Kingston upon Thames"
        transform="matrix(0.5 -0.866 0.866 0.5 379.7188 894.4321)"
        fontSize="27.7809"
      >
        Kingston
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Bromley"
        className={"Bromley" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Bromley"
        d="M1138.614,771.499l-0.1-0.9l-29.019-18.713c-6.504-1.201-12.308,0.5-18.611,2.301c-5.003,1.502-10.307,2.902-15.81,2.902
		c-14.409-0.1-29.419-12.707-39.425-21.012c-3.603-3.002-6.404-7.006-9.105-10.908c-5.403-7.604-10.407-14.908-21.113-14.508
		c-2.201,3.402-11.007,16.709-14.209,17.51c-9.605,1.801-11.808-0.1-18.312-5.803l-1.2-1.002c-3.402-3.002-5.403-6.402-7.205-9.705
		c-1.501-2.602-3.001-5.404-5.403-7.904c-3.702-4.104-6.904-7.605-10.206-11.309l-3.803-4.303
		c-3.702-4.102-8.405-8.605-15.109-10.807c-0.8,1.902-1,4.104-1.2,6.404c-0.2,2.402-0.5,4.904-1.501,7.105
		c-0.4,0.9-1.401,2.102-2.401,3.301c-0.9,1.002-2.902,3.402-2.602,4.004c0,0,0.4,0.6,4.103-0.102l0.7-0.1l0.2,0.701
		c0.7,3.002,2.201,5.203,4.402,6.604c2.602,1.602,6.204,1.902,10.206,1l0.901-0.199l0.1,0.9c0.101,1.502,0.7,4.104,1.301,7.105
		c1.802,8.004,4.003,18.01,0.4,21.012c-1.301,1.102-3.302,1.201-5.804,0.201c-2.302-0.9-4.303-2.902-6.504-5.004
		c-1.901-1.9-4.003-3.803-6.104-4.803c-5.804-2.701-11.708-1.102-16.11,0.6c-1.2,0.5-2.102,0.602-2.802,0.701
		c-1.301,0.199-1.901,0.301-3.402,2.301c-0.801,1.102-0.9,2.602-1.101,4.004c-0.1,1.6-0.3,3.201-1.301,4.402
		c-1.601,1.801-3.302,2.602-5.003,3.502c-2.102,1.1-4.103,2.002-5.904,4.902c-0.5,0.801-0.6,1.602-0.7,2.402
		c-0.2,1.201-0.4,2.602-2.101,4.102c-1.001,0.9-3.202,1.602-5.204,2.201c-1.2,0.4-2.201,0.701-2.901,1.002
		c-1.401,0.699-2.802,1.4-4.203,2.102c-4.102,2.102-8.104,4.102-12.607,5.303c-5.104,1.4-9.806,0.5-15.109-2.803
		c-5.804-3.602-5.804-7.104-5.804-12.307c0-1,0-2.102-0.1-3.303c-0.2-4.803-2.202-8.705-5.804-11.006
		c-4.703-3.102-11.707-3.402-18.312-0.9c-2.901,1.1-5.304,2.301-7.705,3.502c-7.204,3.502-13.408,6.604-24.515,3.102
		c-2.002-0.6-4.103-1.301-6.204-2.102c-8.405-2.801-18.012-6.004-26.717-6.504c-0.9,5.803-5.003,13.609-8.205,18.311
		c0,1.502-0.601,3.002-1.101,4.504c-0.7,2.002-1.401,3.902-0.601,5.504c0.801,1.4,2.902,2.102,5.003,2.9
		c1.802,0.602,3.702,1.301,4.903,2.502c1.801,1.902,2.401,4.904,2.901,7.506c0.2,1.199,0.4,2.301,0.701,3.201
		c1.101,3.402,2.301,7.205,4.202,10.906c4.003,7.506,10.106,11.309,15.41,14.01c3.202,1.6,3.702,1.301,6.504-0.301
		c0.601-0.301,1.2-0.701,2.001-1.1c3.502-1.902,7.205-3.504,10.307,0.9c2.502,3.602,1.301,6.004,0.2,8.404
		c-0.501,1-1.001,2.002-1.201,3.102c-0.9,4.303,1.001,5.404,3.902,7.205l0.701,0.4c1.901,1.201,3.502,2.402,5.103,3.602
		c4.103,3.102,7.705,5.805,14.209,6.205h0.7v0.699c0.2,3.803,0.601,7.404,1.001,10.807c0.5,4.703,1.101,9.207,1.001,14.311v0.6
		c0,5.402,0,6.904,5.203,7.004c2.701,0,4.402-0.9,6.304-2c1.401-0.801,2.902-1.602,4.803-1.902l0.801-0.1v0.801
		c0.2,3.602,1.101,6.104,2.102,9.006c0.4,1.1,0.8,2.201,1.2,3.502c1.201,4.002,1.802,8.705,2.202,13.508
		c0.9,8.605,4.502,13.008,10.306,19.611c2.102,2.402,5.304,4.504,8.605,6.605c4.403,2.801,8.905,5.703,11.107,9.705
		c5.203,9.006,7.404,19.312,9.506,29.219l0.3,1.201c1.101,4.902,2.502,9.705,4.103,14.809c1.701,5.703,3.502,11.508,4.703,17.611
		c0.801,4.102,0.601,6.504-0.601,7.605c5.003,11.207,6.104,26.016,7.005,38.023l0.2,2.5c2.001-0.699,4.303-1.301,6.403-1.699
		l0.801-0.102l0.1,0.801c0.4,3.902,0.101,7.506-0.2,11.008c-0.5,5.902-1,11.506,1.901,18.01c0.7,1.502,1.301,2.803,2.002,4.104
		c1.2,2.402,2.301,4.703,3.201,7.705c0.701,2.4,0.901,4.902,1.001,7.305c0.2,3.102,0.4,5.902,1.501,8.504
		c2.102,4.703,3.603,5.305,4.303,5.205c2.602-0.201,5.003-8.406,6.404-13.309c0.5-1.803,1-3.402,1.4-4.604
		c1.701-4.604,7.705-19.912,16.511-24.816l0.5-0.299l0.4,0.4c1.601,1.801,4.202,3.801,6.904,5.902
		c4.103,3.104,8.405,6.404,10.307,9.807c2.701,4.902,2.602,16.811,2.301,23.916c1.302,0,2.202-0.502,3.303-1.002
		c1.101-0.6,2.201-1.1,3.702-1.201h0.5c2.602,0,4.403,0.801,6.305,1.701c0.8,0.4,1.7,0.801,2.701,1.201
		c5.504,2.002,10.106,2.902,15.81,3.102c10.607,0.4,25.116,0.9,35.723-5.203c3.603-2.102,13.208-7.705,11.907-12.908
		c-0.4-1.701-3.102-5.102-5.403-8.004c-2.102-2.701-4.103-5.203-4.903-6.904c-5.103-11.307-4.603-25.816,1.101-35.922
		c3.002-5.305,6.604-8.205,11.808-11.508c5.403-3.402,8.205-6.604,12.508-11.607c4.503-5.303,10.206-8.205,15.81-11.008
		c4.503-2.301,9.206-4.602,13.009-8.305c4.503-4.203,4.002-6.404,3.202-10.307c-0.2-0.801-0.4-1.701-0.501-2.701
		c-0.2-1.201-0.2-2.602-0.2-4.002c0-1.502-0.1-3.002-0.3-4.303c-0.1-0.701-0.1-1.502,0-2.201c0.101-0.801,0.101-1.502-0.1-2.201
		c-0.101-0.301-1.201-0.801-1.802-1.102c-1.2-0.6-2.001-1-2.001-1.701c-0.601-6.404,9.006-11.307,11.907-12.607
		c3.102-1.4,6.904-1.102,10.507-0.9c2.602,0.199,5.003,0.299,7.204,0c5.604-1.002,6.204-2.402,7.905-6.705
		c0.3-0.9,0.7-1.9,1.2-3.002c0.4-0.9,0.801-1.9,1.201-2.9c2.001-4.604,4.103-9.406,5.403-14.209
		c1.101-4.104,1.901-8.307,2.802-12.408c1.4-6.805,2.902-13.908,5.304-20.914c2.201-6.303,2.201-9.105,2.201-15.209
		c0-2.602,0.8-4.002,1.501-5.303c0.4-0.801,0.801-1.502,1.101-2.402c0.9-4.002,0.2-5.604-1.401-8.705
		c-0.4-0.701-0.801-1.602-1.2-2.502c-2.302-5.002-2.902-10.406-3.603-15.709c-0.801-6.004-1.501-11.707-4.402-16.51l-0.501-0.902
		l1.001-0.199c2.602-0.6,5.203-1,7.705-1.301c3.201-0.5,6.203-0.9,9.205-1.701l0.601-0.199c3.502-0.902,6.104-1.602,6.304-2.303
		c0.2-0.699-1.601-2.701-3.402-4.602c-5.003-5.504-7.805-12.809-10.506-19.812c-1.401-3.502-2.802-7.105-4.403-10.508
		C1139.215,771.499,1138.915,771.499,1138.614,771.499L1138.614,771.499z"
      ></path>
      <text
        onClick={locateUser}
        borough="Bromley"
        transform="matrix(1 0 0 1 934.3105 885.3765)"
        fontSize="27.7821"
      >
        Bromley
      </text>
      <path
        fill="#74c69d"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Croydon"
        className={"Croydon" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Croydon"
        d="M625.095,1019.752c0.5-0.199,1-0.301,1.601-0.5l1.001-0.301c3.802-1,9.006-2.4,11.106-6.004
		c1.001-1.6,1.101-3.602,0.601-5.703c-0.4-1.701-1.801-2.801-3.202-4.002c-1.101-0.9-2.102-1.801-2.401-2.703
		c-0.3-0.9-0.4-1.6-0.1-2c0.3-0.5,1.101-0.701,2.101-1c1.301-0.301,3.002-0.801,3.702-2.402c0.801-1.801-1.2-8.105-1.801-9.506
		c-0.4-0.9-1.101-1.9-1.901-2.902c-1.2-1.602-2.501-3.402-2.501-4.803c0-1.201,0.3-1.602,0.8-2.102c0.301-0.4,0.701-0.801,1.101-1.5
		c0.301-0.602,0.501-1.301,0.701-2.102c0.2-0.602,0.4-1.301,0.6-1.701c0.301-0.4,0.701-0.801,1.201-1.201
		c0.7-0.6,1.401-1.201,1.801-2.201c0.301-0.801,0.2-1.701,0.2-2.502c-0.1-0.699-0.1-1.4,0.101-1.9
		c1.801-3.002,8.605-4.604,13.208-5.703c1.401-0.301,2.602-0.602,3.502-0.902c1.201-0.398,2.401-1,3.603-1.699
		c1.701-0.902,3.402-1.902,5.104-2.002c1.301-0.1,2.602,0.199,4.002,0.5c1.701,0.4,3.502,0.801,5.504,0.6
		c1-0.1,6.304-0.799,8.605-2.801c2.901-2.502,1.9-4.504,0.9-6.404c-0.4-0.701-0.801-1.5-1.001-2.301
		c-0.7-2.502-1.101-5.004-1.501-7.506c-0.601-3.602-1.2-7.404-2.802-11.006c-0.5-1.201-1.601-2.402-2.602-3.502
		c-1.001-1.201-2.102-2.402-2.401-3.303c-0.3-1,0.3-1.701,1.4-2.902c0.901-1,1.802-2.102,2.202-3.602
		c1.101-4.803-0.701-9.205-2.401-13.408c-0.801-2.002-1.602-3.803-2.002-5.703c-0.4-1.701-0.7-3.303-1-4.803
		c-0.901-4.504-1.602-8.506-4.903-12.609c-1.602-2.102-1.802-4.303-2.001-7.104c-0.101-0.801-0.101-1.502-0.2-2.301
		c-0.2-2.203-0.701-3.902-1.201-5.604c-0.3-1.102-0.601-2.203-0.9-3.402c-0.3-1.402-0.3-2.902-0.4-4.203
		c-0.1-1.701-0.1-3.402-0.601-5.004c-0.801-2.801-2.501-5.803-4.202-8.904c-1.201-2.102-2.502-3.402-4.003-4.303
		c0.2-0.1,0.4-0.201,0.5-0.201l0.4-0.1l0.101-0.4c0.601-2.502,2.301-5.303,3.902-7.805c0.801-1.201,2.102-2.502,3.402-3.703
		c1.701-1.6,3.502-3.4,4.202-5.102c2.401-5.604-3.902-14.109-6.904-18.213l-0.2-0.299c-2.701-3.703-6.604-12.809-1.501-17.711
		c1.001-1.002,1.802-1.502,2.502-2.002c1.301-0.9,2.302-1.602,3.702-4.002l0.7-1.301h0.101l0.1-0.201
		c1.301-2.201,2.502-4.502,4.003-6.303c2.001-2.502,4.202-4.904,6.403-7.205c2.502-2.701,4.804-5.203,7.005-8.006
		c1.101-1.5,1.701-2.701,2.201-3.701c1.001-2.102,1.301-2.902,5.704-2.902c3.102,0,6.304-0.199,9.306-0.4l3.002-0.199
		c1.501-0.102,3.102-0.201,4.702-0.4c6.104-0.602,12.408-1.201,16.61,2.102c0.701,0.6,1.401,1.301,2.202,2
		c1.901,1.801,4.002,3.902,6.403,4.203c1.901,0.199,3.902-0.301,6.104-0.9c1.501-0.4,3.102-0.9,4.603-1l-0.2,0.199l0.5,0.4
		c-0.1,1-0.5,2.102-1,3.303c-0.801,2.201-1.701,4.602-0.501,6.703c1.001,1.902,3.503,2.701,5.804,3.602
		c1.701,0.602,3.402,1.201,4.303,2.102c1.501,1.502,2.001,4.203,2.502,6.805c0.2,1.201,0.4,2.402,0.8,3.402
		c1.102,3.402,2.302,7.404,4.303,11.107c4.203,7.805,10.507,11.807,16.11,14.609c3.902,2,5.003,1.301,7.905-0.4
		c0.6-0.301,1.2-0.701,1.901-1.102c3.902-2.102,6.203-2.602,8.405,0.5c2.001,2.902,1.2,4.703,0.1,6.904
		c-0.5,1.102-1.101,2.201-1.301,3.502c-1.101,5.305,1.701,7.006,4.603,8.707l0.701,0.4c1.801,1.1,3.401,2.4,5.003,3.502
		c4.002,3.002,7.805,5.902,14.309,6.402c0.2,3.604,0.601,7.006,1.001,10.207c0.5,4.703,1.101,9.105,1,14.109v0.6
		c0,5.404,0,8.406,6.604,8.506c3.102,0,5.104-1.102,7.004-2.102c1.201-0.6,2.302-1.301,3.503-1.602
		c0.3,3.402,1.101,5.805,2.101,8.506c0.4,1.102,0.801,2.201,1.101,3.402c1.201,3.902,1.701,8.506,2.202,13.309
		c0.9,8.904,4.603,13.607,10.606,20.412c2.302,2.602,5.703,4.703,8.905,6.904c4.203,2.701,8.605,5.504,10.606,9.105
		c5.003,8.807,7.205,19.012,9.406,28.818l0.3,1.201c1.102,5.002,2.602,9.807,4.103,14.908c1.701,5.604,3.503,11.508,4.703,17.512
		c1.001,4.902,0.2,6.004-0.2,6.203c-1.9,1.002-7.704-4.402-10.906-7.404c-2.102-2-3.402-3.102-4.103-3.402
		c-4.804-2.102-7.205,1.701-8.906,4.404c-1,1.6-1.901,3-2.901,3.102c-0.601-0.102-1.701-0.5-3.502-3.102
		c-0.801-1.201-1.602-2.502-2.502-3.904c-3.603-6.002-7.805-12.707-15.01-12.006c-1.4,0.1-2.801,0.5-4.102,0.799
		c-2.302,0.602-4.604,1.201-7.104,0.701c-1.401-0.301-2.602-0.701-3.703-1.1c-3.401-1.201-6.003-2.102-9.205,3.002
		c-0.9,1.5-1.501,2.801-2.002,4.002c-1,2.4-1.7,4.102-4.902,5.504c-1.201,0.5-2.401,0.799-3.702,1c-2.402,0.5-4.804,1-6.604,3.201
		c-3.302,4.203-1.301,7.006,1.301,10.607l0.2,0.199c3.102,4.404,3.202,5.504,0.5,9.307c-1.701,2.402-3.602,3.902-5.703,5.604
		c-0.801,0.701-1.701,1.4-2.502,2.102c-1.101,1-1.901,1.9-2.802,2.902c-1.801,2-3.302,3.701-6.004,4.701
		c-2.901,1.102-12.607,4.604-16.41,2.402c-0.7-0.4-0.8-0.801-1-1.4c-0.301-1.102-0.701-2.201-3.002-2.502
		c-1.901-0.301-3.702,0.4-5.504,1.1c-1.801,0.701-3.603,1.402-5.503,1.102l-1.401-0.199l0.601,1.301c0.3,0.699,0.4,1.199,0.2,1.701
		c-0.4,1.199-2.201,2-3.902,2.9c-1.301,0.701-2.602,1.301-3.402,2.102c-2.602,2.701-1.601,4.604-0.601,6.504
		c0.7,1.301,1.401,2.602,1.401,4.504c-0.101,4.402-3.402,8.404-6.604,12.307c-1.701,2.002-3.202,3.902-4.402,5.904
		c-0.9,1.5-1.602,3.303-2.202,4.902c-0.8,2.002-1.501,3.803-2.501,5.404l-0.101,0.199c-1,1.4-1.7,2.402-3.001,3.203
		c-0.501,0.299-1.201,0.299-1.901,0.299c-1.401,0-3.103,0-4.103,1.803c-1.301,2.301-0.4,3.902,0.3,5.102
		c0.801,1.402,1.201,2.303-0.9,4.104c-1.401,1.201-3.103,2.201-4.903,3.303c-1.801,1.1-3.702,2.201-5.303,3.602
		c-4.003,3.502-8.506,6.104-12.508,7.205c-0.901,0.299-1.701,0.398-2.402,0.6c-3.201,0.701-5.303,1.201-6.804,6.305
		c-0.4,1.199-0.5,2.301-0.7,3.4c-0.4,3.002-0.801,5.104-4.303,6.605c-2.902,1.201-6.904,0.5-9.006-1.502
		c-1.501-1.4-2.802-4.602-3.902-7.305c-0.7-1.6-1.301-3.102-1.901-4.201c-0.9-1.701-1.901-3.203-2.901-4.703
		c-1.201-1.801-2.402-3.703-3.503-5.703l-0.8-1.602c-1.501-2.902-3.002-5.904-4.903-8.205c-2.102-2.502-4.203-3.002-6.304-3.002
		c-0.901,0-1.802,0.1-2.702,0.199c-0.9,0.102-1.701,0.201-2.702,0.201c-1.4,0-2.901,0.299-4.502,0.699
		c-2.402,0.502-4.903,1.002-7.005,0.502c-2.302-0.602-5.604-2.502-8.205-4.104c-0.7-0.4-1.301-0.801-1.801-1.102
		c-4.203-2.5-4.103-3.301-3.502-7.004c0.1-0.6,0.2-1.201,0.3-1.801c0.7-4.703,1.001-8.205,1.001-10.506
		c0-3.203-1.401-4.303-2.802-5.404c-1.001-0.801-2.102-1.701-2.802-3.701c-0.501-1.602-0.801-3.002-1.001-4.303
		c-0.3-2.002-0.601-3.902-1.801-6.004c-0.4-0.701-0.701-1.301-1.001-1.902c-1.901-3.402-2.702-4.703,0.3-7.504
		c1.401-1.301,3.103-2.201,4.903-3.102c1.101-0.602,2.201-1.102,3.202-1.803L625.095,1019.752L625.095,1019.752z"
      ></path>
      <text
        onClick={locateUser}
        borough="Croydon"
        transform="matrix(1 0 0 1 703.4629 914.4966)"
        fontSize="27.7821"
      >
        Croydon
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Barking and Dagenham"
        className={"Barking and Dagenham" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Barking and Dagenham"
        d="M1190.047,363.844c-0.7-1.701-1.901-3.102-3.103-4.403c-1.4-1.701-2.901-3.402-3.502-5.704c-0.9-3.102-1-8.305-0.7-12.408
          c-4.903-1.601-14.009-1-18.712-0.3c-2.602,0.4-5.103,1.501-7.604,2.602c-2.602,1.201-5.403,2.301-8.205,2.702
          c-5.403,0.7-8.605-2.501-12.007-5.804c-1.201-1.101-2.402-2.301-3.703-3.402c-0.6-0.5-2.001-1.301-3.402-2.101
          c-4.702-2.702-7.704-4.503-7.504-6.404c0.1-0.901,1-1.401,1.601-1.601c0.101-3.703-1.4-7.004-2.901-10.607
          c-1.301-3.102-2.702-6.304-3.002-9.806c-0.301-4.903,1.501-8.205,3.201-11.407c1.502-2.802,3.002-5.503,3.202-9.406
          c0.2-4.603,0-9.206-0.2-13.608c-0.1-3.102-0.3-6.304-0.3-9.506c0-0.7,0-1.301,0-2.001c0.101-3.402,0.101-5.403-2.302-7.905
          c-0.5-0.5-1.2-0.9-1.9-1.301c-0.701-0.4-1.502-0.9-2.102-1.501c-0.601-0.6-0.9-1.301-1.101-1.901c-0.601,0.5-1.301,1-2.102,1.601
          c-0.7,0.5-1.501,1.101-2.401,1.801c-7.305,5.704-12.908,12.208-17.311,17.811c-1.701,2.102-3.103,4.103-4.604,6.204
          c-0.7,1-1.701,2.101-2.802,3.202c-1.001,1.101-2.102,2.201-2.302,2.802c-2.602,5.303-0.8,7.604,2.002,10.907
          c0.4,0.5,0.801,1,1.301,1.601c0.6,0.7,1.101,1,1.701,1.301c1,0.5,2.101,1.101,2.701,3.602c0.301,1.101-0.3,3.602-1.101,7.004
          c-0.3,1.101-0.5,2.101-0.601,2.702c-0.9,5.503-1.101,11.107-1.301,17.111v0.8c-0.3,8.405-1.301,10.207-8.005,15.31l-0.601,0.5
          c-7.604,5.803-7.604,5.803-8.405,15.31c-0.1,1.401-0.1,2.201-0.1,2.802c0,1.301-0.101,1.5-1.201,2.301
          c-0.7,0.5-1.901,1.401-4.103,3.402c-1.101,1.001-1.501,2.001-1.9,3.102c-0.4,1.101-0.901,2.401-2.202,3.802
          c-1.2,1.301-2.701,1.901-4.202,2.602c-1.101,0.5-2.102,0.9-2.902,1.5c-1.4,1.201-2.101,2.102-2.802,3.202
          c-0.6,0.801-1.101,1.701-2.101,2.702c-4.703,4.903-9.206,8.405-13.408,10.307c-4.303,2.001-6.204,0.8-8.006-0.4
          c-1.601-1-3.002-1.901-6.403-1.201c-1.101,0.2-2.802,1.701-4.503,3.202c-1.401,1.301-2.902,2.602-4.203,3.202
          c-3.602,1.801-6.104,2.802-9.705,3.703c-3.703,0.9-13.009,3.302-17.712,2.001c0,1.601-0.5,2.802-0.9,3.902
          c-0.7,1.701-1.301,3.203-0.1,5.704c0.8,1.701,1.601,3.202,2.401,4.603c1.301,2.402,2.602,4.604,3.402,7.505
          c0.3,1.101,0.9,2.002,1.4,3.002c0.5,0.801,0.9,1.501,1.201,2.201c0.5,1.301,0.5,2.603,0.5,3.803c0,1.001,0,1.901,0.301,2.802
          c0.9,3.202,2.401,3.603,4.803,4.402c0.9,0.301,2.001,0.601,3.202,1.201c0.9,0.4,1.801,0.9,2.802,1.4
          c2.602,1.301,5.303,2.702,8.605,3.503c1.601,0.4,3.302,0.4,4.902,0.5c3.502,0.101,7.205,0.3,8.706,3.702
          c0.5,1.201,0.399,2.602,0.3,4.103c-0.1,1.401-0.2,2.802,0.301,3.603c0.5,0.9,1.301,1.301,2.201,1.801
          c0.8,0.4,1.701,0.9,2.501,1.802c1.301,1.601,1.802,3.401,2.302,5.103c0.5,1.901,1.001,3.603,2.602,5.203
          c9.605,9.706,26.717,5.403,37.023-1c5.804-3.603,12.707-6.204,19.611-6.304c14.01-0.101,26.517,11.507,39.225,16.41
          c3.202,1.2,6.604,2.701,10.106,2.301l0.4-0.3c-0.4-6.904,1.001-13.509,2.302-19.812l0.6-2.901c0.4-1.901,0.701-3.703,1.001-5.504
          c1.101-6.704,2.102-12.508,6.504-18.411c2.602-3.402,4.403-7.405,6.204-11.207c1.701-3.702,3.402-7.404,5.903-10.807
          c4.604-6.404,10.106-13.709,15.71-20.213c4.803-5.604,10.106-15.31,10.507-21.813
          C1192.948,370.748,1191.447,366.846,1190.047,363.844L1190.047,363.844z"
      ></path>
      <text
        onClick={locateUser}
        borough="Barking and Dagenham"
        transform="matrix(1 0 0 1 1028.4092 420.2437)"
        fontSize="24.6952"
      >
        Barking &amp;
      </text>
      <text
        onClick={locateUser}
        borough="Barking and Dagenham"
        transform="matrix(1 0 0 1 1028.4092 444.9399)"
        fontSize="24.6952"
      >
        Dagenham
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Newham"
        className={"Newham" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Newham"
        d="M828.021,369.547c2.602,2.802,4.703,6.004,6.604,8.906c3.502,5.503,4.603,5.803,8.605,6.504c1.101,0.2,2.502,0.4,4.202,0.8
		c2.302,0.5,3.803,1.401,5.004,2.102c2.301,1.401,4.103,2.501,9.705,0.2c0.701-0.3,1.602-0.701,2.502-1.201
		c3.102-1.5,7.305-3.502,9.807-2.301c1.101,0.5,1.801,1.601,2.201,3.402l0.1,0.5l0.5,0.1c6.905,1,8.205-1.601,9.606-4.403
		c0.801-1.501,1.501-3.102,3.202-4.402c3.202-2.602,7.805-0.1,10.206-2.502c0.9-0.9,1.301-2.401,1.301-4.703
		c0-0.601-0.2-1.401-0.5-2.202c6.804,0.1,9.605,1.301,12.508,9.006l0.2,0.5h0.5c5.504,0.2,11.507-1,17.211-2.201
		c4.703-1,9.605-2.001,14.309-2.201h0.7v-0.701c0.101-2.301-0.9-5.103-1.901-8.105c-1.5-4.403-3.001-9.006-1.4-12.007
		c0.7-1.401,2.102-2.402,4.202-2.902c4.503-1.301,8.605,3.802,11.607,7.504c0.7,0.801,1.301,1.601,1.802,2.202
		c0.6,0.6,1.101,1.301,1.601,1.901c2.201,2.602,4.403,5.303,8.306,6.304c1.2,0.3,2.602,0.1,4.002-0.1c1.701-0.2,3.502-0.5,4.402,0.2
		c4.503,2.902,3.503,9.306,2.502,16.11c-1.101,7.104-2.201,14.309,3.303,17.611c0.199,1.601-0.301,2.802-0.801,4.002
		c-0.701,1.801-1.501,3.803-0.101,6.805c0.801,1.801,1.602,3.302,2.502,4.703c1.301,2.301,2.501,4.402,3.302,7.204
		c0.4,1.201,1.001,2.302,1.602,3.302c0.4,0.701,0.8,1.401,1,2.002c0.4,1.101,0.4,2.101,0.4,3.302c0,1,0,2.102,0.4,3.202
		c1.201,3.902,3.302,4.603,5.804,5.403c0.9,0.3,1.901,0.601,3.002,1.101c0.9,0.4,1.801,0.9,2.701,1.301
		c2.702,1.4,5.504,2.802,8.906,3.603c1.7,0.399,3.502,0.5,5.203,0.5c3.402,0.1,6.204,0.2,7.404,2.901
		c0.4,0.801,0.301,2.102,0.2,3.303c-0.1,1.601-0.3,3.202,0.5,4.503c0.801,1.301,1.901,1.801,2.802,2.301
		c0.701,0.4,1.401,0.7,2.002,1.401c1.101,1.4,1.601,2.901,2.001,4.603c0.5,2.001,1.101,4.003,2.901,5.804
		c1.201,1.2,2.502,2.201,4.003,3.102c-2.602,0.101-4.603,0.601-6.604,1.001c-5.503,1.301-9.005,3.603-13.208,7.305
		c-2.901,2.501-5.604,5.403-8.005,8.405c-6.004,7.505-8.505,18.611-16.01,24.815c-4.503,3.802-11.007,4.103-16.61,4.503
		c-6.904,0.6-13.809,0.1-20.613-0.301c-3.802-0.2-7.404-0.5-10.406-0.5c-7.404,0-13.309,0.4-19.111,1.301
		c-1.502,0.2-2.902,0.5-4.203,0.801c-3.002,0.7-5.804,1.301-9.406,0.8c-9.506-1.4-12.907-5.303-17.61-10.706
		c-1.602-1.901-3.502-4.003-5.804-6.204c-1.301-1.201-3.002-2.102-4.603-3.002c-1.802-0.9-3.503-1.801-4.503-3.102
		c-1.602-2.002-1.501-4.103-1.301-6.604c0.1-1.501,0.199-3.102-0.101-4.603c-1.2-6.305-6.804-10.307-12.107-14.109
		c-3.102-2.201-6.104-4.402-8.205-6.904c-2.302-2.802-2.802-6.403-3.402-10.206c-0.601-4.103-1.2-8.205-4.002-11.907
		c-1.501-2.002-3.702-3.803-5.804-5.504c-1.301-1.101-2.602-2.201-3.702-3.302c-3.002-3.002-4.503-5.504-6.505-9.306
		c-0.199-0.5-0.5-1.001-0.8-1.501c-1.501-2.702-3.302-5.704-1.701-8.506c0.601-1.101,1.501-1.801,2.501-2.602
		c1.502-1.101,3.103-2.401,3.803-5.103c1.701-6.104-2.001-17.411-5.003-23.115c-1.301-2.501-3.002-4.203-4.903-6.104
		c-0.7-0.7-1.4-1.4-2.201-2.201c-2.902-3.102-2.802-4.903-2.702-8.605c0-0.7,0.101-1.601,0.101-2.501L828.021,369.547
		L828.021,369.547z"
      ></path>
      <text
        onClick={locateUser}
        borough="Newham"
        transform="matrix(1 0 0 1 871.2002 449.2964)"
        fontSize="27.7821"
      >
        Newham
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Greenwich"
        className={"Greenwich" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Greenwich"
        d="M831.123,571.874c-0.101,2.201-0.2,4.002,1.2,5.703c1.001,1.102,2.402,1.602,3.803,2.002
          c1.101,0.299,2.102,0.6,3.002,1.301c2.201,1.5,3.102,3.701,2.901,7.004c-0.1,2.301-0.5,2.902-1.601,3.402
          c-0.3,0.199-0.7,0.301-1.201,1c-1.9,2.703-0.9,4.004,0.701,6.205c0.5,0.6,1,1.301,1.4,2c0.701,1.201,1.201,2.703,1.602,4.104
          c0.8,2.801,1.601,5.504,4.702,6.104c0.901,0.199,1.602,0.1,2.002-0.201c1-0.9,0.8-3.602,0.601-5.703
          c-0.101-1.1-0.2-2.102-0.101-2.902v-0.699h0.7c4.503-0.201,9.006-0.201,13.408-0.201c6.204,0,12.508,0.102,18.712-0.6
          c1.201-0.1,2.502-0.4,3.902-0.6c2.502-0.4,5.104-0.9,8.005-0.9c1.901,0,3.503-0.602,5.004-1.102c1.2-0.4,2.401-0.9,3.702-1
          l0.7-0.102l0.1,0.701c0.101,1.602-0.6,2.602-1.2,3.602c-0.4,0.602-0.801,1.301-1.001,2.102c-0.3,1.301,0,2.703,0.4,4.104
          c0.1,0.5,0.2,1,0.301,1.5l0.199,0.9h-0.9c-1.2,0.301-7.505,7.805-8.405,10.107c-0.8,2.102-3.002,7.805-1.801,11.006
          c0.601,1.502,1.2,2.803,1.901,4.303c0.7,1.402,1.4,2.803,2.001,4.303c0.9,2.402,2.802,3.402,4.703,4.604
          c2.101,1.201,4.303,2.502,5.303,5.402c0.301,0.801,0.301,1.701,0.301,2.602c0,0.902,0,1.803,0.4,2.502c0.2,0.301,0.5,0.5,1,0.701
          c0.501,0.199,1.201,0.5,1.501,1.301c1.301,2.801-0.4,4.502-1.701,5.904c-1,1-1.9,1.9-1.801,3.201c1.201,0.1,2.302-0.1,3.302-0.301
          c2.102-0.5,4.203-0.9,5.604,2.602c0.601,1.701,0.501,3.604,0.4,5.404c-0.1,1.5-0.2,3.002,0.2,4.303
          c0.601,2.201,3.902,5.002,7.305,6.004c1.201,0.4,3.402,0.801,5.003-0.301c0.2-2.301,0.501-4.604,1.501-6.705l0.301-0.6l0.6,0.201
          c7.405,2.201,12.508,7.004,16.41,11.406l3.803,4.303c3.303,3.703,6.504,7.305,10.206,11.307c2.401,2.701,4.003,5.504,5.604,8.205
          c1.901,3.303,3.702,6.504,6.904,9.307l1.201,1c6.404,5.604,8.104,7.105,17.011,5.404c2.001-0.602,9.405-10.908,13.508-17.211
          l0.2-0.301h0.4c0.9,0,1.802,0,2.702,0c0.1-0.6,0.3-1.201,0.4-1.801c0.399-1.602,0.8-3.102,0.3-4.504
          c-0.3-0.699-0.9-1.199-1.501-1.699c-1.001-0.801-2.302-1.803-1.501-4.104c0.601-1.701,2.502-2.402,4.103-3.102
          c1.001-0.4,2.001-0.9,2.502-1.4c0.8-0.902,1.2-2.002,1.7-3.203c0.501-1.301,1.001-2.602,2.002-3.803l0.7-0.801
          c5.703-6.604,13.508-15.408,9.806-25.516l-0.399,0.502l-0.501-1.102c-1.101-2.402-1.301-5.203-1.601-7.805
          c-0.4-4.303-0.801-8.305-4.403-10.607c-0.8-0.5-1.801-0.9-2.701-1.301c-1.901-0.801-3.803-1.5-4.303-3.201
          c-0.3-1-0.101-2.201,0.801-3.703c0.5-0.801,0.9-1.301,1.301-1.701c0.601-0.6,1-1,1.301-2.102c0.2-0.799,0.2-1.9,0.2-2.9
          c0-0.701,0-1.502,0.1-2.201c0.801-5.705,1.901-12.107,5.504-16.711c4.103-5.104,10.906-9.707,14.608-12.008
          c0.601-0.4,1.401-0.5,2.202-0.701c0.6-0.1,1.601-0.4,1.801-0.6c0.4-0.4,0.4-0.9,0.4-1.602c0-0.699,0.1-1.4,0.6-2.1
          c1.602-1.902,4.203-1.803,6.404-1.602c1.001,0.1,1.901,0.1,2.802,0c1.201-0.1,2.201-0.4,3.303-0.701c1.801-0.5,3.702-1,6.003-0.801
          c3.503,0.4,4.303,2.102,5.004,3.604c0.5,1,0.9,2,2.101,2.801c1.501-1.801,2.602-3.803,3.702-5.703
          c0.901-1.602,1.901-3.303,3.002-4.803c3.402-4.604,6.604-3.102,9.706-1.701c0.4,0.199,0.801,0.4,1.301,0.6
          c-0.6-3.102-1.4-6.203-2.201-9.305c-1.501-5.705-3.002-11.607-3.102-17.512c-0.101-6.604-0.101-13.408,0-20.012
          c0-3.302,0-6.604,0-10.007c0-3.102-0.101-6.203-0.2-9.306c-0.1-3.001-0.2-6.104-0.2-9.205c0-1.101-0.2-2.802-0.3-4.703
          c-0.4-4.403-0.9-9.406,0.1-12.208c-1.601,0.2-2.901,0.9-4.202,1.602c-13.309,7.504-31.319-1.001-43.127,10.206
          c-6.204,5.903-9.906,13.809-15.109,20.513c-12.008,15.81-32.721,16.21-50.731,14.81c-6.604-0.501-13.509-1.001-20.113-0.501
          c-6.003,0.501-11.406,2.602-17.21,3.803c-5.304,1.101-10.907,1.101-16.311,0c-6.104-1.201-11.907-3.702-16.71-7.604
          c-3.803-3.103-6.504-7.305-9.506-11.107c-2.202-2.802-4.804-6.403-8.405-7.204c-4.203-0.9-7.104,3.202-8.306,6.604
          c-1.301,3.703,0.301,6.805,2.102,10.007c0.3,0.601,0.7,1.301,1.101,2.001c5.903,11.407,4.803,24.214-3.002,32.72
          c-5.804,6.305-11.106,7.506-18.312,7.506h-0.3c-4.303,0-7.905,0-11.808-1.402c-1.301-0.5-2.702-1.199-4.103-2
          c-1.201-0.602-2.401-1.301-3.502-1.801c0.1,0.299,0.2,0.699,0.2,1C831.223,569.573,831.123,570.772,831.123,571.874
          L831.123,571.874z"
      ></path>
      <text
        onClick={locateUser}
        borough="Greenwich"
        transform="matrix(1 0 0 1 905.2852 580.3384)"
        fontSize="27.7821"
      >
        Greenwich
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Towerhamlets"
        className={"Towerhamlets" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Tower Hamlets"
        d="M841.529,410.873c-0.1,0.601-0.2,1.101-0.3,1.601c-0.601,2.202-1.901,3.202-3.303,4.303c-1,0.801-2.101,1.701-2.901,3.002
		c-2.102,3.503,0,7.104,1.701,10.007c0.3,0.5,0.601,1,0.801,1.4c2.101,3.902,3.602,6.504,6.804,9.706
		c1.201,1.201,2.502,2.302,3.803,3.402c2.001,1.701,4.103,3.402,5.604,5.304c2.501,3.302,3.102,7.304,3.702,11.206
		c0.601,3.903,1.2,7.806,3.702,10.907c2.201,2.702,5.403,5.003,8.505,7.204c5.104,3.703,10.407,7.405,11.508,13.209
		c0.3,1.4,0.2,2.802,0.1,4.303c-0.1,2.101-0.3,4.202,0.7,6.203c-7.604-2.701-16.51,2.202-20.012,8.706
		c-3.202,5.804-4.003,13.208-2.402,22.113c0.4,2.002,1.101,4.103,1.901,6.304c1.901,5.304,3.902,10.808,1.001,15.71
		c-3.502,6.104-13.408,7.305-19.312,6.203c-13.008-2.4-13.809-16.509-14.408-28.917c-0.2-4.402-0.4-8.505-1.201-11.907
		c-1.201-5.704-4.103-16.11-9.706-20.913c-2.902-2.502-6.704-3.803-10.907-3.803c-3.802,0-8.005,1.101-12.308,3.202
		c-4.202,2.102-8.205,4.803-12.107,7.305c-2.701,1.801-5.503,3.603-8.305,5.203c-6.404,3.702-12.508,3.902-20.413,0.601
		c-0.9-0.4-2.102-0.801-3.502-1.201c-4.203-1.4-10.707-3.502-12.008-6.704c-0.4-1-0.3-2.001,0.301-3.202
		c0.7-1.4,1.801-2.101,2.901-3.002c1.701-1.2,3.402-2.501,3.902-5.803c0.601-3.903-1.2-6.705-2.901-9.507
		c-0.601-1-1.201-2.001-1.701-3.001c-1.802-3.703-1.301-5.204-0.501-7.605c0.501-1.301,1.001-2.901,1.201-5.003
		c0.2-1.701,0.2-3.402,0.2-5.003c0-3.603,0-7.005,1.701-10.307c2.301-4.703,5.103-5.503,9.605-6.704l1.301-0.4
		c2.002-0.601,3.202-1.801,4.403-2.901c0.5-0.501,1-1.001,1.601-1.401l0.601-0.4c1.501-1.2,3.803-2.901,4.303-5.103
		c3.603-0.2,6.304-0.9,9.206-1.501c1.4-0.301,2.901-0.7,4.402-1.001c1.701-0.3,3.603-0.4,5.703-0.601
		c3.703-0.2,7.605-0.399,10.607-2.001c4.303-2.201,9.105-7.104,11.406-11.607c0.601-1.2,1.001-2.501,1.501-3.902
		c0.901-2.802,1.802-5.704,3.903-6.904c4.702,5.704,10.105,4.103,15.31,2.502c4.103-1.201,8.405-2.502,12.607-0.3L841.529,410.873
		L841.529,410.873z"
      ></path>
      <text
        onClick={locateUser}
        borough="Towerhamlets"
        transform="matrix(1 0 0 1 763.7822 461.9351)"
        fontSize="24.6952"
      >
        Tower
      </text>
      <text
        onClick={locateUser}
        borough="Towerhamlets"
        transform="matrix(1 0 0 1 763.7822 486.6304)"
        fontSize="24.6952"
      >
        Hamlets
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Hackney"
        className={"Hackney" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Hackney"
        d="M826.521,370.248c0,0.901,0,1.701-0.101,2.402c-0.1,3.802-0.2,6.104,3.102,9.606c0.801,0.8,1.501,1.501,2.202,2.201
		c1.801,1.801,3.401,3.402,4.603,5.704c2.502,4.803,5.304,13.108,5.304,18.912l-1.301-0.8c-4.703-2.501-9.307-1.201-13.709,0.2
		c-5.304,1.601-10.006,3.002-14.108-2.501l-0.301-0.5l-0.5,0.2c-3.102,1.301-4.303,4.903-5.304,8.005
		c-0.4,1.401-0.8,2.602-1.4,3.702c-2.201,4.303-6.704,8.906-10.707,11.007c-2.802,1.401-6.504,1.602-10.106,1.802
		c-2.101,0.1-4.103,0.2-5.903,0.6c-1.601,0.301-3.102,0.601-4.503,1.001c-3.002,0.7-5.804,1.401-9.605,1.501h-0.701v0.7
		c-0.1,1.802-2.301,3.502-3.802,4.604l-0.601,0.399c-0.601,0.501-1.201,1.001-1.701,1.501c-1.201,1.102-2.201,2.102-3.803,2.602
		l-1.301,0.4c-4.603,1.301-7.904,2.202-10.506,7.505c-1.802,3.702-1.901,7.205-1.901,11.007c0,0.9,0,1.801,0,2.702
		c-4.803-0.2-8.405-2.502-12.208-5.004c-1.801-1.2-3.702-2.401-5.703-3.401l-0.501-0.2c-5.903-2.902-12.607-6.204-13.809-13.909
		c-0.8-5.403,3.503-7.504,8.105-9.806c1.801-0.9,3.702-1.802,5.203-2.902c5.403-4.002,5.804-11.007,6.204-17.811
		c0.2-3.803,0.5-7.505,1.601-10.507c1.802-0.2,3.603,0,5.504,0.2c1.501,0.2,3.002,0.3,4.603,0.3h0.801l-0.101-0.8
		c-0.7-5.904-4.103-10.907-9.706-14.209c-1.9-1.101-3.902-1.601-5.804-2.102c-3.602-0.9-6.704-1.701-8.104-6.003
		c-0.601-1.901-1.001-3.703-1.401-5.404c-1.2-5.503-2.201-9.906-9.906-11.907c-5.503-1.401-10.105-4.903-12.508-9.406
		c2.402-0.4,4.403-2.501,5.904-4.303c0.9-1.101,1.201-2.001,1.4-2.802c0.2-0.5,0.301-1.101,0.601-1.701
		c0.501-0.9,1.201-1.701,1.802-2.602c0.7-0.9,1.4-1.801,1.9-2.702c1.301-2.802,1.901-7.805-0.7-10.406
		c1.501-1.301,5.604-1.501,8.705-1.701c1.602-0.1,2.902-0.2,3.903-0.3c2.101-0.4,4.303-0.8,6.403-1.101
		c2.702-0.4,5.304-0.9,7.604-1.301c3.402-0.701,7.005-1.201,10.407-1.701c5.303-0.8,10.807-1.501,15.81-3.102
		c1.301-0.4,2.401-1,3.402-1.701c1.2,2.102,2.301,4.303,3.402,6.604c1.601,3.202,3.201,6.604,5.203,9.606
		c2.501,3.602,5.604,5.904,8.605,8.105c1.301,1,2.701,2.001,4.103,3.102c2.401,2.001,5.303,5.003,6.504,7.104
		c0.4,0.8,0.601,1.901,0.7,3.102c0.2,1.601,0.4,3.302,1.501,4.703c3.402,4.002,11.307,3.502,16.511,3.202l1-0.1
		c1.001,0,1.802-0.1,2.702-0.2c5.303-0.3,7.704-0.5,12.708,2.802c1.4,0.9,2.901,2.201,4.103,3.302L826.521,370.248L826.521,370.248z"
      ></path>
      <text
        onClick={locateUser}
        borough="Hackney"
        transform="matrix(0.3419 0.9397 -0.9397 0.3419 728.6875 334.2275)"
        fontSize="27.7891"
      >
        Hackney
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Islington"
        className={"Islington" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Islington"
        d="M715.251,431.386c1.801-0.9,3.502-1.701,4.902-2.802c4.804-3.603,5.204-10.307,5.604-16.71
          c0.301-3.903,0.501-8.005,1.802-11.308l0.2-0.4l0.4-0.1c2.101-0.4,4.303-0.1,6.304,0.1c1.2,0.1,2.401,0.3,3.602,0.3
          c-0.8-5.104-4.002-9.406-8.905-12.208c-1.701-1-3.603-1.401-5.403-1.901c-3.702-0.901-7.505-1.901-9.105-6.904
          c-0.7-2.001-1.101-3.902-1.401-5.503c-1.2-5.403-2.001-9.006-8.805-10.707c-6.104-1.501-11.308-5.503-13.809-10.707l0.199-0.1
          c-1.101-0.2-2.301-0.8-3.401-1.801c-1.501-1.401-2.602-2.802-3.702-4.203c-1.501-1.801-2.902-3.502-4.903-5.104
          c-3.803-3.002-5.904-4.903-8.706-9.606c-4.603-7.905-11.807-5.003-19.512-2.101l-1.001,0.4c-4.202,1.601-7.604,4.403-10.606,6.804
          c-0.601,0.5-1.501,1.101-2.401,1.701c-2.602,1.801-6.204,4.303-6.704,6.304l-0.2,0.8l-0.2-0.1c-0.1,2.201-0.3,4.603-0.601,7.104
          c-0.5,5.403-1.101,10.907,0.101,15.51c1.301,5.003,4.902,9.105,8.305,13.108c1.701,2.001,3.502,4.002,5.003,6.204
          c2.502,3.602,3.903,5.904,3.103,10.207c-0.2,0.9-0.301,1.701-0.501,2.301c-0.6,2.702-0.6,2.702,2.702,5.003l0.9,0.601
          c5.504,3.802,8.906,12.208,11.407,18.412l0.3,0.7c1.001,2.502,1.201,6.104,1.301,9.806c0.2,5.404,0.501,11.107,3.603,12.508
          c0.601,0.301,1.401,0.2,2.201,0.101c0.4,0,0.801-0.101,1.201-0.101c0.9,0,1.901,0.2,2.702,0.901c1.5,1.301,1.4,2.501,1.301,3.502
          c0,0.601-0.101,1.2,0.199,1.801c0.801,1.401,1.802,2.502,2.902,3.702c1.301,1.301,2.502,2.702,3.502,4.703
          c1.501,3.103,2.602,3.902,4.303,5.003c0.9,0.601,2.001,1.401,3.402,2.602c1.4,1.301,3.902,6.305,4.002,9.606v-0.4
          c1.602,0,2.202-0.601,3.103-1.501c0.5-0.601,1.2-1.2,2.201-1.701c1.801-0.8,4.003-0.8,6.104-0.8c0.601,0,1.201,0,1.701,0
          c0.101-0.701,0.101-1.701,0.101-2.603c0-2.802,0.1-4.502,1.101-5.203c0.6-0.399,1.501-0.9,2.301-0.6
          c0.901,0.3,1.101,1.301,1.301,2.101c0.101,0.2,0.101,0.601,0.2,0.701c0.101,0,0.601,0.1,1.101,0.199
          c1.201,0.301,1.901,0.4,2.302,0.701c0.7,0.4,1.401,0.9,2.302,1.501c3.002,2.101,7.204,4.902,10.106,5.103
          c0.7-1.4,1.101-3.102,1.601-5.003c0.801-3.002,1.601-6.204,3.502-8.104c-1.001-0.601-1.901-1.201-2.901-1.802
          c-1.802-1.101-3.603-2.301-5.604-3.302l-0.501-0.2c-6.203-3.102-13.308-6.604-14.608-15.01
          C705.345,436.289,710.647,433.688,715.251,431.386L715.251,431.386z"
      ></path>
      <text
        onClick={locateUser}
        borough="Islington"
        transform="matrix(0.3419 0.9397 -0.9397 0.3419 650.7441 350.7026)"
        fontSize="27.7891"
      >
        Islington
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="City of London"
        className={"City of London" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="City of London"
        d="M737.164,500.429c0.901-1.701,2.102-2.602,3.303-3.502c1.601-1.201,2.901-2.201,3.302-4.803
		c0.5-3.402-1.101-5.904-2.702-8.506c-0.6-1-1.301-2.001-1.801-3.102c-2.102-4.203-1.401-6.304-0.5-8.806
		c0.4-1.301,0.9-2.701,1.101-4.703l0.1-0.7c-3.402-0.1-6.104-1.201-8.705-2.602c-1.801,1.601-2.602,4.703-3.402,7.705
		c-0.5,2.101-1.101,4.103-1.901,5.703l-0.2,0.4h-0.4c-3.401,0-8.005-3.102-11.307-5.403c-0.801-0.601-1.601-1.101-2.302-1.501
		c-0.2-0.1-1.301-0.4-1.901-0.5c-0.7-0.2-1.2-0.301-1.5-0.4c-0.601-0.301-0.801-1.001-1.001-1.701c-0.101-0.3-0.2-0.9-0.4-1.001
		c0,0-0.2,0-0.9,0.4c-0.4,0.3-0.4,2.702-0.4,4.003c0,1.501,0,2.802-0.3,3.602l-0.2,0.501h-0.501c-0.8,0-1.601,0-2.401,0
		c-2.102,0-4.002,0-5.503,0.7c-0.701,0.3-1.201,0.801-1.701,1.4c-0.9,0.901-1.802,2.002-4.203,1.901v-0.4
		c-0.1,0.601-0.2,1.101-0.5,1.501c-1.701,2.302-7.005,2.202-12.607,2.102c-3.903-0.1-8.006-0.2-9.807,0.7
		c-1.601,0.801-3.302,2.502-4.103,4.003c-1.4,2.701-0.9,3.102,0.601,4.402c0.7,0.601,1.501,1.301,2.301,2.401
		c0.801,1.001,1.201,2.202,1.501,3.303c0.501,1.501,1.001,2.901,2.302,3.802c3.603,2.202,10.707,0.301,14.509-0.2
		c7.005-0.9,14.109-1.801,21.214-1.101c7.204,0.701,14.309,2.401,21.213,4.604c3.902,1.301,7.805,2.501,11.107,2.401
		c-0.801-0.7-1.501-1.501-1.802-2.502C736.264,503.531,736.364,502.03,737.164,500.429z"
      ></path>
      <text
        onClick={locateUser}
        borough="City of London"
        transform="matrix(1 0 0 1 690.5557 496.8979)"
        fontSize="23.1518"
      >
        City
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Merton"
        className={"Merton" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Merton"
        d="M552.749,710.86c1.301-5.004,2.802-15.51,0.501-17.311c-2.202-1.602-10.007,2.102-13.809,3.902
		c-0.9,0.4-1.701,0.801-2.302,1.102c-1.101,0.5-2.102,1-3.002,1.5c-1.701,0.9-3.302,1.801-5.503,2.201l-2.102,0.4
		c-4.203,0.9-8.105,1.701-12.608,1.701h-3.502c-7.004,0-13.608-0.1-20.112,1.102c-1.501,0.299-3.102,0.199-4.703,0.199
		c-1.701-0.1-3.502-0.1-5.103,0.301c-2.702,0.699-5.104,2.602-7.605,4.402c-0.9,0.701-1.801,1.301-2.602,1.9
		c-5.303,3.604-14.108,9.506-20.513,9.506h-0.2v-0.699c-0.2,0.199-0.3,0.4-0.5,0.699c-0.801,0.902-1.501,1.602-2.201,2.102
		c-1.501,1.201-2.502,2.002-2.401,4.803c0,1.301,0.6,2.902,1.2,4.504s1.201,3.201,1.301,4.703c0.301,3.402,1.501,6.303,2.802,9.305
		c1.301,3.102,2.702,6.404,3.103,10.406c0.1,1.201,0.1,2.303,0.199,3.303c0,2.301,0.101,4.203,1.102,6.604
		c0.399,0.801,0.7,1.502,1.101,2.201c1,2.002,1.901,3.604,2.101,6.605c0.301,4.502,0.801,6.504,2.302,10.707l0.4,1.1
		c1.2,3.303,3.002,8.406,3.302,10.707c0.5,4.303-1.301,7.104-3.002,9.605c-2.201,3.402-3.802,5.904,0.601,10.908
		c1.201,1.301,2.802,2.701,4.503,4.102c3.102,2.602,6.604,5.404,8.005,9.006c0.3,0,0.7,0,1.001,0c0.6,0,1.2-0.1,1.801-0.1
		c0.9,0,1.801,0.1,2.602,0.299c4.003,1.201,3.702,3.703,3.402,6.205c-0.101,0.5-0.101,1-0.101,1.5
		c-0.2,3.402,0.801,4.604,3.402,6.705c2.201,1.701,4.403,3.201,6.604,4.602c2.501,1.602,5.003,3.303,7.505,5.305
		c0.5,0.4,0.9,0.801,1.4,1.301c1.801,1.701,3.702,3.402,6.104,3.102c1.501-0.201,3.002-1.801,4.403-3.303
		c1-1,2.001-2.102,3.002-2.801c2.802-1.902,2.802-2.002,2.602-3.703c-0.101-0.6-0.2-1.5-0.2-2.701c0-2.301,1.2-3.402,2.201-4.504
		c0.801-0.799,1.501-1.5,2.001-2.801l0.101-0.4l0.4-0.1c1.801-0.301,3.502,0.699,5.103,1.701c0.601,0.299,1.101,0.699,1.602,0.9
		c1.101,0.5,2.101,1.201,3.102,1.801c0.9,0.6,1.801,1.201,2.702,1.602c2.701,1.301,5.103-0.801,7.704-2.902
		c0.9-0.801,1.802-1.5,2.802-2.201c3.702-2.402,5.604-0.701,7.505,1c1.301,1.201,2.602,2.402,4.703,2.803
		c2.602,0.6,4.603-0.201,6.804-1.502c3.103-1.801,5.504-4.902,7.905-7.904c0.7-0.9,1.401-1.801,2.201-2.701
		c0.4-0.4,0.9-1.102,1.501-1.902c2.502-3.301,4.604-6.104,6.304-6.604c2.502-0.701,4.903,1,6.904,2.4
		c0.601,0.4,1.201,0.902,1.802,1.201c2.401,1.301,3.902,3.203,5.403,4.904c2.102,2.602,4.002,4.803,7.805,4.703
		c3.002-0.102,4.203-0.801,6.104-2.002c0.601-0.4,1.301-0.801,2.102-1.201c2.302-1.301,5.403-1.5,8.205-1.801
		c0.7-0.1,1.401-0.1,2.102-0.201c1.901-0.199,3.602-0.398,5.403-0.699c4.603-0.602,9.006-1.201,14.309-1.201c0.7,0,1.301,0,1.901,0
		c2.802,0,5.304-0.1,7.505,0.6c0.3,0,0.7-0.199,1.101-0.4c0.2-0.1,0.4-0.199,0.601-0.299c0.7-2.602,2.401-5.404,4.002-7.906
		c0.9-1.301,2.302-2.701,3.603-4.002c1.601-1.5,3.302-3.102,3.902-4.602c2.001-4.904-4.103-13.209-6.704-16.811l-0.2-0.301
		c-3.702-5.104-6.604-14.51-1.301-19.613c1.101-1,1.901-1.6,2.701-2.201c1.201-0.9,2.002-1.4,3.303-3.602l0.4-0.701
		c-0.601-0.1-1.101-0.199-1.602-0.299c-2.501-0.5-4.202-0.801-6.704,1c-3.603,2.602-6.404,4.502-11.007,2.102
		c-0.5-0.301-0.9-0.5-1.301-0.701c-2.001-1.1-2.901-1.6-6.104-1.4h-0.601c-2.302,0.1-4.503,0.199-5.503-1.102
		c-0.701-0.9-0.601-2.301,0.2-4.201c0.8-1.902,1.801-3.303,2.802-4.604c1.101-1.4,1.9-2.602,1.7-3.602
		c-0.2-0.9-1.301-2.002-3.502-3.203c-2.401-1.4-5.003-2.201-7.505-3.102c-2.701-0.9-5.604-1.9-8.104-3.402
		c-0.601-0.301-1.201-0.801-1.901-1.301c-2.102-1.5-4.803-3.402-6.704-2.801c-1.901,0.6-2.401,4.902-2.201,7.604v0.801h-0.801
		c-5.503,0.1-11.808-3.201-17.511-6.203c-1.701-0.9-3.303-1.701-4.803-2.402c-1.201-0.6-2.702-1.1-4.303-1.701
		c-5.104-1.9-11.508-4.203-13.209-9.406c-0.4-1.1-0.4-3.301-0.5-5.803c-0.1-4.002-0.2-10.607-2.302-10.607l0,0
		c-0.6,0-1.301,0.602-2.001,1.201c-1.301,1.102-3.102,2.701-5.703,0.801c-2.502-1.9-1.501-5.703-0.9-7.904L552.749,710.86
		L552.749,710.86z"
      ></path>
      <text
        onClick={locateUser}
        borough="Merton"
        transform="matrix(1 0 0 1 493.1865 785.6929)"
        fontSize="27.7821"
      >
        Merton
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Lewisham"
        className={"Lewisham" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Lewisham"
        d="M829.021,566.77c0.2,0.6,0.4,1.201,0.5,1.801c0.101,1.102,0.101,2.102,0,3.203c-0.1,2.301-0.2,4.602,1.602,6.703
		c1.301,1.502,3.002,2.002,4.503,2.402c1,0.301,1.901,0.6,2.602,1.1c1.801,1.201,2.401,2.902,2.301,5.705c-0.1,1.9-0.3,2-0.7,2.1
		c-0.4,0.201-1.001,0.502-1.701,1.402c-2.602,3.602-0.9,5.803,0.7,7.904c0.501,0.6,0.901,1.201,1.401,1.9
		c0.601,1.002,1.001,2.303,1.401,3.703c0.9,3.002,1.9,6.305,5.803,7.104c1.401,0.301,2.502,0.102,3.303-0.6
		c1.601-1.4,1.301-4.303,1.101-6.904c-0.101-0.701-0.101-1.4-0.101-2.002c4.203-0.199,8.506-0.199,12.608-0.1
		c6.204,0,12.607,0.1,18.812-0.6c1.301-0.1,2.602-0.4,3.902-0.602c2.502-0.398,5.003-0.9,7.604-0.9h0.101
		c2.201,0,3.902-0.6,5.503-1.199c0.901-0.301,1.701-0.602,2.502-0.801c-0.101,0.699-0.5,1.201-0.9,1.801
		c-0.501,0.701-1.001,1.5-1.201,2.502c-0.4,1.701,0,3.301,0.4,4.703c0.101,0.299,0.101,0.5,0.2,0.799
		c-2.802,1.602-8.405,9.307-8.905,10.707c-1.501,3.902-3.103,8.807-1.802,12.107c0.601,1.502,1.301,3.002,2.002,4.404
		c0.7,1.301,1.301,2.701,1.9,4.201c1.102,2.902,3.303,4.104,5.404,5.305c2.001,1.1,3.802,2.201,4.603,4.602
		c0.2,0.602,0.2,1.402,0.2,2.102c0,1.102,0,2.201,0.6,3.102c0.4,0.801,1.201,1.102,1.701,1.402c0.4,0.199,0.701,0.299,0.801,0.5
		c0.801,1.801,0,2.701-1.4,4.201c-1.201,1.301-2.602,2.703-2.102,5.104l0.1,0.5l0.5,0.102c1.701,0.299,3.202,0,4.403-0.301
		c2.001-0.5,3.002-0.701,3.902,1.701c0.5,1.4,0.4,3.102,0.3,4.803c-0.1,1.602-0.199,3.201,0.2,4.703
		c0.701,2.701,4.403,5.904,8.306,7.104c2.001,0.602,3.803,0.602,5.203,0.102c-0.2,2-0.5,4.002-1.201,5.703
		c-0.3,0.801-1.301,1.9-2.201,3.002c-1.9,2.301-3.602,4.203-2.802,5.604c0.601,1,2.102,1.201,5.003,0.801
		c0.901,3.102,2.502,5.303,4.903,6.803c2.802,1.701,6.404,2.201,10.507,1.301c0.2,1.602,0.7,3.902,1.301,6.504
		c1.501,6.805,3.803,17.111,0.9,19.613c-0.9,0.801-2.301,0.701-4.303-0.1c-2.001-0.801-4.002-2.703-6.004-4.604
		c-2.001-2.002-4.103-4.002-6.504-5.104c-6.304-2.902-12.508-1.201-17.311,0.602c-1.101,0.4-1.801,0.5-2.502,0.6
		c-1.601,0.199-2.602,0.5-4.303,2.902c-1.101,1.5-1.2,3.201-1.301,4.803c-0.1,1.4-0.2,2.701-1,3.502
		c-1.401,1.602-2.902,2.301-4.503,3.102c-2.201,1.102-4.503,2.201-6.504,5.404c-0.7,1.1-0.801,2.102-1.001,2.9
		c-0.2,1.201-0.301,2.102-1.601,3.203c-0.801,0.699-3.002,1.4-4.703,1.9c-1.201,0.4-2.302,0.701-3.103,1.102
		c-1.4,0.699-2.801,1.4-4.202,2.102c-4.103,2.102-7.905,4.102-12.308,5.203c-4.703,1.301-8.905,0.5-14.009-2.703
		c-5.104-3.201-5.104-5.803-5.104-11.105c0-1.002,0-2.102-0.1-3.303c-0.2-5.303-2.401-9.605-6.504-12.207
		c-2.802-1.902-6.404-2.803-10.307-2.803c-3.102,0-6.304,0.602-9.406,1.801c-2.901,1.102-5.403,2.402-7.805,3.504
		c-7.204,3.502-12.908,6.303-23.414,3.002c-2.002-0.602-4.103-1.301-6.204-2.002c-8.506-2.902-18.212-6.104-27.217-6.604
		c-1.301-3.504,1.2-10.707,3.602-13.209c1.001-1,2.202-1.801,3.603-2.602c1.401-0.9,2.902-1.801,4.103-3.002
		c2.001-2.201,3.702-5.004,5.403-7.605c0.7-1.1,1.301-2.1,1.901-3.102l0.2-0.299l-0.101-0.301c-1.2-4.904-0.399-12.709,0.701-18.312
		c1.101-5.502,3.002-11.506,9.105-14.908c1.901,2.4,4.103,1.4,5.903,0.699c0.601-0.299,1.201-0.5,1.802-0.699
		c1.701-0.4,3.002-0.5,4.303-0.602c2.802-0.199,4.902-0.299,7.604-4.201c1.501-2.102,3.802-6.205,2.802-10.406
		c-0.301-1.502-1.001-2.703-1.701-3.803c-0.7-1.102-1.301-2.201-1.602-3.604c-0.5-2.4-0.399-5.102-0.399-7.703
		c0-1.002,0-1.902,0-2.902c0-4.002-1.501-6.004-3.603-8.807l-0.601-0.799c-4.503-6.205-4.703-11.207-5.103-18.812
		c-0.2-4.703-1.501-8.906-2.602-12.908c-1.102-3.602-2.202-7.404-2.502-11.508c-0.4-4.502-0.801-10.307-0.4-15.809
		c0.2-2.502,1.401-3.502,2.702-4.604c1.101-0.9,2.301-2.002,3.001-3.902c1.001,0,2.302,0.199,3.603,0.5
		c2.602,0.5,5.304,0.9,7.104,0.1c1.701-0.799,2.302-2.5,2.902-4.002c0.6-1.5,1.101-2.902,2.501-3.602
		c2.102-1.101,7.104-1.301,9.206-0.4c1.601,0.7,2.401,2.401,3.302,4.303c0.4,0.801,0.801,1.701,1.301,2.502
		c1.001,1.701,2.401,3.301,3.803,5.002c1.601,1.801,3.202,3.703,4.202,5.703L829.021,566.77L829.021,566.77z"
      ></path>
      <text
        onClick={locateUser}
        borough="Lewisham"
        transform="matrix(1 0 0 1 786.8086 700.9634)"
        fontSize="27.7821"
      >
        Lewisham
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Southwark"
        className={"Southwark" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Southwark"
        d="M690.836,512.136c2.602,4.604,0.8,11.308,0.3,13.309c-0.601,1.901-1.201,3.603-1.901,5.304
		c-0.601,1.601-1.301,3.302-1.801,5.103c-0.9,3.103-1.201,5.504,0.7,7.805c1.801,2.202,6.004,4.903,7.305,5.604
		c0.601,0.4,1.2,0.501,1.601,0.601c1.201,0.301,1.901,0.6,2.202,2.502c0.3,1.701-0.801,2.9-1.602,3.801
		c-0.2,0.301-0.5,0.602-0.7,0.902l-0.101,0.199c-3.401,4.803-6.504,9.406-3.702,15.01c0.301,0.6,0.9,1.4,1.602,2.301
		c1.9,2.602,3.302,4.604,3.001,6.104c-0.3,2.002-2.301,2.703-3.802,3.203c-0.5,0.199-1.501,0.5-1.601,0.801c0,0-0.101,0.5,1.5,1.9
		c0.701,0.701,1.501,1.201,2.202,1.701c1.2,0.9,2.501,1.9,3.702,3.303c2.001,2.5,4.303,4.902,7.404,7.805
		c9.006,8.404,18.812,20.912,14.009,32.619c-2.102,5.004-5.003,10.508-8.905,16.811c-1.001,1.602-2.102,2.803-3.202,4.002
		c-2.502,2.803-4.503,5.004-3.302,9.607c0.9,3.602,3.002,6.604,5.203,9.906c1.601,2.4,3.302,4.803,4.402,7.504
		c2.702,6.205,5.203,12.908,7.104,19.312c0.301,0.9,0.501,1.801,0.801,2.602c1.4,4.604,2.802,9.006,3.302,14.109
		c0.101,1.301,0.4,4.002,1.301,5.203c0.601,0.799,1.501,1.1,2.502,1.4c0.9,0.301,1.901,0.6,2.701,1.4
		c1.802,1.801,2.102,4.604,2.402,7.305c0.199,2.201,0.5,4.402,1.5,5.904c0.601,0.9,1.401,1.301,2.302,1.801
		c0.601,0.4,1.301,0.701,1.901,1.301c0.4,0.4,0.9,0.801,1.301,1.301c1.001,1,1.901,2.002,3.102,2.301l-0.1,0.301
		c2.602-4.502,5.104-10.006,5.503-14.309c-1.601-4.203,1.101-11.908,3.903-14.809c1.101-1.102,2.501-2.002,3.902-2.803
		c1.4-0.9,2.802-1.701,3.702-2.701c1.901-2.102,3.602-4.803,5.203-7.404c0.601-1.002,1.2-1.902,1.801-2.803
		c-1.101-5.104-0.4-13.008,0.801-18.711c1.201-6.004,3.402-12.607,10.406-16.211l0.601-0.301l0.4,0.602c1.2,1.9,2.401,1.5,4.503,0.6
		c0.7-0.299,1.301-0.6,2.001-0.699c1.801-0.502,3.202-0.602,4.503-0.602c2.602-0.199,4.202-0.299,6.504-3.502
		c1.101-1.5,3.402-5.504,2.602-9.205c-0.3-1.301-0.9-2.303-1.501-3.303c-0.7-1.201-1.501-2.4-1.801-4.102
		c-0.501-2.602-0.501-5.404-0.4-8.006c0-0.9,0-1.9,0-2.801c0-3.504-1.301-5.205-3.302-7.906l-0.601-0.801
		c-4.803-6.504-5.003-12.006-5.403-19.611c-0.2-4.504-1.401-8.406-2.602-12.508c-1.101-3.703-2.202-7.605-2.602-11.807
		c-0.4-4.504-0.801-10.508-0.4-16.012c0.2-3.102,1.801-4.402,3.202-5.604c1.101-1,2.201-1.9,2.802-3.701l0.2-0.5h0.5
		c1.301-0.1,2.802,0.199,4.402,0.5c2.302,0.4,4.903,0.9,6.204,0.199c1.201-0.6,1.701-1.801,2.201-3.301
		c0.601-1.602,1.301-3.403,3.202-4.303c2.302-1.201,7.805-1.601,10.406-0.5c1.201,0.5,2.002,1.4,2.702,2.401
		c0.2-8.105-0.3-16.009-0.7-24.115c-0.301-5.104-0.301-11.106-3.902-15.209c-7.605-8.706-18.312-0.101-24.016,6.203
		c-4.503,4.903-9.105,10.007-16.01,10.707c-10.906,1.001-21.714-3.202-32.12-7.305c-4.503-1.801-8.705-3.402-13.008-4.703
		c-2.502-0.7-4.803-1.601-7.005-2.401c-5.203-1.901-10.105-3.702-16.91-4.002c-5.504-0.301-11.707-0.4-16.91,1.301
		C689.435,510.235,690.235,511.136,690.836,512.136L690.836,512.136z"
      ></path>
      <text
        onClick={locateUser}
        borough="Southwark"
        transform="matrix(0.3419 0.9397 -0.9397 0.3419 715.5693 538.3921)"
        fontSize="27.7891"
      >
        Southwark
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Haringey"
        className={"Haringey" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Haringey"
        d="M711.948,324.519c1.401-0.1,2.802-0.2,3.703-0.3c2.101-0.4,4.303-0.801,6.504-1.101c2.701-0.4,5.303-0.9,7.504-1.301
		c3.402-0.7,7.005-1.201,10.507-1.701c5.304-0.701,10.707-1.501,15.61-3.002c4.603-1.401,6.604-5.704,8.805-10.207
		c1.301-2.702,2.702-5.503,4.604-7.805c2.001-2.401,4.303-5.203,5.804-8.605c1.4-3.002,0.9-4.703,0.2-7.104
		c-0.301-1-0.701-2.201-0.901-3.602c-1.501-9.806,3.603-16.11,8.605-22.114c4.003-4.903,8.205-10.006,9.006-17.111
		c-2.102-0.4-4.003-1.601-5.903-2.802c-0.901-0.6-1.701-1.101-2.502-1.501c-11.607-5.904-24.916-4.703-37.823-3.402
		c-3.402,0.3-6.805,0.7-10.207,0.8c-12.207,0.701-24.715,0.601-36.822,0.5c-4.703,0-9.507-0.1-14.209-0.1
		c-8.005,0-15.811-0.5-23.415-1.001c-2.501-0.2-5.003-0.3-7.505-0.5c-4.702-0.3-9.105-1.401-13.308-2.602l-0.9-0.2
		c-3.002-0.801-6.705-0.701-10.207-0.601c-0.801,0-1.701,0.1-2.501,0.1c0.1,0.4,0.1,0.701,0.2,1.201
		c0.3,3.102-0.801,3.603-2.302,4.103c-0.9,0.3-1.802,0.5-2.602,1.901c-0.601,1.101-0.301,4.503-0.101,6.504
		c0.101,0.5,0.101,0.901,0.101,1.301c2.602,1.401,3.502,3.803,2.602,7.004c-1.802,6.204-10.807,14.609-16.711,13.909h-0.399
		l-0.2-0.4c-0.4-0.901-0.801-2.502-1.302-4.503c-1.101-4.403-2.901-11.908-5.403-13.408c-0.399-0.2-0.8-0.3-1.301-0.2
		c-0.9,0.3-2.602,3.402-5.103,9.306c-0.2,0.6-0.4,1-0.5,1.301l-0.501,1.101c-2.102,4.503-4.202,9.206-2.802,14.109
		c0.4,1.401,1.201,2.602,2.102,3.902c1.4,2.001,2.802,4.103,2.802,6.904c0,1.301-0.4,2.202-0.801,3.102c-0.5,1-0.8,1.801-0.7,3.002
		c0.1,1,0.9,1.701,1.801,2.401c0.801,0.601,1.602,1.301,1.802,2.301c1.101,4.403-3.303,7.405-7.605,10.407
		c-3.302,2.301-6.804,4.703-7.604,7.504c-0.5,1.801-0.9,3.803-1.2,5.604c-0.4,2.302-0.701,4.403-1.401,6.404
		c-0.5,1.201-0.801,2.602-1.201,4.002c-0.5,1.801-1,3.702-1.7,5.403c1.2,0,2.301,0,3.502,0c3.402,0,6.904-0.1,10.106,0
		c4.002,0.2,6.304,1.201,8.805,2.301c1.301,0.601,2.602,1.101,4.203,1.601c2.502,0.701,5.203,0.9,7.805,1.101
		c1.801,0.1,3.603,0.2,5.304,0.5c3.502,0.6,6.804,2.001,10.006,3.502c0.9,0.4,1.801,0.801,2.602,1.201
		c1.101-2.301,4.303-4.502,7.005-6.404c0.9-0.6,1.7-1.201,2.301-1.701c3.103-2.501,6.604-5.303,11.007-7.004l1.001-0.4
		c3.902-1.501,8.005-3.102,11.808-3.102c3.602,0,6.904,1.401,9.506,5.804s4.603,6.304,8.305,9.105
		c2.201,1.701,3.702,3.603,5.203,5.403c1.101,1.301,2.202,2.702,3.603,4.002c1.101,1.001,2.201,1.501,3.302,1.401
		c2.002-0.1,4.003-2.201,5.203-3.802c0.701-0.9,0.901-1.501,1.101-2.301c0.2-0.601,0.301-1.201,0.801-2.001
		c0.5-1,1.301-1.901,2.001-2.802c0.701-0.9,1.301-1.701,1.701-2.401c1.201-2.602,1.602-7.305-0.8-9.005l-0.501-0.4l0.301-0.601
		C703.043,325.02,707.746,324.819,711.948,324.519z"
      ></path>
      <text
        onClick={locateUser}
        borough="Haringey"
        transform="matrix(1 0 0 1 628.3643 289.9907)"
        fontSize="27.7821"
      >
        Haringey
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Lambeth"
        className={"Lambeth" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Lambeth"
        d="M660.116,570.172c0.4,1.801-0.601,3.602-1.501,5.104c-0.5,0.801-0.9,1.602-1.101,2.301c-0.9,3.002-1.801,3.902-3.202,5.404
		c-0.4,0.4-0.8,0.9-1.4,1.4c-2.401,2.701-3.303,5.703-4.303,9.006c-0.601,2.102-1.301,4.303-2.302,6.404
		c-1.501,3.102-3.803,4.703-6.304,6.604c-0.5,0.4-1.101,0.801-1.601,1.201c-5.004,3.803-10.007,8.205-13.909,12.408
		c-4.103,4.402-3.402,8.205-2.401,13.008c0.2,1.199,0.5,2.5,0.7,3.801c0.801,5.604,1.601,12.008,2.001,18.012
		c0.301,4.803,0.301,4.803,3.503,7.305l0.5,0.4c3.102,2.402,2.802,3.803,1.801,6.305c-0.2,0.6-0.5,1.199-0.7,2
		c-0.9,3.002-0.7,7.705,0.1,10.508l0.2,0.699c0.701,2.502,1.802,6.605,3.503,7.605c1.101,0.701,3.002,0.5,4.803,0.301
		c1.901-0.201,3.902-0.4,5.503,0.4c0.4,0.199,0.801,0.299,1.001,0.4c0.5,0.199,0.9,0.398,0.9,0.9v0.5l-0.5,0.299
		c-0.2,0.102-0.4,0.201-0.4,0.801c-0.2,2.201-0.4,4.303-0.801,5.305c-0.6,1.6-1.601,2.4-2.501,3.102c-1.201,1-2.102,1.6-1.701,4.303
		c0.3,2.201,1.801,3.803,3.402,5.604c1.801,1.9,3.602,3.902,3.602,6.703c0,2.602-1.4,3.402-2.501,4.004
		c-0.601,0.299-1.201,0.699-1.602,1.301c-1.301,1.9-0.9,5.203-0.5,8.205c0.1,1.199,0.3,2.4,0.3,3.4c0,2.902,0.301,5.604,0.701,7.807
		c0.1,0.299,0.2,0.6,0.3,1c0.4,1.4,0.9,3.303,0,5.203c-0.9,1.801-2.401,3.402-3.803,4.902c-1.301,1.402-2.701,2.902-3.502,4.404
		l-0.3-0.201v0.1c0.3,1.701-0.7,3.102-2.001,4.803c-0.901,1.201-1.901,2.602-2.602,4.303c-0.601,1.301-0.701,2.303-0.301,2.703
		c0.5,0.699,2.502,0.6,4.203,0.5h0.6c0.4,0,0.801,0,1.101,0c2.702,0,3.903,0.6,5.704,1.6c0.4,0.201,0.801,0.4,1.301,0.701
		c3.902,2.002,5.903,0.5,9.406-1.9c3.102-2.201,5.303-1.801,7.904-1.301c0.701,0.1,1.301,0.299,2.102,0.4
		c1.201-2.102,2.401-4.203,3.803-5.904c2.101-2.502,4.303-4.902,6.403-7.205c2.502-2.701,4.804-5.203,6.904-7.904
		c1.001-1.4,1.602-2.502,2.002-3.502c1.2-2.502,1.9-3.703,7.004-3.703c3.102,0,6.204-0.199,9.206-0.4l3.002-0.199
		c1.501-0.1,3.102-0.201,4.702-0.4c6.404-0.602,13.009-1.201,17.611,2.4c0.801,0.602,1.501,1.301,2.302,2.102
		c1.801,1.701,3.602,3.604,5.604,3.803c1.601,0.201,3.502-0.301,5.503-0.9c2.001-0.5,4.003-1.201,6.104-1
		c0.501-0.701,1.001-1.502,1.501-2.402c-1.501-0.5-2.501-1.602-3.502-2.602c-0.4-0.4-0.801-0.801-1.2-1.201
		c-0.501-0.4-1.001-0.699-1.602-1.1c-1-0.602-2.001-1.102-2.701-2.303c-1.301-1.801-1.501-4.201-1.802-6.604
		c-0.3-2.502-0.5-4.902-2.001-6.404c-0.5-0.5-1.301-0.801-2.102-1c-1.101-0.301-2.301-0.701-3.202-1.9
		c-1.2-1.502-1.5-4.404-1.601-6.004c-0.5-5.004-1.801-9.307-3.202-13.809c-0.3-0.9-0.5-1.701-0.8-2.602
		c-1.901-6.404-4.403-13.01-7.104-19.113c-1.101-2.602-2.802-5.002-4.303-7.305c-2.201-3.201-4.403-6.504-5.403-10.307
		c-1.401-5.303,1.101-8.104,3.702-11.006c1-1.201,2.102-2.402,3.002-3.803c3.902-6.203,6.804-11.607,8.805-16.609
		c4.503-10.908-5.003-22.814-13.608-30.92c-3.201-2.902-5.503-5.404-7.604-8.006c-1.101-1.301-2.201-2.201-3.402-3.102
		c-0.7-0.6-1.5-1.1-2.301-1.801c-1.602-1.4-2.201-2.4-2.002-3.303c0.2-1.1,1.401-1.4,2.502-1.801c1.501-0.5,2.602-1,2.802-2.102
		c0.2-1-1.601-3.4-2.802-5.002c-0.7-1-1.4-1.801-1.701-2.502c-3.302-6.404,0.301-11.508,3.803-16.51l0.1-0.201
		c0.2-0.299,0.501-0.6,0.801-1c0.7-0.9,1.4-1.602,1.201-2.602c-0.2-1.102-0.301-1.102-1.102-1.301c-0.5-0.1-1.2-0.301-2.001-0.801
		c-1.701-1-5.703-3.602-7.604-6.003c-2.401-2.902-1.901-6.104-1.001-9.206c0.601-1.901,1.201-3.602,1.802-5.203
		c0.6-1.601,1.301-3.302,1.801-5.203c0.5-1.801,2.102-8.105-0.1-12.208c-0.901-1.601-2.302-2.602-4.103-3.102
		c-3.002-0.801-5.704-0.4-8.105,1.301c-6.304,4.603-8.505,17.11-8.705,23.015c-0.101,1.4-0.101,2.701-0.2,4.002
		c-0.2,4.903-0.301,9.506-0.9,14.209C667.521,552.362,666.12,566.069,660.116,570.172L660.116,570.172z"
      ></path>
      <text
        onClick={locateUser}
        borough="Lambeth"
        transform="matrix(0.3419 0.9397 -0.9397 0.3419 650.7432 625.1978)"
        fontSize="27.7891"
      >
        Lambeth
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Wandsworth"
        className={"Wandsworth" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Wandsworth"
        d="M624.294,579.377c-4.703,0-9.306,0.102-13.809,0.801c-6.504,1.002-12.808,2.902-19.111,4.904
		c-5.304,1.701-11.008,4.002-14.409,8.705c-3.103,4.303-4.604,10.307-5.804,15.609l-0.101,0.199
		c-2.802,11.709-12.207,22.215-24.215,24.615c-6.304,1.301-13.408,1.201-19.612-0.4c-3.502-0.9-7.004-2.201-10.206-3.701
		c-7.905-3.902-14.309-10.006-20.913-15.609c-0.601-0.5-1.701-2.002-2.401-2.303c-4.403-1.301-8.906-2.1-13.608-2
		c-0.101,3.002-0.101,6.104-0.101,9.105c0,3.303,0.101,6.604-0.1,9.906v0.801l-0.801-0.102c-4.402-0.398-8.806-0.9-13.208-1.5
		c-3.402-0.4-6.904-0.9-10.307-1.201c-9.806-1-12.008,0.301-15.51,8.906c-0.4,1.1-1,2.301-1.501,3.502
		c-2.701,5.904-6.004,13.209-2.101,18.512c1.801,2.301,5.003,4.402,8.205,6.504c2.901,1.9,5.903,3.803,8.005,6.004
		c4.303,4.604,6.504,9.006,8.605,14.508c2.701,7.105,2.301,7.705-2.702,10.707c-0.601,0.4-1.301,0.801-2.102,1.301
		c-4.402,2.803-8.505,6.205-12.508,9.707c0.701,1.602,2.102,2.801,3.503,4.102c2.602,2.303,5.403,4.803,2.901,9.105
		c5.903-0.199,14.509-6.104,19.312-9.305c0.8-0.602,1.7-1.201,2.602-1.902c2.501-1.9,5.103-3.902,8.104-4.602
		c1.801-0.4,3.702-0.4,5.504-0.301c1.601,0.1,3.102,0.1,4.402-0.1c6.604-1.201,13.608-1.201,20.413-1.102h3.502
		c4.303,0,8.205-0.801,12.308-1.701l2.102-0.4c2.001-0.398,3.401-1.199,5.103-2.1c1.001-0.502,2.002-1.102,3.103-1.602
		c0.5-0.201,1.301-0.6,2.201-1c6.304-3.002,12.607-5.805,15.31-3.803c4.002,3.002,0.1,18.711,0.1,18.912l-0.1,0.5
		c-0.601,2-1.401,5.104,0.3,6.404c1.501,1.1,2.401,0.5,3.803-0.701c0.9-0.801,1.901-1.602,3.002-1.602
		c3.402,0.102,3.602,6.504,3.702,12.107c0.1,2.303,0.1,4.404,0.4,5.305c1.501,4.602,7.204,6.703,12.308,8.504
		c1.601,0.602,3.102,1.102,4.402,1.701c1.501,0.701,3.103,1.502,4.804,2.502c5.203,2.701,11.106,5.805,16.01,6.004
		c0-2.201,0.3-7.305,3.202-8.305c0.399-0.1,0.9-0.201,1.301-0.201c2.301,0,4.702,1.701,6.704,3.203c0.7,0.5,1.301,0.9,1.801,1.301
		c2.401,1.5,5.104,2.4,7.805,3.301c2.602,0.9,5.304,1.803,7.805,3.203c1.701,1,2.902,1.9,3.603,2.801
		c0.9-1.4,2.102-2.801,3.302-4.002c1.401-1.5,2.802-3.002,3.603-4.604c0.7-1.4,0.3-2.801-0.1-4.102
		c-0.101-0.4-0.2-0.801-0.301-1.102c-0.5-2.301-0.7-5.102-0.7-8.104c0-0.902-0.1-2.002-0.3-3.203c-0.4-3.201-0.801-6.805,0.8-9.205
		c0.601-0.9,1.401-1.4,2.102-1.701c1.101-0.602,1.801-1,1.801-2.701c0-2.203-1.501-3.902-3.201-5.705
		c-1.602-1.801-3.402-3.701-3.803-6.303c-0.5-3.502,0.9-4.604,2.201-5.703c0.801-0.602,1.602-1.303,2.102-2.502
		c0.4-0.9,0.601-3.803,0.601-4.703c0-0.602,0.2-1.102,0.399-1.4l-0.5-0.201c-1.2-0.5-3.002-0.4-4.703-0.199
		c-2.101,0.199-4.202,0.4-5.703-0.502c-2.201-1.301-3.402-5.604-4.103-8.504l-0.2-0.701c-0.801-3.002-1.101-8.004-0.1-11.406
		c0.3-0.801,0.5-1.502,0.8-2.102c0.9-2.201,1.101-2.701-1.301-4.604l-0.5-0.4c-3.603-2.801-3.803-3.102-4.103-8.404
		c-0.301-5.904-1.201-12.309-1.901-17.912c-0.2-1.301-0.4-2.502-0.7-3.701c-1.001-5.104-1.901-9.406,2.802-14.311
		c4.002-4.201,8.905-8.605,14.009-12.508c0.6-0.4,1.101-0.799,1.601-1.199c2.502-1.902,4.503-3.303,5.903-6.104
		c1.001-2.002,1.602-4.104,2.202-6.205c1-3.303,2.001-6.703,4.603-9.605c0.5-0.602,1.001-1.102,1.401-1.502
		c1.4-1.4,2.101-2.1,2.901-4.803c0.3-0.801,0.7-1.701,1.201-2.602c0.7-1.201,1.4-2.502,1.4-3.701c0,0.4-2.302,1.801-2.602,2.102
		c-0.9,0.699-1.901,1.301-2.901,1.801C644.507,579.479,634.3,579.278,624.294,579.377L624.294,579.377z"
      ></path>
      <text
        onClick={locateUser}
        borough="Wandsworth"
        transform="matrix(1 0 0 1 463.9053 670.0591)"
        fontSize="27.7821"
      >
        Wandsworth
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Westminster"
        className={"Westminster" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Westminster"
        d="M666.82,498.228c-0.4-1.101-0.7-2.102-1.301-2.901c-0.5-0.701-1.101-1.201-1.601-1.701c-0.4,0.399-0.801,0.8-1.101,1.301
		c-1.401,1.801-2.802,3.401-6.604,2.301c-2.201-0.601-3.902-3.002-5.503-5.103c-0.501-0.601-0.901-1.301-1.401-1.802
		c-2.001-2.301-4.903-4.803-7.805-7.104c-2.102-1.701-4.303-3.502-6.004-5.303c-2.802-2.802-4.202-4.604-6.404-7.805
		c-0.9-1.401-2.101-2.202-3.502-3.103c-1.101-0.7-2.301-1.501-3.402-2.701c-3.602-3.702-5.403-10.407-6.904-15.811
		c-0.2-0.6-0.4-1.301-0.5-1.801l-0.3,1.101l-0.601-2.802c-0.2-0.9-0.4-1.701-0.5-2.501c-0.801-4.503-1.401-7.205-6.805-8.006
		c-2.602-0.399-5.104,0-7.705,0.4c-2.301,0.4-4.603,0.701-7.004,0.601c-3.603-0.2-5.403-1.501-7.305-2.802
		c-1.001-0.7-2.001-1.4-3.402-2.102c-1.2-0.6-2.501-0.8-3.802-0.9c-2.402-0.3-4.903-0.7-6.204-4.002
		c-7.604-0.301-9.906,0.8-14.909,7.104c-1.802,2.201-5.304,6.003-9.406,5.804c-1.801,0-3.402-0.801-4.903-2.302
		c0,3.802-0.3,8.205-1,11.808c-0.4,2.001-1.401,4.002-2.302,5.803c-1.101,2.002-2.102,4.003-2.102,5.804h-1.501
		c-0.1-5.703-7.404-14.909-13.608-15.409c-3.202-0.2-6.204,0.9-9.306,2.001c-1,0.4-2.001,0.7-3.002,1.001
		c-4.903,1.501-6.204,3.702-5.703,9.306l0,0l0,0c1.4,3.603,4.402,3.902,7.904,4.303c2.202,0.2,4.503,0.5,6.505,1.701
		c1.801,1.101,2.901,2.602,4.002,4.103c0.5,0.7,1.001,1.4,1.601,2.102c0.501,0.5,0.901,0.9,1.201,1.301
		c1.801,1.801,2.802,2.901,2.001,6.604c-0.2,0.801-0.3,1.401-0.5,1.901c-0.601,2.302-0.801,2.901,1.101,5.504
		c0.7,1,1.401,2.401,2.001,3.702c0.801,1.601,1.602,3.302,2.402,4.103c0.8,0.8,1.9,1.101,3.102,1.4
		c1.601,0.4,3.302,0.801,4.703,2.401c1.301,1.401,1.601,3.103,2.001,4.804c0.3,1.601,0.7,3.102,1.801,4.103
		c1.001,0.9,2.502,1,4.103,1c1.701,0.101,3.402,0.101,4.903,1.301c1.801,1.501,2.102,4.103,2.401,6.404
		c0.101,1.001,0.2,1.901,0.4,2.701c1.301,5.104,4.903,13.809,8.506,17.011c6.104,5.504,13.708,3.703,17.61,2.102
		c3.603-1.4,4.604-2.201,6.604-4.903c0.5-0.7,1.101-1.701,1.701-2.701c1.2-2.002,2.401-4.203,3.802-5.203
		c1.501-1.101,2.802-1.701,4.103-1.701c0.4,0,0.801,0.1,1.101,0.2c3.002,0.8,4.604,4.702,5.804,7.904
		c0.301,0.701,0.601,1.401,0.801,1.901c1.901,4.103,3.202,7.205,3.702,12.308c0.101,1.301,0.2,2.602,0.2,3.902
		c0.101,2.202,0.2,4.403,0.601,6.504c1.501,7.205,5.103,13.309,10.006,17.512h0.301c3.102-0.301,6.203-0.301,9.306-0.301
		c2.901,0,5.903,0,8.806-0.301c6.704-0.699,9.705-1.701,14.008-6.404c7.305-8.004,7.705-19.211,8.105-30.118l0.2-4.903
		c0.2-5.203,0.4-10.606,1.701-15.41c1.4-5.003,4.503-6.604,7.805-8.305c0.9-0.5,1.901-1.001,2.802-1.601
		c-1.201-0.101-2.302-0.4-3.102-0.801C668.021,501.729,667.421,499.929,666.82,498.228L666.82,498.228z"
      ></path>
      <text
        onClick={locateUser}
        borough="Westminster"
        transform="matrix(0.6429 0.7659 -0.7659 0.6429 554.6523 449.2964)"
        fontSize="24.6968"
      >
        Westminster
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Camden"
        className={"Camden" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Camden"
        d="M667.221,482.317c2.102-1,6.204-1,10.507-0.9c4.803,0.101,10.206,0.2,11.407-1.501c1.101-1.501-1.701-8.305-3.303-9.806
		c-1.301-1.201-2.301-1.802-3.202-2.401c-1.9-1.201-3.201-2.102-4.902-5.604c-0.801-1.701-2.002-3.002-3.202-4.303
		c-1.101-1.201-2.201-2.402-3.102-4.003c-0.501-1.001-0.501-1.901-0.4-2.602c0.1-0.9,0.1-1.4-0.801-2.201
		c-0.801-0.601-1.701-0.601-2.802-0.501c-1.001,0.101-2.001,0.2-2.902-0.3c-4.002-1.801-4.202-7.905-4.502-13.809
		c-0.101-3.502-0.301-7.004-1.201-9.306l-0.3-0.7c-2.401-6.004-5.704-14.109-10.907-17.711l-0.9-0.6
		c-3.803-2.602-4.103-2.902-3.302-6.504c0.1-0.6,0.3-1.401,0.5-2.301c0.7-3.702-0.4-5.604-2.802-9.105
		c-1.501-2.102-3.202-4.103-4.903-6.104c-3.502-4.103-7.204-8.305-8.605-13.708c-1.2-4.803-0.7-10.507-0.1-16.01
		c0.3-2.702,0.5-5.203,0.601-7.504c-0.801-0.4-1.701-0.701-2.502-1.101c-3.102-1.401-6.304-2.802-9.605-3.402
		c-1.701-0.3-3.503-0.4-5.204-0.5c-2.701-0.2-5.503-0.3-8.205-1.101c-1.701-0.5-3.002-1.101-4.402-1.701
		c-2.302-1-4.603-2.001-8.306-2.101c-3.201-0.1-6.704-0.1-10.006,0c-1.4,0-2.901,0-4.202,0c-1.602,3.302-3.703,7.305-6.604,8.405
		c-1.701,0.6-3.202,0.8-4.603,0.9c-1.802,0.2-3.603,0.4-5.704,1.701l-1.601,1c-3.402,2.001-7.205,4.403-9.406,7.405
		c-0.9,1.301-1.701,3.002-2.401,4.603c-0.9,2.001-1.801,4.103-3.202,5.704c-1.301,1.501-3.002,2.402-4.503,3.402
		c-1.4,0.8-2.602,1.601-3.702,2.602c-1.2,1.201-2.201,3.002-3.102,4.703c-1.101,2.001-2.102,4.002-3.702,5.303
		c-4.003,3.402-16.411,3.702-22.414,3.102c2.001,3.702,5.503,7.805,8.705,11.507c1.801,2.102,3.502,4.002,4.803,5.804
		c2.002,2.602,3.502,5.403,4.903,8.005c1.601,2.902,3.202,6.003,5.503,8.805c1.201,1.501,2.902,3.103,4.604,4.703
		c3.502,3.202,7.305,6.805,8.405,11.207l0.1-0.1c1.501,2.102,3.202,3.202,5.104,3.302c3.402,0.101,6.604-3.202,8.205-5.203
		c5.403-6.805,8.104-8.005,16.61-7.604h0.5l0.2,0.5c0.9,2.901,2.702,3.102,5.203,3.502c1.301,0.2,2.802,0.4,4.203,1.101
		c1.501,0.701,2.602,1.501,3.603,2.202c1.9,1.301,3.401,2.301,6.604,2.501c2.201,0.2,4.402-0.2,6.604-0.5
		c2.602-0.4,5.403-0.801,8.205-0.4c6.403,1.001,7.104,4.603,8.005,9.206c0.1,0.5,0.2,1.101,0.3,1.701l0.4,0.1l0.101,0.4
		c0.3,1.101,0.7,2.401,1.101,3.702c1.4,5.203,3.302,11.707,6.604,15.109c1.001,1.101,2.102,1.801,3.202,2.502
		c1.401,0.9,2.802,1.801,3.902,3.502c2.201,3.202,3.502,4.903,6.204,7.604c1.701,1.701,3.902,3.502,5.903,5.203
		c2.902,2.401,5.904,4.903,8.005,7.305c0.4,0.501,0.901,1.201,1.401,1.802c1.4,1.9,3.002,4.103,4.703,4.603
		c2.802,0.801,3.702-0.2,5.003-1.801c0.3-0.4,0.7-0.901,1.101-1.301c-1.4-1.302-2.001-2.502-0.4-5.704
		C663.418,485.22,665.319,483.218,667.221,482.317L667.221,482.317z"
      ></path>
      <text
        onClick={locateUser}
        borough="Camden"
        transform="matrix(1 0 0 1 534.3428 407.5103)"
        fontSize="27.7821"
      >
        Camden
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Barnet"
        className={"Barnet" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Barnet"
        d="M352.425,184.232c0.9,0.7,1.801,1.301,2.602,1.901c2.602,1.801,5.103,3.502,6.904,6.504c1,1.601,1.901,3.502,2.701,5.303
		c0.801,1.601,1.602,3.202,2.402,4.703c1.4,2.402,3.502,4.603,5.703,7.004c1.901,2.001,3.902,4.103,5.403,6.404
		c2.201,3.102,4.703,5.804,7.404,8.505c1.602,1.701,3.303,3.402,4.903,5.303c2.602,3.002,4.603,6.404,6.504,9.806
		c1.501,2.501,2.802,4.903,4.403,7.004c1,1.401,2.301,2.901,3.602,4.502c3.402,4.203,7.005,8.505,8.405,13.008l0.2,0.601l0,0
		c1.602,2.401,3.402,4.502,5.104,6.604c2.401,3.002,5.003,6.104,7.104,9.806c0.3,0.5,0.5,1,0.801,1.601
		c0.8,1.5,1.601,3.202,2.602,4.002c1,0.8,1.801,1.201,2.602,1.501c1.2,0.6,2.501,1.201,3.902,3.001c0.3,0.4,0.7,0.901,1.2,1.401
		c2.002,2.402,4.804,5.704,5.604,7.905c1.701,4.903-1.501,7.604-4.603,10.106l-0.3,0.3c-3.603,3.002-4.604,4.803-4.103,10.106
		c0.3,2.802,1.4,4.503,2.701,6.504c0.7,1.101,1.501,2.202,2.102,3.603c0.801,1.701,0.9,3.702,1,5.703
		c0.101,2.102,0.2,4.203,1.102,6.004c0.5,0.9,2.101,3.802,4.002,3.202c1.201-0.4,1.201-0.9,1.201-2.102c0-0.8-0.101-1.701,0.4-2.501
		c2.201-4.103,4.402-4.002,8.104-3.902c0.7,0,1.501,0,2.401,0c9.006,0,12.809,1.501,19.412,7.705
		c12.208,11.407,22.614,25.216,27.918,37.023c6.004,0.8,18.711,0.3,22.214-2.602c1.4-1.201,2.301-3.002,3.402-4.903
		c1-1.801,2.001-3.702,3.401-5.103c1.201-1.201,2.602-2.001,4.003-2.802c1.501-0.901,3.002-1.801,4.202-3.102
		c1.301-1.401,2.102-3.302,3.002-5.303c0.701-1.701,1.501-3.402,2.502-4.903c2.401-3.202,6.304-5.604,9.806-7.805l1.602-0.9
		c2.501-1.501,4.402-1.701,6.403-1.901c1.401-0.1,2.702-0.3,4.203-0.9c2.502-0.901,4.603-5.203,5.903-8.005
		c1.001-2.001,1.602-4.203,2.202-6.304c0.399-1.501,0.8-2.902,1.301-4.203c0.7-1.801,1-3.902,1.4-6.104
		c0.301-1.901,0.601-3.903,1.201-5.804c1-3.402,4.703-5.904,8.205-8.305c4.103-2.802,7.904-5.403,7.104-8.806
		c-0.101-0.5-0.701-1-1.301-1.501c-0.901-0.8-2.102-1.701-2.302-3.302c-0.2-1.701,0.3-2.802,0.801-3.902
		c0.4-0.801,0.7-1.501,0.7-2.402c0-2.401-1.301-4.303-2.602-6.104c-0.9-1.401-1.901-2.802-2.302-4.403
		c-1.501-5.403,0.801-10.307,2.902-15.109l0.5-1.101c0.1-0.3,0.3-0.701,0.5-1.301c2.502-5.904,4.403-9.706,6.004-10.207
		c0.801-0.2,1.602-0.1,2.401,0.3c3.103,1.801,4.903,9.005,6.104,14.309c0.4,1.601,0.7,3.002,1,3.902
		c4.903,0.1,12.908-7.004,14.609-12.908c0.7-2.602,0-4.503-2.201-5.503l-0.4-0.2v-0.4c0-0.4-0.101-1-0.2-1.601
		c-0.4-3.302-0.601-6.104,0.3-7.504c1.101-1.801,2.502-2.202,3.402-2.501c1.101-0.3,1.501-0.4,1.301-2.602
		c-0.2-2.301-1.4-3.702-2.602-5.103c-1.801-2.201-3.702-4.403-0.9-9.206c1.601-2.702,3.603-5.203,5.703-7.605
		c3.202-3.802,6.204-7.304,7.205-11.807c0.8-3.402,1.901-6.604,2.901-9.806c1.301-4.103,2.702-8.305,3.603-12.808
		c1.301-7.305-8.306-12.808-13.408-15.71l-0.2-0.1c-4.203-2.402-6.304-3.603-8.906-8.405c-1.301-2.502-2.602-3.703-4.302-5.204
		c-0.601-0.6-1.301-1.201-2.002-2.001c-5.604-5.704-6.704-10.207-8.405-17.011c-0.2-0.9-0.5-1.901-0.7-2.902
		c-0.7-2.702-1.501-5.203-2.401-7.805c-0.301-1.001-0.7-2.001-1.001-3.002c-1.301-4.103-2.102-4.603-6.004-6.604l-0.6-0.3
		c-8.506-4.603-15.61-7.405-22.414-8.806c-3.703-0.7-6.104-1.801-8.906-3.102c-0.7-0.3-1.301-0.601-2.101-0.901
		c-1.602-0.7-3.603-0.9-5.504-1.201c-2.401-0.3-5.003-0.601-6.904-1.901l-0.3-0.2v-0.4c-0.101-1.401,0.5-3.502,1.2-5.704
		c0.901-3.002,2.002-6.804,0.901-8.105c-0.601-0.701-1.201-1.101-1.901-1c-1.201,0.1-3.202,1.401-6.305,6.804
		c-0.399,0.7-0.6,1.301-0.8,1.801c-0.701,1.801-1.301,2.502-4.503,2.402c-1.701-0.1-5.304-2.102-6.504-3.202
		c-1.401-1.201-2.102-2.702-2.602-4.002c-0.901-2.102-1.501-3.602-5.104-3.202l-0.601,0.1l-0.2-0.601
		c-0.399-1.4-1.101-2.901-2.501-3.202c-0.501,6.204-10.907,7.504-13.809,7.805c-0.101,1.401,0.7,2.602,1.4,3.902
		c1.001,1.801,2.201,3.803,0.9,6.404c-1.101,2.101-4.603,3.302-8.005,4.502c-1.701,0.601-3.202,1.101-4.103,1.701
		c-0.5,0.3-1.4,1.001-2.501,1.801c-4.903,3.702-13.208,9.906-17.812,7.905c-1.501-0.6-2.401-2.001-2.802-4.002
		c-1.2,0.1-2.501,0.4-3.902,0.701c-2.701,0.6-5.604,1.301-8.005,0.3c-2.401,2.302-6.204,3.703-10.206,5.204
		c-5.304,2.001-10.707,4.002-12.308,8.005c-1.501,3.602-1.602,7.504-1.802,11.607c-0.2,5.404-0.5,11.107-4.002,16.11
		c-4.103,5.804-8.205,4.503-12.107,3.402c-2.702-0.801-5.504-1.601-8.706-0.601c-3.402,1.101-6.904,3.002-9.005,5.103
		c-1.401,1.301-2.202,2.702-2.902,4.103c-1.2,2.102-2.401,4.203-5.403,5.804c-3.603,1.901-9.006,3.402-13.208,3.802
		c-3.103,0.3-5.203,1.101-7.405,1.901c-1.501,0.601-3.102,1.101-5.003,1.601c-4.603,1-16.91,1.101-21.813-2.001
		c0,0.701,0,1.401,0,2.202C345.22,172.925,346.421,179.729,352.425,184.232L352.425,184.232z"
      ></path>
      <text
        onClick={locateUser}
        borough="Barnet"
        transform="matrix(1 0 0 1 472.6719 226.7778)"
        fontSize="27.7821"
      >
        Barnet
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Kensington and Chelsea"
        className={"Kensington and Chelsea" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Kensington and Chelsea"
        d="M617.99,571.374c-4.603-4.303-8.105-10.508-9.506-17.512c-0.501-2.301-0.601-4.502-0.601-6.804c0-1.2-0.1-2.501-0.2-3.802 
		c-0.4-4.903-1.601-7.705-3.502-11.808c-0.301-0.601-0.501-1.301-0.9-2.001c-1.101-2.702-2.602-6.404-4.903-7.005
		c-1.101-0.3-2.502,0.101-4.003,1.301c-1.2,0.9-2.401,3.002-3.401,4.804c-0.601,1.101-1.201,2.101-1.802,2.802
		c-2.302,3.102-3.603,3.902-7.305,5.403c-7.404,3.002-14.209,2.101-19.212-2.302c-4.002-3.603-7.705-12.708-8.905-17.711
		c-0.2-0.9-0.3-1.901-0.5-2.802c-0.301-2.102-0.501-4.303-1.901-5.403c-1.101-0.9-2.502-0.9-4.003-1.001
		c-1.701-0.1-3.602-0.1-5.003-1.4c-1.501-1.401-1.901-3.202-2.302-4.903c-0.3-1.501-0.6-3.002-1.601-4.103
		c-1.101-1.201-2.502-1.602-4.003-1.901c-1.4-0.3-2.802-0.7-3.902-1.801c-1-1.101-1.901-2.802-2.701-4.503
		c-0.601-1.301-1.301-2.602-1.901-3.502c-2.201-3.103-2.102-4.103-1.301-6.805c0.1-0.5,0.3-1.101,0.5-1.901
		c0.701-2.901,0.101-3.602-1.601-5.303c-0.4-0.4-0.801-0.801-1.301-1.401c-0.601-0.7-1.201-1.501-1.701-2.201
		c-1.001-1.401-2.001-2.802-3.502-3.702c-1.701-1.001-3.803-1.201-5.904-1.501c-3.602-0.4-7.204-0.801-9.005-5.104
		c-6.705-1-13.509-2.602-19.812-4.603c1.701,4.603,2.101,9.806,2.501,14.809c0.4,4.903,0.801,10.007,2.401,14.609
		c1.602,4.403,3.903,8.005,6.404,11.907c0.5,0.701,0.9,1.401,1.401,2.102c0.9,1.501,2.301,3.002,3.802,4.603
		c2.102,2.402,4.403,4.804,5.403,7.405c1.201,3.102,0.4,6.104-0.399,9.006c-0.801,3.001-1.501,5.804-0.2,8.705
		c0.7,1.601,3.001,3.603,5.103,5.403c1.701,1.401,3.402,2.902,4.503,4.303c1.501,1.801,3.402,3.803,5.304,6.004
		c4.902,5.303,10.506,11.306,12.308,16.71c8.305,3.303,13.308,10.707,18.312,17.91c1,1.402,1.9,2.803,2.901,4.104
		c2.502,3.502,5.304,5.904,8.205,8.506c0.9,0.799,1.801,1.6,2.802,2.5c0.9,0.801,1.601,1.502,2.201,2.203
		c2.802-6.605,9.306-11.709,19.713-15.51C584.869,578.077,601.68,572.073,617.99,571.374L617.99,571.374z"
      ></path>
      <text
        onClick={locateUser}
        borough="Kensington and Chelsea"
        transform="matrix(0.6429 0.7659 -0.7659 0.6429 502.5781 489.1899)"
        fontSize="18.5226"
      >
        Ken &amp; Chelsea
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Hammersmith and Fulham"
        className={"Hammersmith and Fulham" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Hammersmith and Fulham"
        d="M492.111,582.78c0.101,3.303,0.801,6.604,1.602,9.807c1.801,7.305,5.403,14.709,10.807,20.113
		c2.301,2.301,4.803,4.201,7.604,5.902c5.203,3.203,11.007,5.504,16.91,7.004c2.802,0.701,5.604,1.301,8.506,1.602
		c2.602,0.301,5.203,0.4,7.705,0.1c8.905-1.1,14.208-7.504,17.21-15.51c0.701-2,1.301-4.102,1.802-6.203
		c0.6-2.602,2.001-5.803,1.301-8.506c-0.2-0.699-0.4-1.301-0.9-1.9c-0.601-0.801-1.401-1.602-2.602-2.701
		c-0.901-0.9-1.802-1.701-2.803-2.502c-3.001-2.602-5.803-5.104-8.404-8.705c-1.001-1.301-1.901-2.703-2.902-4.104
		c-4.903-7.104-9.906-14.408-17.911-17.51l-0.3-0.102l-0.101-0.299c-1.601-5.203-7.204-11.208-12.107-16.511
		c-2.001-2.201-3.902-4.202-5.403-6.104c-1.101-1.301-2.702-2.802-4.402-4.103c-2.402-2.102-4.703-4.003-5.504-6.004
		c-1.4-3.302-0.601-6.504,0.2-9.706c0.7-2.802,1.401-5.503,0.4-8.104c-0.9-2.302-3.002-4.703-5.104-6.904
		c-1.501-1.602-2.901-3.202-3.902-4.804c-0.4-0.7-0.9-1.4-1.301-2.101c-2.401-3.703-4.903-7.605-6.504-12.208
		c-1.701-4.803-2.102-10.006-2.502-15.01c-0.4-5.503-0.8-10.807-2.802-15.509c-1.101-0.4-2.301-0.801-3.302-1.201
		c-3.603-1.401-7.104-1.501-11.307-1.301c-1.201,0.1-2.602,0.4-4.103,0.7c-3.002,0.7-6.104,1.401-8.605,0.2
		c-0.9-0.4-1.602-0.9-2.201-1.4c-2.802,3.802-5.004,7.904-7.505,12.808c-2.602,5.304-1.602,9.906,0.1,15.71
		c0.7,2.401,1.201,4.903,1.701,7.305c0.9,4.303,1.701,8.305,3.702,12.207c3.103,6.104,3.503,11.607,3.103,18.111
		c-0.4,7.805-2.002,14.109-4.604,18.612c-1.101,1.9-2.602,3.201-4.103,4.402c-0.8,0.7-1.601,1.4-2.401,2.201l-0.1,0.2
		c2.401-0.5,5.203,1.101,6.403,1.801c1.201,0.701,1.401,0.601,2.002,0.301c0.5-0.2,1.101-0.501,2.201-0.601
		c3.002-0.1,3.603,2.602,3.902,4.503c0.2,1.101,0.5,2.201,0.801,3.202c0.7,3.002,1.501,6.104,1.501,9.307
		c0,1.301-0.101,2.5-0.301,3.602c1.701-1.4,3.603-2.502,5.004-2.902c5.203-1.5,9.506-1.1,14.608,1.502
		C477.202,561.467,491.511,567.77,492.111,582.78z"
      ></path>
      <text
        onClick={locateUser}
        borough="Hammersmith and Fulham"
        transform="matrix(0.6429 0.7659 -0.7659 0.6429 466.2227 510.1382)"
        fontSize="18.5226"
      >
        Hammersmith
      </text>
      <text
        onClick={locateUser}
        borough="Hammersmith and Fulham"
        transform="matrix(0.6429 0.7659 -0.7659 0.6429 453.8076 520.5571)"
        fontSize="18.5226"
      >
        &amp; Fulham
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Brent"
        className={"Brent" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Brent"
        d="M508.722,445.995c1.001-0.301,2.002-0.7,3.002-1.001c3.103-1.101,6.304-2.301,9.906-2.102
		c5.804,0.4,12.208,7.405,14.309,13.409c0.4-1.001,0.901-2.002,1.401-3.002c0.9-1.802,1.901-3.603,2.201-5.403
		c0.601-3.503,1.001-7.905,1.001-11.607c-0.101-4.903-4.203-8.706-8.205-12.408c-1.801-1.601-3.502-3.202-4.803-4.803
		c-2.402-2.901-4.003-6.004-5.704-9.006c-1.4-2.602-2.901-5.303-4.803-7.805c-1.301-1.801-3.002-3.702-4.703-5.803
		c-3.402-4.003-7.305-8.505-9.306-12.708l0,0l-0.2-0.4c-5.203-11.708-15.51-25.516-27.718-36.923
		c-6.403-6.004-9.806-7.305-18.411-7.305c-0.9,0-1.701,0-2.401,0c-3.702-0.1-5.003-0.2-6.805,3.102
		c-0.3,0.5-0.199,1.101-0.199,1.701c0.1,1.201,0.199,2.901-2.202,3.602c-2.701,0.8-4.703-2.202-5.703-4.002
		c-1.101-2.102-1.201-4.403-1.301-6.604c-0.101-1.901-0.2-3.703-0.801-5.104c-0.601-1.301-1.301-2.401-2.001-3.402
		c-1.301-2.001-2.602-3.902-3.002-7.104c-0.601-5.403,0.4-7.905,4.603-11.407l0.301-0.3c3.001-2.501,5.503-4.603,4.103-8.505
		c-0.701-1.901-3.503-5.203-5.304-7.404c-0.5-0.5-0.9-1-1.201-1.401c-1.301-1.601-2.301-2.001-3.401-2.602
		c-0.801-0.4-1.802-0.801-2.902-1.701c-1.2-1-2.201-2.902-3.002-4.503c-0.3-0.5-0.5-1.101-0.8-1.501
		c-2.102-3.602-4.604-6.704-7.005-9.606c-1.801-2.201-3.603-4.403-5.303-6.904c-2.202,1.201-4.303,2.702-6.305,4.203
		c-3.302,2.401-6.704,4.803-10.606,6.204c-1.601,0.6-3.402,0.7-5.303,0.8c-2.102,0.1-4.203,0.3-6.104,1.101
		c-2.501,1.101-6.304,3.402-8.605,5.503c7.705,4.903,10.507,11.708,9.206,21.814l-0.1,0.6l-1.001,0.1
		c-6.504,0.4-13.809,0.801-20.013-0.2c-1.101-0.2-2.101-0.3-3.102-0.5c-5.104-0.801-9.506-1.601-14.709-0.601
		c-3.002,0.601-4.003,1.501-5.704,3.202c-0.5,0.5-1.101,1-1.801,1.701c-1.602,1.4-3.302,2.301-4.903,3.202
		c-1.101,0.601-2.302,1.301-3.402,2.001c-3.001,2.101-6.203,4.803-9.105,7.504c-2.602,2.502-3.802,3.002-6.604,4.002l-0.801,0.3
		c-0.601,0.2-1.201,0.3-1.701,0.3h-0.2c0.601,4.103,1.4,8.305,3.302,11.607c2.802,4.903,4.703,9.005,5.704,12.208l0.3,0.8l-0.8,0.1
		c-0.701,0.1-1.502,0.2-2.202,0.3c-4.103,0.601-6.904,1-9.405,4.703c-1.401,2.001-1.201,2.501-0.701,4.002
		c0.301,0.8,0.601,1.801,0.801,3.202c0.4,3.402-0.7,5.204-2.001,7.405c-0.501,0.8-1.001,1.601-1.501,2.602
		c-0.601,1.101-1.201,2.202-1.801,3.302c-1.001,1.601-1.901,3.202-2.502,4.903c-0.101,0.3-0.2,0.801-0.2,1.301
		c-0.101,0.901-0.2,1.801-0.601,2.602h0.301c5.803,0,11.907,3.402,17.01,6.304c0.901,0.5,1.802,1,2.602,1.401
		c6.604,3.602,11.908,8.105,17.512,12.908l1.301,1.101c1,0.9,2.201,1.501,3.202,2.101c2.301,1.301,4.603,2.602,5.103,6.104
		c0.101,0.701-0.2,1.501-0.5,2.401c-0.301,0.801-0.601,1.802-0.5,2.502c0.1,1.301,0.6,2.302,1.2,3.502
		c0.4,0.701,0.7,1.401,1.101,2.202c0.801,2.201,0.801,6.203,0.7,10.506c-0.1,5.304-0.2,11.207,1.701,12.908l0.2,0.2
		c4.403,0.3,8.605,0.4,11.607-2.701c0.9-1.001,1.501-1.802,2.102-2.502c1.4-1.801,2.301-3.202,6.104-4.103
		c1.501-0.3,2.902-0.601,4.203-0.9c2.801-0.501,5.503-1.001,8.305-2.302c0.4-0.2,0.9-0.4,1.401-0.7
		c1.801-0.9,4.302-2.201,6.604-2.201c1.101,0,2.102,0.3,3.103,0.9c1.7,1.2,2.602,4.202,2.901,6.403c0.1,1.001,0.3,3.503-0.7,4.703
		c-1.401,1.602-4.203,2.002-6.904,2.401c-1.602,0.2-3.202,0.501-4.103,0.901c-2.401,1.2-3.603,2.301-3.303,3.302
		c0.601,2.501,8.405,4.603,12.809,4.603l0,0c9.205,0,16.21-1.2,22.714-6.904c1.301-1.101,2.502-2.701,3.902-4.402
		c3.702-4.703,8.405-10.606,14.509-6.104c0.701,0.501,1.001,1.201,1.201,1.901c0.3,0.801,0.5,1.401,1.601,1.901
		c0.801,0.4,2.302,0.2,3.603,0c1.001-0.1,2.001-0.2,2.702-0.1c3.302,0.3,4.603,1.7,5.903,3.002c0.801,0.9,1.701,1.801,3.202,2.501
		c2.102,0.9,4.903,0.301,7.604-0.3c1.501-0.301,3.002-0.701,4.303-0.701c4.403-0.199,8.105-0.1,11.907,1.401
		c1.001,0.4,1.901,0.7,2.902,1.101l0.7-0.3c0.1,0.2,0.2,0.4,0.3,0.7c6.404,2.102,13.409,3.803,20.313,4.903
		C501.617,450.298,503.519,447.596,508.722,445.995z"
      ></path>
      <text
        onClick={locateUser}
        borough="Brent"
        transform="matrix(1 0 0 1 363.6064 390.8687)"
        fontSize="27.7821"
      >
        Brent
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Harrow"
        className={"Harrow" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Harrow"
        d="M178.358,250.415c0.125,2.16,0.23,4.166,0.54,6.129c0.958,6.403,2.933,12.268,4.938,18.517
		c1.655,5.016,3.395,10.184,4.475,15.561c0.414,2.006,0.617,4.088,0.85,6.103c0.463,4.088,0.925,8.41,2.932,12.035
		c1.147,2.083,2.314,3.318,3.626,4.565c1.148,1.158,2.314,2.314,3.55,4.202c0.859,1.312,1.234,3.241,1.62,5.17
		c0.279,1.389,0.541,2.623,0.926,3.642c2.565,6.251,4.321,12.577,6.019,18.694c1.287,4.629,2.623,9.334,4.244,13.964
		c3.883,10.878,8.177,20.523,12.729,30.729l0.501,1.125c0.373,0.618,0.771,1.234,1.157,1.76l0.357,0.489l-0.124,0.154
		c3.611,1.389,5.864,0.462,9.965-1.189l0.563-0.227c3.435-1.376,6.803-3.05,10.372-4.822c5.11-2.537,10.396-5.161,15.969-6.892
		c1.119-0.348,2.149-0.721,3.125-1.069c4.775-1.722,8.556-3.083,13.965,1.91c0.472,0.463,0.925,0.85,1.312,1.312
		c1.618,1.621,2.932,2.932,5.4,3.269c3.599,0.541,9.489,0.694,10.795-0.305c0.487-0.392,0.583-1.398,0.672-2.289
		c0.06-0.593,0.115-1.154,0.274-1.632c0.627-1.859,1.641-3.541,2.621-5.163c0.617-1.025,1.259-2.087,1.78-3.163
		c0.508-1.051,1.044-1.943,1.521-2.729c1.243-2.057,2.142-3.546,1.813-6.431c-0.146-1.281-0.434-2.139-0.688-2.89
		c-0.584-1.733-0.83-2.832,0.893-5.285c2.908-4.143,6.217-4.647,10.41-5.285c0.413-0.062,0.839-0.127,1.271-0.198
		c-1.037-2.932-2.828-6.649-5.344-11.066c-2.088-3.671-2.894-8.359-3.541-12.843l-0.1-0.688l0.682-0.141
		c0.347-0.068,0.7-0.108,1.058-0.145c0.496-0.053,0.966-0.1,1.353-0.245l0.842-0.318c2.626-0.985,3.715-1.397,6.075-3.664
		c2.909-2.793,6.19-5.515,9.243-7.658c1.147-0.806,2.344-1.465,3.497-2.102c1.665-0.918,3.24-1.784,4.674-3.056
		c0.671-0.593,1.221-1.127,1.716-1.606c1.813-1.759,3.011-2.92,6.476-3.566c5.452-1.019,9.979-0.28,15.198,0.54
		c0.99,0.154,2.007,0.31,3.009,0.488c6.023,0.925,13.193,0.54,19.521,0.173c1.054-9.463-1.867-15.736-9.417-20.29l-0.795-0.481
		l0.646-0.667c2.329-2.396,6.845-5.216,9.69-6.457c2.119-0.92,4.408-1.063,6.619-1.202c1.774-0.112,3.449-0.215,4.884-0.715
		c3.768-1.316,7.073-3.702,10.271-6.009c2.152-1.55,4.37-3.15,6.747-4.449c-1.468-4.058-4.754-8.051-7.941-11.922
		c-1.306-1.589-2.542-3.088-3.621-4.555c-1.613-2.199-3.009-4.591-4.485-7.125c-1.909-3.276-3.888-6.666-6.359-9.553
		c-1.566-1.828-3.234-3.549-4.851-5.214c-2.621-2.702-5.328-5.491-7.567-8.73c-1.505-2.178-3.428-4.213-5.288-6.18
		c-2.175-2.303-4.429-4.686-5.937-7.251c-0.896-1.521-1.701-3.2-2.479-4.824c-0.837-1.749-1.706-3.557-2.672-5.134
		c-1.65-2.695-3.882-4.247-6.466-6.038c-0.854-0.595-1.739-1.208-2.646-1.893c-6.46-4.874-7.789-12.195-7.769-17.476
		c0.016-3.705,0.019-4.585-3.211-5.973c-2.708-1.164-6.028-2.23-8.444-3.008c-0.585-0.186-1.323-0.484-2.14-0.81
		c-2.059-0.821-4.878-1.931-6.367-1.668c-1.314,0.244-2.109,1.292-3.028,2.501c-0.735,0.965-1.49,1.963-2.606,2.7
		c-2.577,1.627-5.329,2.317-7.992,2.988c-2.903,0.731-5.646,1.42-8.13,3.238c-2.776,2.031-4.736,5.258-6.636,8.41
		c-1.141,1.874-2.32,3.814-3.655,5.443c-1.713,2.09-3.227,2.478-5.323,3.015c-0.605,0.153-1.27,0.325-2.022,0.541
		c-3.047,0.942-5.641,2.771-8.15,4.532c-2.66,1.872-5.413,3.808-8.765,4.781c-1.695,0.492-3.521,0.754-5.286,1.002
		c-3.688,0.533-7.172,1.039-9.724,3.427c-1.818,1.7-3.198,3.558-4.528,5.353c-1.94,2.613-3.948,5.314-7.275,7.485
		c-3.302,2.128-7.102,3.737-10.777,5.295c-1.854,0.789-3.608,1.529-5.302,2.338c-1.495,0.708-3.009,1.013-4.475,1.312
		c-1.484,0.298-2.891,0.579-4.269,1.254c-1.217,0.595-2.141,1.445-3.035,2.268c-1.14,1.051-2.321,2.138-4.071,2.701
		c-2.472,0.769-4.937,1.036-7.322,1.299c-3.505,0.384-6.812,0.747-9.877,2.606c-3.906,2.369-10.426,4.859-16.622,4.707
		c0.641,0.926,1.234,2.159,1.774,3.702c1.525,3.173,1.77,7.108,2,10.86L178.358,250.415L178.358,250.415z"
      ></path>
      <text
        onClick={locateUser}
        borough="Harrow"
        transform="matrix(1 0 0 1 237.2969 281.2759)"
        fontSize="27.7773"
      >
        Harrow
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Richmond upon Thames"
        className={"Richmond upon Thames" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Richmond upon Thames"
        d="M470.098,565.069c-1.601-0.1-3.202,0.1-5.103,0.701c-8.605,2.902-15.01,14.508-16.711,22.814
		c-0.9,4.402-0.801,8.904-1.801,13.307c-2.602,11.309-12.908,20.113-25.016,17.812c-11.407-2.102-18.012-14.209-22.314-23.814
		c-0.5-1.102-1-2.303-1.601-3.504c-0.3-0.6-0.5-1.1-0.801-1.699c-2.001-4.404-3.802-8.605-8.104-10.809
		c-5.203-2.701-10.807-2.602-14.909,0.301c-0.801,0.602-1.802,1.502-2.802,2.502l-12.208,16.91
		c-3.402,4.402-6.904,7.205-10.907,10.508l-2.501,2c-9.105,7.205-16.911,13.508-10.507,25.416c2.001,3.703,6.004,6.805,9.807,9.807
		c6.104,4.803,12.407,9.705,12.007,17.611c-0.601,12.006-11.007,16.51-20.112,20.512c-1.4,0.602-2.802,1.201-4.103,1.801
		c-0.7,0.301-1.401,0.701-2.201,1.002c-4.703,2.102-10.507,4.703-12.608,9.006c-2.401,4.902-2.602,10.705-0.5,17.209
		c0.3,1.102,0.601,2.102,0.9,3.104c1.401,5.002,2.302,8.004,8.205,10.605c3.603,1.502,6.805,2.102,9.906,1.801
		c1.701-0.199,3.102-0.801,4.603-1.5c1.102-0.5,2.102-1,3.402-1.4c3.303-0.902,2.102,0.299,4.604,0.9
		c-2.702-0.4-6.404,1.301-7.405,1.801c-1.501,0.699-3.102,1.4-5.003,1.602c-3.402,0.299-6.904-0.301-10.707-1.902
		c-6.604-2.801-7.604-6.504-9.105-11.508c-0.3-0.9-0.601-2-0.9-3c-2.201-6.906-2.001-13.01,0.601-18.312
		c2.401-4.803,8.405-7.504,13.308-9.705c0.801-0.301,1.501-0.701,2.202-1.002c1.301-0.6,2.701-1.201,4.103-1.801
		c2.201-0.9,4.402-1.9,6.504-3.002c3.603-1.801,6.804-4.002,9.405-7.104c1.301-1.502,2.302-3.303,2.802-5.203
		c0.301-1.301,0.4-2.602,0.2-3.902c-0.2-2.303-1-4.604-2.301-6.506c-2.502-3.602-6.204-5.902-10.106-7.604
		c-2.702-1.201-5.504-2.402-7.404-4.104c-1.501-1.301-7.605-6.904-8.906-12.607c-0.8,1.102-1.801,2.102-2.802,3.102
		c-1.4,1.502-2.901,3.002-3.702,4.703c-0.2,0.4-0.4,0.801-0.601,1.201c-0.7,1.301-1.101,2.002-1,3.803c0,0.4,0.4,0.801,0.8,1.201
		c0.701,0.799,1.602,1.801,1.301,3.402c-0.6,2.602-3.201,3.4-5.604,4.201c-1.101,0.301-2.101,0.701-2.701,1.102
		c-0.801,0.5-1.401,1-2.102,1.602c-2.201,1.801-4.303,3.502-8.705,2.602c-3.502-0.701-6.904-3.803-7.205-7.605
		c-0.399,0.301-0.9,0.701-1.4,1c-3.002,2.201-6.404,4.803-9.406,5.504c-5.203,1.201-8.005-1.201-10.506-3.303
		c-1.602-1.301-3.002-2.5-5.004-3.002c-1.601-0.4-3.001,0.201-4.302,0.801c-0.801,0.301-1.502,0.701-2.302,0.801
		c-1.401,0.201-2.902,0.1-4.303,0c-1.101-0.1-2.102-0.1-3.103-0.1c-3.102,0.199-5.903,0.699-8.905,1.201
		c-1.501,0.299-3.102,0.5-4.803,0.799c-2.102,4.504-6.904,11.107-10.507,14.91l-0.6,0.701c-1.901,2-4.703,5.104-6.904,6.004
		c-1.302,0.6-2.702,0.5-4.104,0.5c-1.2,0-2.301-0.1-3.201,0.299c1.801,1.201,2.201,2.703,2.701,4.203c0.2,0.9,0.5,1.801,1.001,2.902
		c1.101,2.201,2.802,3.201,4.803,4.402c0.601,0.4,1.201,0.701,1.901,1.102c3.702,2.4,4.703,3.002,9.405,3.502
		c1.001,0.1,2.102,0.1,3.202,0.1c2.602,0,5.203,0.1,7.605,1c2.501,1.002,3.802,2.201,3.902,3.703c0.2,2.902-4.103,5.504-8.306,8.004
		c-1.901,1.102-3.702,2.203-4.503,3.002c-1.2,1.201-2.001,2.602-2.901,4.004c-1.101,1.801-2.201,3.602-4.103,5.402
		c-3.002,2.803-5.304,5.703-7.805,8.906l-1.001,1.301c-3.002,3.902-3.002,6.203-2.201,11.807c0.1,0.9,0.8,2.502,1.501,4.203
		c1.601,4.002,2.602,6.805,1.801,8.105c-0.4,0.6-0.9,1-1.501,1.201c-1.001,2.1-1.101,5.502-1.2,8.705
		c-0.2,6.104-0.501,12.908-6.404,13.607c0.4,1.902,1,3.902,1.801,5.805c2.702,0.299,4.503,1.9,6.304,3.402
		c1.701,1.5,3.303,2.9,5.804,3.301c6.104,1.102,11.308-1.801,16.41-4.602l1.201-0.701c5.503-3.002,10.807-5.104,18.411-5.104h0.101
		c7.705,0,8.705,1.301,11.407,4.904c0.5,0.6,1,1.301,1.601,2c3.502,4.203,8.605,7.205,13.709,10.006
		c4.303,2.402,8.705,4.904,12.107,8.205c1.501,1.402,3.002,2.803,4.503,4.104c2.401,2.102,4.803,4.203,7.004,6.604
		c1.501,1.701,2.802,3.803,3.902,5.805c1.701,2.9,3.502,5.902,6.104,7.504c4.202,2.701,9.405,3.002,14.709,0.801l0.7-0.301l0.5-0.6
		l0.301,0.199c5.604-2.801,10.006-7.904,11.407-13.408c0.8-3.301,0.8-7.203,0.8-11.006c0-3.502,0-6.805,0.601-9.607
		c0.9-4.102,1.501-8.305,2.201-12.807c0.2-1.602,0.5-3.203,0.7-4.904c0.501-3.201,1.401-6.104,2.302-9.004
		c0.801-2.602,1.701-5.205,2.102-8.006c1-5.504-0.801-8.705-3.202-13.107c-0.601-1.102-1.201-2.201-1.801-3.402l-0.601-1.201
		c-2.102-4.203-5.403-10.506-0.101-14.51c0.101-0.1,0.301-0.199,0.4-0.299l-2.501-0.502c1.801-0.199,4.202-0.799,4.902-0.699
		c0.801-0.201,1.901,0,2.802,0c4.703,0,10.307,2.102,13.108,3.602c5.704,3.102,10.606,7.404,13.909,12.207
		c0.8,1.102,1.4,2.602,2.101,4.104c1.301,2.902,2.702,6.104,4.903,6.805c1.101,0.299,2.302,0,3.803-0.9
		c1.901-1.201,4.603-5.805,6.804-9.506c1.401-2.303,2.602-4.404,3.603-5.705c5.304-6.803,11.007-12.107,18.312-17.311
		c4.603-3.301,8.905-7.203,13.208-11.006c1.101-1.002,2.302-2.102,3.502-3.102c0-0.201-0.1-0.4-0.1-0.602l0.9-0.1
		c4.003-3.502,8.105-6.904,12.608-9.807c0.8-0.5,1.5-1,2.201-1.4c4.503-2.803,4.503-2.803,2.101-9.006
		c-2.101-5.402-4.202-9.605-8.305-14.008c-1.901-2.102-4.903-4.004-7.705-5.805c-3.302-2.102-6.704-4.303-8.605-6.805
		c-4.503-6.004-0.9-13.809,1.901-20.012c0.601-1.201,1.101-2.402,1.501-3.502c3.803-9.307,6.404-10.906,17.011-9.906
		c3.402,0.301,7.004,0.801,10.406,1.201c4.103,0.5,8.306,1,12.408,1.4c0.1-3.002,0.1-6.104,0.1-9.105c0-3.203-0.1-6.604,0.101-9.906
		v-0.701h0.7c4.303-0.199,8.505,0.301,12.607,1.402c-1.9-2.402-3.201-5.104-4.103-8.707c-1-3.902-1.2-7.604-1.501-11.307
		c-0.5-7.004-1-13.607-6.304-19.713C478.203,568.471,474.801,565.469,470.098,565.069L470.098,565.069z"
      ></path>
      <text
        onClick={locateUser}
        borough="Richmond upon Thames"
        transform="matrix(1 0 0 1 272.3438 708.1187)"
        fontSize="27.7821"
      >
        Richmond
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Hounslow"
        className={"Hounslow" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Hounslow"
        d="M443.882,584.782c-1.001,7.004-0.2,14.809-4.403,20.912c-4.503,6.404-12.407,9.207-19.612,5.904
		c-1.801-0.801-3.902-1.9-5.403-3.201c-9.906-8.406-10.106-23.816-20.713-31.42c-8.605-6.205-22.614-4.402-28.718,4.402
		c-1.601,2.301-3.102,4.703-4.603,7.104c-4.003,6.305-8.105,12.809-13.809,17.711c-2.102,1.803-4.703,3.303-7.405,4.805
		c-4.202,2.4-8.604,4.902-11.106,8.805c-1.301,2.102-1.301,4.402-1.301,6.604c0,1.402,0,2.803-0.3,4.104l-0.4,1.201
		c-0.801,1.6-2.201,3.002-3.603,4.502c-1.501,1.602-3.102,3.201-4.003,5.004c-0.199,0.4-0.399,0.799-0.6,1.1
		c-0.701,1.301-1.301,2.402-1.101,4.703c0.1,0.9,0.6,1.502,1.101,2.002c0.7,0.801,1.101,1.301,0.9,2.102
		c-0.4,1.801-2.502,2.4-4.604,3.102c-1.2,0.4-2.301,0.699-3.102,1.201c-0.801,0.5-1.501,1.1-2.201,1.699
		c-2.102,1.701-3.803,3.002-7.505,2.303c-3.302-0.701-6.504-3.902-5.903-7.506l0.3-1.701l-1.4,1.002
		c-0.801,0.6-1.701,1.201-2.702,1.9c-2.901,2.201-6.204,4.604-8.905,5.203c-4.503,1.002-6.805-0.9-9.206-3.002
		c-1.601-1.4-3.302-2.801-5.604-3.301c-2.102-0.5-3.803,0.199-5.203,0.801c-0.7,0.299-1.301,0.6-1.901,0.699
		c-1.2,0.201-2.602,0.1-4.002,0c-1.101-0.1-2.202-0.1-3.303-0.1c-3.202,0.199-6.104,0.701-9.105,1.201
		c-1.701,0.299-3.302,0.6-5.203,0.801l-0.4,0.1l-0.2,0.4c-1.901,4.402-6.804,11.006-10.406,14.908l-0.601,0.701
		c-1.701,1.801-4.503,4.902-6.403,5.703c-1.001,0.4-2.202,0.4-3.503,0.301c-1.901-0.1-3.802-0.1-5.203,1.301l-0.801,0.801l1.001,0.4
		c2.201,1,2.502,2.102,3.002,3.902c0.2,0.9,0.5,2,1.101,3.201c1.301,2.602,3.302,3.803,5.403,5.004
		c0.601,0.299,1.201,0.699,1.801,1.1c3.803,2.402,5.004,3.203,10.106,3.703c1.101,0.1,2.202,0.1,3.303,0.1
		c2.501,0,5.003,0.1,7.104,0.9c1.301,0.5,2.901,1.4,3.002,2.402c0.199,2-4.303,4.703-7.605,6.703
		c-2.102,1.201-3.802,2.303-4.803,3.303c-1.301,1.301-2.201,2.801-3.102,4.303c-1.001,1.701-2.102,3.402-3.803,5.104
		c-3.102,2.9-5.403,5.902-7.905,9.006l-1,1.301c-3.402,4.303-3.402,7.104-2.502,13.008c0.2,1,0.801,2.602,1.501,4.502
		c0.9,2.201,2.401,6.004,1.901,6.805c-0.9,1.5-4.303-0.201-6.704-1.502c-1.301-0.699-2.401-1.301-3.202-1.4
		c-1.301-0.199-2.702-0.299-4.103-0.299c-1.401,0-2.902,0.1-4.403,0.199c-2.602,0.1-4.902,0.1-7.904,0.4
		c-2.802,0.199-6.004,0.5-8.205-0.201c-2.902-0.9-5.003-3.902-6.805-6.604c-0.4-0.6-0.8-1.1-1.101-1.602
		c-0.801-1.1-1.801-2.9-2.802-4.701c-3.102-5.904-7.404-13.91-13.708-12.508c-1.602,0.4-3.603,1.701-5.403,3.002
		c-1.401,1-2.802,2-4.003,2.4c-1.201,0.5-2.302,1.102-3.603,1.801c-2.501,1.402-5.003,2.803-7.604,2.902
		c-3.603,0.201-6.404-1.801-9.406-3.803c-0.5-0.299-0.9-0.699-1.4-1c-0.4-0.301-0.801-0.5-1.101-0.701
		c-1.301-0.801-1.701-1.1-2.602-2.9c-0.2-0.4-0.301-1.201-0.4-2.002c-0.2-1.301-0.4-2.701-1.201-3.502
		c-1.601-1.602-3.402-1.701-5.003-1.902c-1.901-0.199-3.302-0.299-4.103-2.4c-0.6-1.602-0.5-3.002-0.4-4.104
		c0.1-1.1,0.2-2.102-0.5-2.801c-0.701-0.701-1.801-0.9-4.103-0.801c-1.401,0.1-2.902,0.701-4.503,1.4
		c-3.202,1.4-5.303,2.201-6.704,0.602c-0.8-1.002-1-4.004-1.101-6.404c-0.1-1.602-0.1-3.102-0.4-4.104c-0.5-2-0.8-4.102-1.201-6.303
		c-0.3-1.701-0.5-3.502-0.9-5.203l-0.1-0.602c-0.3-1.701-0.801-4.203-1.801-5.303c-0.701-0.9-1.701-1.201-2.702-1.502
		c-0.701-0.199-1.401-0.5-1.801-0.9c-1.701-2.5-0.4-4.102,1.201-6.004c0.601-0.699,1.101-1.4,1.501-2.1
		c1.501-2.602,2.001-5.904,1.401-8.807l0.2,0.1c1.401,0.701,2.802,1.402,4.403,2.002c5.804,2.502,11.307,4.803,18.111,4.502
		c9.006-0.4,10.106-3.801,12.208-10.605l0.3-1c3.302-10.807,16.01-19.213,25.315-25.416c0.601-0.4,1.802-1.102,3.103-1.803
		c6.304-3.502,12.007-6.904,12.207-9.605c0.2-2.602-1.501-3.803-3.002-4.902c-0.9-0.701-1.801-1.4-2.301-2.303
		c-1.101-2-1.201-6.002-1.401-8.604v-0.701c-0.601-12.408,2.102-20.914,5.604-31.619l0.601-2.002
		c1.001-3.102,1.101-6.404,1.201-9.906c0.1-2.701,0.199-5.402,0.7-8.105c0.9-4.803,3.802-7.705,6.904-10.906l0.4-0.4l0.9,0.7
		c4.603,2.302,9.806,4.402,15.109,6.004c2.401,0.799,4.503,1.6,6.604,2.5c4.303,1.803,8.306,3.502,14.31,3.703h0.9
		c2.701,0.1,6.204,0.301,8.705-0.4c0.801-0.199,1.501-0.801,2.202-1.301c0.5-0.4,1.101-0.801,1.4-0.9
		c2.302-0.6,2.802,0.4,3.902,2.502c0.4,0.699,0.801,1.6,1.301,2.4c3.202,4.803,5.804,7.105,8.105,7.105
		c2.701-0.1,6.904-3.402,10.606-6.305c1.301-1.1,2.602-2.102,3.502-2.701c1.901-1.201,3.603-2.602,5.304-3.902
		c3.902-3.002,7.505-5.904,12.508-7.105c4.402-1.101,7.604,0.301,11.106,1.701c1.901,0.801,3.803,1.601,6.004,2.101
		c4.203,0.9,8.905,0.801,13.309,0.701c3.902-0.1,7.904-0.1,11.507,0.4c3.402,0.5,6.805,0.299,10.206,0.199
		c2.502-0.1,4.903-0.299,7.205-0.1c2.501,0.199,3.902,1.602,5.403,3.102c2.201,2.201,4.402,4.402,9.306,1.902
		c0.2-0.102,0.5-0.201,0.7-0.301c1.101-0.5,2.302-1.102,3.103-2.002c0.6-0.6,0.7-1.4,0.8-2c0.2-0.801,0.301-1.201,0.801-1.502
		c1.101-0.5,2.502,0.1,4.103,0.701c1.701,0.699,3.502,1.4,5.203,0.699c1.001-0.4,1.701-1.1,2.001-1.9
		c0.501-1.401-0.2-2.902-0.9-4.302c-0.3-0.601-0.601-1.201-0.7-1.602c-0.801-2.802-0.1-3.402,1.801-5.203
		c0.301-0.3,0.701-0.601,1.001-1.001c3.702-3.602,7.004-3.602,11.607-3.502c1.4,0,2.802,0,4.402,0c2.102-0.1,4.203-0.801,6.204-1.4
		c3.803-1.201,7.004-2.302,9.706,0.399c2.302,2.302,4.003,5.104,5.903,8.105c2.002,3.202,4.003,6.404,6.704,9.105l0.701,0.701
		c4.103,3.902,8.205,7.904,13.809,9.506c8.405,2.402,12.407-7.904,13.708-12.507c0.2-0.701,0.4-1.401,0.501-2.102
		c0.2-1.001,0.399-1.901,0.8-2.702l0.2,0.101c1.201-1.802,3.302-1.701,6.904,0.4c1.701,1,2.502,0.8,3.402,0.3
		c0.4-0.2,0.801-0.4,1.601-0.4h0.101c1.501,0,1.901,1.301,2.302,3.402c0.199,1.101,0.5,2.102,0.7,3.202
		c0.7,2.902,1.4,5.904,1.4,8.906c0,2.201-0.3,4.002-0.9,5.703c-0.1,0.199-0.9,0.6-1.001,0.801
		C448.685,570.874,444.982,577.176,443.882,584.782L443.882,584.782z"
      ></path>
      <text
        onClick={locateUser}
        borough="Hounslow"
        transform="matrix(1 0 0 1 186.8818 617.4614)"
        fontSize="27.7821"
      >
        Hounslow
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Hillingdon"
        className={"Hillingdon" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Hillingdon"
        d="M92.863,663.03c0.5,0.201,0.9,0.4,1.401,0.701c1.401,0.699,2.802,1.301,4.303,2c5.704,2.402,11.007,4.703,17.411,4.404
		c8.005-0.4,8.805-2.902,10.807-9.607l0.3-1c3.502-11.307,16.511-19.912,25.916-26.217c0.7-0.4,1.801-1.1,3.202-1.9
		c3.702-2.002,11.307-6.305,11.407-8.406c0.1-1.701-0.801-2.4-2.401-3.602c-1.001-0.701-2.102-1.602-2.802-2.801
		c-1.201-2.303-1.401-6.504-1.501-9.207v-0.699c-0.601-12.709,2.201-21.215,5.604-32.121l0.601-1.9c0.9-2.902,1-6.104,1.101-9.506
		c0.1-2.703,0.2-5.504,0.7-8.305c1.001-5.205,4.103-8.306,7.305-11.608c0.7-0.7,1.4-1.401,2.102-2.201
		c5.503-6.004,10.006-10.507,16.41-15.51c5.303-4.203,6.504-7.905,7.904-12.608c0.601-2.001,1.301-4.303,2.502-6.904
		c2.001-4.603,5.403-9.006,9.006-13.708c6.504-8.506,13.308-17.312,11.507-27.317c-5.003-1.201-9.306-2.901-13.509-4.503
		c-5.804-2.201-11.207-4.303-18.111-5.303c-10.906-1.602-21.413-5.704-32.02-12.708l-1.001-0.701
		c-3.102-2.001-5.903-3.802-5.703-6.003c0.1-1.602,1.601-3.002,4.703-4.604c2.802-1.4,6.804-2.102,10.606-2.901
		c2.802-0.501,5.503-1.001,7.705-1.802c1-0.3,2.501-0.6,4.002-1c4.203-0.9,10.007-2.102,10.307-5.104c0.1-0.5-0.7-1.101-1.401-1.701
		c-1.101-0.9-2.401-1.901-2.301-3.402c0.2-3.602,0.7-4.302,2.802-4.803c0.7-0.2,1.601-0.4,2.802-1
		c3.502-1.901,7.204-3.502,10.807-5.003c6.904-2.902,14.009-5.804,19.412-11.507l-0.2-0.3l-0.2,0.1l-0.601-1.301
		c-1.001-1.701-1.901-3.502-2.602-5.103l-0.5-1l0.3-0.2c-3.702-8.405-7.305-16.71-10.507-25.816
		c-1.701-4.603-3.002-9.406-4.303-14.009c-1.7-6.104-3.502-12.308-6.003-18.511c-0.501-1.101-0.801-2.501-1.001-3.902
		c-0.4-1.801-0.7-3.603-1.401-4.703c-1.2-1.801-2.301-2.902-3.401-4.002c-1.301-1.301-2.602-2.602-3.902-4.903
		c-2.102-3.902-2.602-8.305-3.103-12.507c-0.2-2.102-0.5-4.103-0.9-6.004c-1.101-5.303-2.802-10.407-4.402-15.41
		c-2.002-6.004-4.103-12.208-5.004-18.712c-0.3-2.001-0.399-4.202-0.5-6.304c-0.2-3.702-0.4-7.505-1.601-10.606
		c-1.901-5.203-3.803-5.904-8.306-7.705c-0.7-0.3-1.501-0.6-2.301-0.9l-0.601-0.2c-5.704-2.301-10.606-4.303-16.911-4.703
		c-6.403-0.4-9.105-1.601-12.907-3.302c-1.602-0.701-3.503-1.601-5.904-2.501c-4.703-1.701-12.607-2.802-17.911-1.601
		c-4.002,0.9-5.303,2.802-7.104,5.303c-0.901,1.301-1.901,2.702-3.402,4.203c-4.503,4.603-9.606,7.104-14.109,6.704
		c-4.002-0.3-7.104-2.802-10.406-5.303c-1.701-1.301-3.502-2.702-5.403-3.802c-11.507-6.304-20.913-11.908-29.819-20.413
		c-0.8-0.7-1.801-1.801-3.002-3.001c-5.403-5.604-15.509-16.11-21.213-14.009c-3.803,1.401-1.501,14.109,0,22.614
		c0.6,3.502,1.201,6.504,1.301,8.405c0.4,8.105,0.3,16.41,0.1,24.416c-0.1,4.203-0.1,8.405-0.1,12.508c0,0.8,0.1,1.701,0.2,2.702
		c0.2,2.201,0.4,4.803-0.2,6.504c-0.601,1.601-1.501,2.401-2.402,3.002c-0.9,0.7-1.601,1.201-2.101,2.802
		c-1,3.802,0.3,9.406,1.401,13.909c0.3,1.301,0.601,2.401,0.8,3.502c1.301,6.404,2.702,11.607,5.304,16.51
		c1.301,2.402,2.901,4.503,4.703,6.604c2.001,2.501,4.103,5.103,5.704,8.405c0.8,1.601,1.201,3.302,1.601,5.003
		c0.3,1.401,0.7,2.702,1.201,3.902c0.601,1.501,1.301,2.401,2.101,3.402c0.5,0.7,1.101,1.501,1.601,2.401
		c1.901,3.602,2.202,6.604,2.402,10.106c0.1,1.901,0.3,4.002,0.8,6.304c0.701,3.702,2.101,7.405,3.302,11.007
		c0.6,1.801,1.201,3.502,1.701,5.103c1.201,3.803,2.502,5.303,4.203,7.205c1.101,1.201,2.302,2.501,3.603,4.603
		c5.903,9.406,0.1,15.81-5.604,22.014c-2.001,2.101-4.002,4.403-5.503,6.704c-1.301,2.001-2.602,3.903-4.103,5.904
		c-4.903,6.904-10.006,14.108-11.007,22.113c-0.4,3.402,1.201,5.704,3.001,8.405c1.401,2.102,2.902,4.303,3.502,7.305
		c1,4.403,1.101,9.206,1.301,13.909c0,1.301,0.1,2.602,0.2,3.902c0.3,5.403-0.601,10.706-1.501,15.81
		c-1.201,6.904-2.301,13.408-0.8,20.213c0.8,3.802,3.202,6.204,5.703,8.705c2.102,2.102,4.203,4.203,5.503,7.205
		c2.902,6.304,1.801,10.306-0.2,16.21c-1.001,3.002-1.901,6.004-2.802,8.806c-2.402,7.905-4.603,15.309-9.306,22.915
		c-5.403,8.904-10.306,19.611-14.609,29.018l-1,2.301c-2.502,5.404-4.002,10.908-4.703,17.311c-0.2,1.301-1,3.604-2.001,6.205
		c-1.301,3.602-3.302,8.904-2.602,10.307l0.2,0.299l-0.1,0.301c0,0.199-0.1,0.301,0,0.5c2.401,0.1,4.603-0.6,6.904-1.4
		c3.202-1.102,6.504-2.301,10.407-0.9c2.501,0.9,4.903,3.602,7.204,6.303c1.701,1.902,3.402,3.902,5.003,4.904
		c5.303,3.502,9.005,4.502,15.61,4.502h0.4c6.604,0,8.706,1.502,12.208,4.002c0.901,0.701,1.901,1.402,3.202,2.203
		c4.103,2.701,7.805,3.102,12.208,3.701c1.001,0.1,2.102,0.301,3.202,0.4c3.502,0.5,6.304,1.602,9.105,2.902L92.863,663.03
		L92.863,663.03z"
      ></path>
      <text
        onClick={locateUser}
        borough="Hillingdon"
        transform="matrix(1 0 0 1 64.1763 361.4897)"
        fontSize="27.7821"
      >
        Hillingdon
      </text>
      <path
        fill="#74C69D"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.5"
        borough="Ealing"
        className={"Ealing" === userLocation ? "clicked" : null}
        onClick={locateUser}
        title="Ealing"
        d="M179.417,543.155c4.503,2.201,9.605,4.303,14.909,6.004c2.501,0.8,4.603,1.701,6.704,2.501
          c4.202,1.701,8.104,3.402,13.809,3.602h0.9c2.602,0.102,5.903,0.301,8.205-0.299c0.5-0.1,1.201-0.602,1.801-1.002
          c0.701-0.5,1.301-0.9,1.901-1.1c3.503-0.9,4.503,1.1,5.504,3.303c0.4,0.699,0.7,1.5,1.2,2.301c3.503,5.303,5.604,6.404,6.904,6.404
          c2.202-0.102,6.504-3.502,9.706-6.004c1.401-1.102,2.702-2.102,3.603-2.701c1.801-1.201,3.603-2.602,5.203-3.904
          c4.003-3.101,7.805-6.103,13.008-7.404c4.804-1.201,8.506,0.301,12.008,1.801c1.801,0.801,3.702,1.501,5.704,2.002
          c4.103,0.9,8.604,0.8,13.008,0.701c3.902-0.1,8.005-0.201,11.808,0.4c3.201,0.5,6.604,0.299,9.906,0.199
          c2.401-0.1,5.003-0.301,7.404-0.1c3.002,0.199,4.803,2.002,6.404,3.502c2.101,2.102,3.702,3.602,7.504,1.602
          c0.2-0.1,0.501-0.201,0.701-0.4c1-0.5,2.101-1.002,2.701-1.701c0.301-0.301,0.4-0.801,0.5-1.301c0.2-0.9,0.4-2.002,1.602-2.602
          c1.601-0.801,3.502,0,5.203,0.7c1.501,0.602,3.002,1.201,4.003,0.701c0.6-0.301,1-0.6,1.2-1c0.301-0.801-0.3-2.001-0.801-3.203
          c-0.3-0.7-0.6-1.301-0.8-1.901c-1.001-3.602,0.2-4.803,2.201-6.704c0.3-0.3,0.7-0.6,1.001-1c4.103-4.103,8.104-4.003,12.707-3.902
          c1.401,0,2.803,0,4.303,0c1.901-0.101,3.903-0.701,5.804-1.401c3.902-1.301,7.905-2.602,11.207,0.801
          c2.401,2.501,4.303,5.503,6.104,8.405c1.9,3.102,3.902,6.304,6.504,8.805l0.7,0.701c3.902,3.803,8.005,7.705,13.208,9.105
          c7.205,2.002,10.707-7.305,11.907-11.506c0.2-0.701,0.4-1.401,0.501-2.002c0.5-2.101,0.9-4.002,2.802-6.003
          c0.8-0.901,1.701-1.602,2.501-2.302c1.401-1.201,2.802-2.401,3.803-4.103c2.502-4.303,4.002-10.307,4.402-17.911
          c0.301-6.404,0-11.508-3.002-17.311c-2.001-4.003-2.901-8.405-3.802-12.608c-0.5-2.302-1.001-4.803-1.701-7.104
          c-1.801-5.903-2.901-10.906,0-16.811c2.502-5.003,4.803-9.306,7.705-13.208l-0.4-0.4c-1.201-1.301-2.201-2.302-4.903-2.602
          c-0.601-0.1-1.501,0-2.401,0.101c-1.601,0.199-3.202,0.3-4.303-0.2c-1.701-0.701-2.102-1.901-2.401-2.802
          c-0.2-0.601-0.301-0.901-0.7-1.201c-4.604-3.402-7.905,0.101-12.508,5.804c-1.401,1.801-2.702,3.402-4.103,4.603
          c-6.904,6.104-14.51,7.305-23.715,7.305c-3.902,0-13.409-2.001-14.31-5.703c-0.4-1.802,1.001-3.402,4.103-5.004
          c1.101-0.5,2.802-0.8,4.503-1c2.401-0.301,5.003-0.7,6.004-1.901c0.4-0.4,0.601-1.701,0.4-3.502
          c-0.3-2.401-1.201-4.604-2.302-5.403c-2.301-1.602-5.703,0.1-8.104,1.4c-0.501,0.301-1.001,0.501-1.501,0.7
          c-2.902,1.301-5.704,1.802-8.605,2.402c-1.301,0.2-2.702,0.5-4.203,0.8c-3.302,0.801-4.002,1.802-5.303,3.503
          c-0.601,0.8-1.201,1.7-2.201,2.701c-3.603,3.702-8.405,3.402-13.108,3.102h-0.801l-0.2-0.7c-2.102-2.201-2.102-7.904-2.001-13.809
          c0.1-3.902,0.1-7.904-0.601-9.906c-0.3-0.8-0.601-1.4-1-2.101c-0.601-1.201-1.301-2.402-1.401-4.003
          c-0.1-1.001,0.3-2.102,0.601-3.102c0.2-0.701,0.5-1.401,0.4-1.802c-0.4-2.802-2.102-3.802-4.303-5.003
          c-1.101-0.6-2.302-1.301-3.503-2.301l-1.301-1.101c-5.503-4.703-10.706-9.206-17.21-12.708c-0.801-0.4-1.701-0.901-2.602-1.401
          c-5.604-3.102-12.508-7.004-18.412-5.904l-0.1-0.3c-3.502,1.001-10.406,0-10.507,0c-3.002-0.4-4.503-1.901-6.204-3.702
          c-0.4-0.4-0.8-0.8-1.301-1.201c-4.703-4.403-7.604-3.302-12.407-1.601c-1.001,0.4-2.002,0.7-3.202,1.101
          c-5.504,1.701-10.707,4.303-15.71,6.804c-3.603,1.801-7.004,3.502-10.507,4.903l-0.6,0.2c-4.403,1.801-7.104,2.901-11.607,1
          c-5.604,5.704-12.708,8.605-19.612,11.507c-3.603,1.5-7.305,3.001-10.707,4.903c-1.301,0.801-2.401,1.001-3.102,1.201
          c-1.301,0.3-1.501,0.399-1.701,3.401c0,0.801,0.9,1.501,1.701,2.202c1,0.8,2.102,1.7,2.001,3.001
          c-0.4,4.103-6.504,5.304-11.507,6.404c-1.501,0.301-2.902,0.601-3.803,0.9c-2.302,0.801-5.104,1.301-7.905,1.802
          c-3.802,0.7-7.604,1.4-10.306,2.701c-3.103,1.602-3.803,2.702-3.902,3.303c-0.101,1.4,2.401,3.001,5.103,4.702l1.101,0.701
          c10.507,6.804,20.713,10.906,31.42,12.407c7.104,1.001,12.908,3.202,18.411,5.403c4.303,1.602,8.706,3.302,13.809,4.503l0.501,0.1
          l0.1,0.501c2.102,10.906-4.903,20.112-11.707,29.018c-3.502,4.604-6.904,9.006-8.806,13.408c-1.101,2.502-1.801,4.604-2.401,6.705
          c-1.401,4.702-2.702,8.805-8.405,13.308c-6.404,5.003-10.807,9.406-16.311,15.41c-0.3,0.3-0.5,0.6-0.8,0.8L179.417,543.155
          L179.417,543.155z"
      ></path>
      <text
        onClick={locateUser}
        borough="Ealing"
        transform="matrix(1 0 0 1 264.8262 484.7241)"
        fontSize="27.7821"
      >
        Ealing
      </text>
      <path
        fill="none"
        fillOpacity="1"
        fillRule="evenodd"
        stroke="#00000"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="6.2"
        d="M17.542 126.403l41.753 32.01 13.918-12.525 45.928 11.134 80.722-30.62 16.702-20.876 16.7 8.35 50.104-12.525 8.35-27.835 22.27-1.392 30.618-19.485 23.66-4.175 20.876-29.227 80.723-11.134 89.073 16.7 4.175 52.888 30.619 16.701 11.134 23.66 27.835 25.052 47.32 16.701 4.176-18.093 44.536-19.484h38.97l64.021-13.918 41.753 32.01-6.959 16.702 12.526 2.783 25.052 64.021 27.835-1.391 26.444 40.36-77.895 21.388-1.968 26.571-18.698-17.714-38.381 76.762 8.857 7.873-13.778 35.429-56.095 64.952 8.857 59.048-10.825 5.904-14.762 81.683-16.73.984-1.969 24.603-34.444 25.588 10.825 36.412-55.11 10.826-15.747-19.683-20.666 21.65-16.73-62-27.556-17.713-27.556 16.73-.984 9.841-41.333 11.81-.984 11.81-36.413 46.253-23.619-19.683-18.698-6.888-3.937-34.445-44.286-36.413-19.682 25.588-19.683-12.794 12.794-19.682-21.65-36.413-9.842 3.936v-31.492l-13.778 4.921-27.555 21.65L245.72 655.2l-23.62 17.714-6.634-6.727-3.207-34.606 18.699-40.35 8.857-8.857-10.826-22.634-8.857-.985-41.333-32.476-32.476-2.952-5.905-19.683h-12.794l-14.762-16.73-15.746 5.905-23.619-12.794-7.873-35.428L9.53 418.024l23.62-64.952-12.794-60.032 18.698-31.492-22.635-84.635 1.124-50.51z"
      ></path>
    </SC.SVG>
  );
}
